import { useState, useEffect, useCallback, useRef, useImperativeHandle } from "react";
import { ReactDiagram } from "gojs-react";
import { tubeColorSet } from "@/config/const";
import * as go from "gojs";
import LinkLabelOnPathDraggingTool from "./LinkLabelOnPathDraggingTool";
import {
  Modal,
  Button,
  message,
  Popconfirm,
  Table,
  Input,
  Select,
  Form,
  Tooltip,
  ColorPicker,
  Dropdown,
} from "antd";
import Dialog from "rc-dialog";
import Draggable from "react-draggable";
import "rc-dialog/assets/index.css";
import { loadOverview } from "./func";
// import './GuidedDraggingTool';
import {
  CheckCircleFilled,
  WarningFilled,
  LoadingOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
  WarningOutlined,
  CaretUpOutlined,
  CloseOutlined,
  ImportOutlined,
  PlayCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { useAppContext } from "@/AppContext";
import { rebuildFormula } from "@/config/func";
import { unitMap, materialsValueMap, typeMap3, dataTypeMap } from "@/constants/dataMap";
import ParameterEditor from "./ParameterEditor_new";
import { ImportIcon } from "@/Pages/Project/Flow/FlowDesign/TreeMenu/Icons";
import { flushSync } from "react-dom";
import Drawer from "@/Components/Drawer";
import { buildSelectedElementData } from "./func";
import { buildNodeDataByInput } from "@/Pages/Project/Flow/FlowDesign/func/buildNodeDataByInput";
import userInfo from "@/Components/user";
import { getSubJobs } from "@/services/common";

import dayjs from "dayjs";

const statusColor: any = {
  error: "#f10202",
  done: "#01894c",
  pedding: "#0066cc",
  uncovered: "#ffb833",
};

import element from "./newElements.json";
import boiler from "./elementsData/boiler.json";
import comments from "./elementsData/comments.json";
import container from "./elementsData/container.json";
import equipment from "./elementsData/equipment.json";
import heatExchanger from "./elementsData/heatExchanger.json";
import others from "./elementsData/others.json";
import products from "./elementsData/products.json";
import pump from "./elementsData/pump.json";
import reactor from "./elementsData/reactor.json";
import separator from "./elementsData/separator.json";
import tank from "./elementsData/tank.json";
import tower from "./elementsData/tower.json";
import Flash2 from "./elementsData/Flash2.json";
import MultiStreamExchanger from "./elementsData/MultiStreamExchanger.json";
import Mixer from "./elementsData/Mixer.json";
import { stringify } from "querystring";
// import test_Rectisol from "@/constants/test_Rectisol.json";
import test_Rectisol from "@/constants/defaultValue.json";

interface DataSource {
  nodeDataArray: any;
  linkDataArray: any;
}

interface ComponentProps {
  overview?: boolean; //是否显示概览图
  dataSource: DataSource; //流程图数据
  settings?: Settings; //其他设置
  diagrams: any;
  setDiagrams: any;
  globalData?: any;
  onScaleChange?: (scale: number) => void;
  diagramsRef: any;
  doubleClick: any;
  upTreeData: (newElement: any, newElementType: string, newNodeType: string) => void;
  setClearSelectVariable?: () => void;
  taskList?: any;
  selectedItem?: any;
  setSelectedNode: (newSelectedNode) => void;
  setSearchElementName: (newSearchElement) => void;
  setOpenImportPage: () => void;
  closeModalVariable: number;
  setMultipleNodes?: (newMultipleNodes) => void;
  changeLinkFlowValue: any;
  setTaskListGroups: (newGroups) => void;
  taskListSelectGroup: any;
  setRunPartTaskByDiagram?: (nodeData) => void;
  saveDiagram?: () => void;
  taskListVariable: any;
  taskListWidth: any;
  closeOtherDrawer: (drawerName) => void;
  setIsNowNeedOpenPramDrawer: (newIsNowNeedOpenPramDrawer) => void;

  setSubName?: (newSubName) => void;
  setCurResultInfo?: any;
  setResultDrawOpen?: any;
}

interface Settings {
  readonly?: boolean; //是否只读
}

const elementsDatas = {
  boiler: boiler,
  comments: comments,
  container: container,
  equipment: equipment,
  ShellAndTubeExchanger: heatExchanger,
  others: others,
  products: products,
  pump: pump,
  reactor: reactor,
  Splitter: separator,
  tank: tank,
  DistilStrict: tower,
  Flash2: Flash2,
  Mixer: Mixer,
  MultiStreamExchanger: MultiStreamExchanger,
};

export const getStreamsBasicParams = () => [
  {
    p_name: "类型",
    p_engName: "type",
    p_show: false,
    enum: [
      { label: "进料", value: "进料" },
      { label: "出料", value: "出料" },
      { label: "内部", value: "内部" },
    ],
  },
  {
    p_name: "物性计算方法",
    p_engName: "physical_method",
    p_show: true,
    enum: [
      { label: "NRTL", value: "NRTL" },
      { label: "SRK", value: "SRK" },
    ],
  },
  {
    p_name: "相态",
    p_engName: "phase",
    p_show: true,
    enum: [
      { label: "L-液相", value: "L" },
      { label: "V-汽相", value: "V" },
      { label: "VL-汽液两相", value: "VL" },
    ],
  },
  {
    p_name: "计算模式",
    p_engName: "mode",
    p_show: true,
    enum: [
      { label: "TP-温压闪蒸", value: "TP" },
      { label: "VP-汽化率压力闪蒸", value: "VP" },
      { label: "HP-压焓闪蒸", value: "HP" },
    ],
  },
  {
    p_name: "流股属性",
    p_engName: "streamAttribute",
    p_show: true,
    enum: [
      { label: "无", value: "无" },
      { label: "冷流股", value: "冷流股" },
      { label: "热流股", value: "热流股" },
    ],
  },
  {
    p_name: "流量",
    p_engName: "f",
    p_show: true,
    p_unitField: "",
    p_unit: ["kg/h", "kmol/h", "Nm3/h"],
    p_value: "16500.19495",
  },
  {
    p_name: "温度",
    p_engName: "t",
    p_show: true,
    p_unitField: "",
    p_unit: unitMap["T"],
    p_value: "120",
  },
  {
    p_name: "压力",
    p_engName: "p",
    p_show: true,
    p_unitField: "",
    p_unit: unitMap["P"],
    p_value: "50.49",
  },
  { p_name: "描述", p_engName: "description", p_show: false, p_value: "" },
];

// 辅助函数：根据节点数据构建 modal2Data (基础信息)
export const buildNodeModal2Data = (nodeData: any) => {
  return {
    元件名称: { value: nodeData.nodeName, engName: "nodeName", show: true },
    物性计算方法: {
      value: nodeData.physical_method !== undefined ? nodeData.physical_method : "NRTL",
      engName: "physical_method",
      show: true,
      enum: [
        { label: "NRTL", value: "NRTL" },
        { label: "SRK", value: "SRK" },
      ],
    },
    相态: {
      value: nodeData.phase !== undefined ? nodeData.phase : "L",
      engName: "phase",
      show: true,
      enum: [
        { label: "L-液相", value: "L" },
        { label: "V-汽相", value: "V" },
        { label: "VL-汽液两相", value: "VL" },
      ],
    },
    计算模式: {
      value: nodeData.mode !== undefined ? nodeData.mode : "TP",
      engName: "mode",
      show: true,
      enum: [
        { label: "TP-温压闪蒸", value: "TP" },
        { label: "VP-汽化率压力闪蒸", value: "VP" },
        { label: "HP-压焓闪蒸", value: "HP" },
      ],
    },
    描述: {
      value: nodeData.description !== undefined ? nodeData.description : "",
      engName: "description",
      show: false,
    },
  };
};

// 根据节点数据构建 modalParams (参数列表)
export const buildNodeModalParams = (nodeData: any) => {
  const type = nodeData.type;
  const name = nodeData.elementName;
  let params: any[] = [];

  if (element.filter((item: any) => item.typeID == type).length > 0) {
    params = element.filter((item: any) => item.typeID == type)[0].params;
  }
  if (elementsDatas[type] !== undefined) {
    if (elementsDatas[type].filter((item: any) => item.name == name).length > 0) {
      let extraParams = elementsDatas[type].filter((item: any) => item.name == name)[0].params;
      if (extraParams.length > 0) {
        params = params.concat(extraParams);
      }
    }
  }

  // 根据 p_type 找单位
  for (let i = 0; i < params.length; i++) {
    if (params[i].p_type) {
      if (unitMap[params[i].p_type]) {
        params[i].p_unit = unitMap[params[i].p_type];
      }
    }
  }

  // 排序，有子的放最下面
  params = [
    ...params.filter((item: any) => !item.hasOwnProperty("p_children")),
    ...params.filter((item: any) => item.hasOwnProperty("p_children")),
  ];
  return params;
};

// 根据流股数据构建 modal2Data
export const buildLinkModal2Data = (linkData: any) => {
  return {
    流股名称: { value: linkData.linkName, engName: "linkName", show: true },
    描述: {
      value: linkData.description !== undefined ? linkData.description : "",
      engName: "description",
      show: false,
    },
  };
};

// 根据流股数据和全局物质列表构建 materialsData
export const buildLinkMaterialsData = (linkData: any, globalMaterials: any[]) => {
  const newMaterialsData: any = {};
  for (let i = 0; i < globalMaterials.length; i++) {
    let name = globalMaterials[i].formula;
    newMaterialsData[name] = {
      molar_frac:
        linkData?.materials?.[name]?.molar_frac ??
        (linkData?.materials?.[name]?.molar_frac === 0 ? linkData.materials[name].molar_frac : ""),
      desValue:
        linkData?.materials?.[name]?.desValue ??
        (linkData?.materials?.[name]?.desValue === 0
          ? linkData.materials[name].desValue
          : (linkData?.materials?.[name]?.molar_frac ?? "")),
      cas: globalMaterials[i].cas_code,
      name: globalMaterials[i].formula,
      chineseName: globalMaterials[i].name,
    };
  }
  return newMaterialsData;
};

// 获取与节点相关的链接（入或出），用于 Ns/No 参数
export const getRelatedLinksFromData = (
  nodeKey: string,
  direction: "in" | "out",
  linkDataArray: any[],
) => {
  return linkDataArray.filter((link: any) => {
    if (direction === "in") return link.to === nodeKey;
    return link.from === nodeKey;
  });
};

export const getRelatedLinks2 = (
  nodeKey: string,
  direction: "cold" | "hot",
  linkDataArray: any[],
) => {
  let type = direction === "cold" ? "冷流股" : "热流股";
  return linkDataArray.filter((link) => {
    return link.from === nodeKey && link.ParamValues?.["流股属性"]?.value === type;
  });
};

// 初始化 localParamValues，类似于 Diagram 中 useEffect 里的逻辑
export const initializeLocalParamValues = (
  modalParams: any[],
  modal2Data: any,
  savedParamValues: any,
  nodeKey?: string,
  linkDataArray?: any[],
  selectNode?: string,
) => {
  const initialValues: any = {};
  modalParams.forEach((param: any) => {
    const paramName = param?.p_name;
    const saved = savedParamValues?.[paramName] || {};

    if (param.p_children && Array.isArray(param.p_children) && param.p_children.length > 0) {
      if (param.p_engName === "Ns" || param.p_engName === "No" || param.p_engName === "output_f") {
        if (nodeKey && linkDataArray) {
          const direction = param.p_engName === "Ns" ? "in" : "out";
          const links = getRelatedLinksFromData(nodeKey, direction, linkDataArray);
          const savedChildren = saved.p_children || [];
          const newChildren = links.map((link: any, index: number) => {
            const found = savedChildren.find(
              (item: any) => item?.["流股"]?.value === (link.text || link.linkName),
            );
            return {
              linkKey: link.key,
              streamName: link.text || link.linkName || "",
              hasSaved: !!found,
              isLast: index === links.length - 1,
              value:
                found?.[
                  param.p_engName === "Ns"
                    ? "进料位置"
                    : param.p_engName === "No"
                      ? "出料位置"
                      : "输出流量"
                ]?.value ??
                (found?.[
                  param.p_engName === "Ns"
                    ? "进料位置"
                    : param.p_engName === "No"
                      ? "出料位置"
                      : "输出流量"
                ]?.value === ""
                  ? ""
                  : null),
              desValue:
                found?.[
                  param.p_engName === "Ns"
                    ? "进料位置"
                    : param.p_engName === "No"
                      ? "出料位置"
                      : "输出流量"
                ]?.desValue ??
                (found?.[
                  param.p_engName === "Ns"
                    ? "进料位置"
                    : param.p_engName === "No"
                      ? "出料位置"
                      : "输出流量"
                ]?.desValue === ""
                  ? ""
                  : null),
            };
          });
          // 分流器“输出流量”：不强制哪个流股为空，编辑时允许存在多个空值，
          // 校验（有且仅有一个为空）仅在提交计算时进行
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: newChildren.map((child: any) => {
              const defaultVal =
                (selectNode &&
                  test_Rectisol.inputs.elements.find((item) => item.name === selectNode)?.params[
                    param.p_engName
                  ]?.[
                    test_Rectisol.inputs.elements
                      .find((item) => item.name === selectNode)
                      ?.[
                        param.p_engName === "Ns" ? "inputStreams" : "outputStreams"
                      ].findIndex((item) => item.name === (child.streamName ?? ""))
                  ]) ??
                param.p_children.find(
                  (item) =>
                    item.p_engName === "进料位置" ||
                    item.p_engName === "出料位置" ||
                    item.p_engName === "输出流量",
                ).p_value ??
                null;
              // 分流器“输出流量”：已保存的值原样保留（空值不再回填默认值）；未保存时最后一个输出流股留空
              const isOutputF = param.p_engName === "output_f";
              const outputFValue = child.hasSaved ? child.value : child.isLast ? "" : defaultVal;
              const outputFDesValue = child.hasSaved
                ? child.desValue
                : child.isLast
                  ? ""
                  : defaultVal;
              return {
                流股: {
                  value: child.streamName ?? "",
                  desValue: child.streamName ?? "",
                  show: true,
                  engName: "streamName",
                  readonly: true,
                },
                [param.p_engName === "Ns"
                  ? "进料位置"
                  : param.p_engName === "No"
                    ? "出料位置"
                    : "输出流量"]: {
                  value: isOutputF ? outputFValue : child.value !== null ? child.value : defaultVal,
                  desValue: isOutputF
                    ? outputFDesValue
                    : child.desValue !== null
                      ? child.desValue
                      : defaultVal,
                  show: true,
                  engName:
                    param.p_engName === "Ns"
                      ? "进料位置"
                      : param.p_engName === "No"
                        ? "出料位置"
                        : "输出流量",
                },
              };
            }),
          };
        } else {
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: [],
          };
        }
      } else if (param.p_engName === "cold_out_T" || param.p_engName === "hot_out_T") {
        if (nodeKey && linkDataArray) {
          const direction = param.p_engName === "cold_out_T" ? "cold" : "hot";
          const links = getRelatedLinks2(nodeKey, direction, linkDataArray);
          const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
          const newChildren = links.map((link) => {
            // 查找已保存的值
            return {
              linkKey: link.key,
              streamName: link.text || link.linkName || "",
              value: savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                "出口温度"
              ]?.value
                ? savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                    "出口温度"
                  ]?.value
                : savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                      "出口温度"
                    ]?.value === ""
                  ? ""
                  : null,
              desValue: savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                "出口温度"
              ]?.desValue
                ? savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                    "出口温度"
                  ]?.desValue
                : savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                      "出口温度"
                    ]?.desValue === ""
                  ? ""
                  : null,
              unit:
                savedChildren.find((item) => item?.["流股"]?.value === link.text)?.["出口温度"]
                  ?.unit ??
                unitMap[param.p_children.find((item) => item.p_engName === "出口温度")?.p_type][0],
            };
          });
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: newChildren.map((child) => ({
              流股: {
                value: child.streamName ?? "",
                desValue: child.streamName ?? "",
                show: true,
                engName: "streamName",
                readonly: true,
              },
              出口温度: {
                value: child.value
                  ? child.value
                  : child.value === ""
                    ? ""
                    : (param.p_children.find((i) => i.p_engName === "出口温度").p_value ?? null),
                desValue: child.desValue
                  ? child.desValue
                  : child.desValue === ""
                    ? ""
                    : (param.p_children.find((i) => i.p_engName === "出口温度").p_value ?? null),
                show: true,
                engName: "出口温度",
                unit: child.unit,
              },
            })),
          };
        } else {
          // 降级处理
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: [],
          };
        }
      } else if (param.p_engName === "cold_out_P" || param.p_engName === "hot_out_P") {
        if (nodeKey && linkDataArray) {
          const direction = param.p_engName === "cold_out_P" ? "cold" : "hot";
          const links = getRelatedLinks2(nodeKey, direction, linkDataArray);
          const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
          const newChildren = links.map((link) => {
            // 查找已保存的值
            return {
              linkKey: link.key,
              streamName: link.text || link.linkName || "",
              value: savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                "出口压力"
              ]?.value
                ? savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                    "出口压力"
                  ]?.value
                : savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                      "出口压力"
                    ]?.value === ""
                  ? ""
                  : null,
              desValue: savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                "出口压力"
              ]?.desValue
                ? savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                    "出口压力"
                  ]?.desValue
                : savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                      "出口压力"
                    ]?.desValue === ""
                  ? ""
                  : null,
              unit:
                savedChildren.find((item) => item?.["流股"]?.value === link.text)?.["出口压力"]
                  ?.unit ??
                unitMap[param.p_children.find((item) => item.p_engName === "出口压力")?.p_type][0],
            };
          });
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: newChildren.map((child) => ({
              流股: {
                value: child.streamName ?? "",
                desValue: child.streamName ?? "",
                show: true,
                engName: "streamName",
                readonly: true,
              },
              出口压力: {
                value: child.value
                  ? child.value
                  : child.value === ""
                    ? ""
                    : (param.p_children.find((i) => i.p_engName === "出口压力").p_value ?? null),
                desValue: child.desValue
                  ? child.desValue
                  : child.desValue === ""
                    ? ""
                    : (param.p_children.find((i) => i.p_engName === "出口压力").p_value ?? null),
                show: true,
                engName: "出口压力",
                unit: child.unit,
              },
            })),
          };
        } else {
          // 降级处理
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: [],
          };
        }
      } else if (param.p_engName === "stream_type") {
        let defaultChildren = [{}];
        for (let i = 0; i < param.p_children.length; i++) {
          let defaultChild = {
            value: param.p_children[i].p_value,
            desValue: param.p_children[i].p_value,
            show: param.p_children[i].p_show,
            engName: param.p_children[i].p_engName,
          };
          defaultChildren[0][param.p_children[i].p_name] = defaultChild;
        }

        initialValues[paramName] = {
          show:
            saved.show !== undefined
              ? saved.show
              : param.p_show !== undefined
                ? param.p_show
                : false,
          engName:
            saved.engName !== undefined
              ? saved.engName
              : param.p_engName !== undefined
                ? param.p_engName
                : null,
          p_children: saved.p_children
            ? saved.p_children.length === 1
              ? saved.p_children
              : defaultChildren
            : defaultChildren,
        };
      } else if (param.p_engName === "streamRelationship") {
        if (nodeKey && linkDataArray) {
          const direction = "out";
          const links = getRelatedLinksFromData(nodeKey, direction, linkDataArray);
          const savedChildren = saved.p_children || [];

          //构建入口流股枚举
          const inLinks = getRelatedLinksFromData(nodeKey, "in", linkDataArray);
          let inLinkNames = inLinks.map((obj) => obj.linkName);
          let inLinkEnums = [];
          for (let i = 0; i < inLinkNames.length; i++) {
            let inLinkEnum = {
              label: inLinkNames[i],
              value: inLinkNames[i],
            };
            inLinkEnums.push(inLinkEnum);
          }

          const newChildren = links.map((link: any) => {
            const found = savedChildren.find(
              (item: any) => item?.["出口流股"]?.value === (link.text || link.linkName),
            );
            return {
              linkKey: link.key,
              streamName: link.text || link.linkName || "",
              value: found?.["入口流股"]?.value ?? (found?.["入口流股"]?.value === "" ? "" : null),
              desValue:
                found?.["入口流股"]?.desValue ?? (found?.["入口流股"]?.desValue === "" ? "" : null),
            };
          });
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: newChildren.map((child: any) => ({
              出口流股: {
                value: child.streamName ?? "",
                desValue: child.streamName ?? "",
                show: true,
                engName: "出口流股",
                readonly: true,
              },
              入口流股: {
                // value: child.value !== null ? child.value : (param.p_value ?? null),
                value: child.value ?? null,
                desValue: child.desValue ?? null,
                show: true,
                engName: "入口流股",
                enum: inLinkEnums,
              },
            })),
          };
        } else {
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: [],
          };
        }
      } else {
        initialValues[paramName] = {
          show: saved.show !== undefined ? saved.show : (param.p_show ?? false),
          engName: saved.engName ?? param.p_engName ?? null,
          p_children: saved.p_children || [],
        };
      }
    } else if (param.enum && Array.isArray(param.enum) && param.enum.length > 0) {
      initialValues[paramName] = {
        value: saved.value != null && saved.value !== "" ? saved.value : param.enum[0]?.value,
        desValue: saved.value != null && saved.value !== "" ? saved.value : param.enum[0]?.value,
        show: saved.show !== undefined ? saved.show : (param.p_show ?? false),
        engName: saved.engName ?? param.p_engName ?? null,
      };
    } else if (param.p_unit && Array.isArray(param.p_unit) && param.p_unit.length > 0) {
      initialValues[paramName] = {
        // value: saved.value !== undefined ? saved.value : (param.p_value ?? null),
        value:
          saved.value !== undefined
            ? saved.value
            : ((selectNode &&
                test_Rectisol.inputs.elements.find((item) => item.name === selectNode)?.params[
                  param.p_engName
                ]) ??
              param.p_value ??
              null),
        desValue:
          saved.desValue !== undefined
            ? saved.desValue
            : ((selectNode &&
                test_Rectisol.inputs.elements.find((item) => item.name === selectNode)?.params[
                  param.p_engName
                ]) ??
              param.p_value ??
              null),
        unit: saved.unit != null && saved.unit !== "" ? saved.unit : param.p_unit[0],
        show: saved.show !== undefined ? saved.show : (param.p_show ?? false),
        engName: saved.engName ?? param.p_engName ?? null,
        unitField: saved.unitField ?? param.p_unitField ?? null,
      };
    } else {
      initialValues[paramName] = {
        // value: saved.value !== undefined ? saved.value : (param.p_value ?? null),
        value:
          saved.value !== undefined
            ? saved.value
            : ((selectNode &&
                test_Rectisol.inputs.elements.find((item) => item.name === selectNode)?.params[
                  param.p_engName
                ]) ??
              param.p_value ??
              null),
        desValue:
          saved.desValue !== undefined
            ? saved.desValue
            : ((selectNode &&
                test_Rectisol.inputs.elements.find((item) => item.name === selectNode)?.params[
                  param.p_engName
                ]) ??
              param.p_value ??
              null),
        show: saved.show !== undefined ? saved.show : false,
        engName: saved.engName ?? param.p_engName ?? null,
      };
    }
  });

  //特殊处理
  if (
    initialValues["流股属性"] &&
    initialValues["冷流股出口温度"] &&
    initialValues["热流股出口温度"]
  ) {
    if (initialValues["流股属性"].value === "冷流股") {
      initialValues["冷流股出口温度"].show = true;
      initialValues["热流股出口温度"].show = false;
    } else if (initialValues["流股属性"].value === "热流股") {
      initialValues["冷流股出口温度"].show = false;
      initialValues["热流股出口温度"].show = true;
    }
  }
  if (
    initialValues["流股属性"] &&
    initialValues["冷流股出口压力"] &&
    initialValues["热流股出口压力"]
  ) {
    if (initialValues["流股属性"].value === "冷流股") {
      initialValues["冷流股出口压力"].show = true;
      initialValues["热流股出口压力"].show = false;
    } else if (initialValues["流股属性"].value === "热流股") {
      initialValues["冷流股出口压力"].show = false;
      initialValues["热流股出口压力"].show = true;
    }
  }
  if (initialValues["流股属性"] && initialValues["冷流出口温度"] && initialValues["热流出口温度"]) {
    if (initialValues["流股属性"].value === "冷流股") {
      initialValues["冷流出口温度"].show = true;
      initialValues["热流出口温度"].show = false;
    } else if (initialValues["流股属性"].value === "热流股") {
      initialValues["冷流出口温度"].show = false;
      initialValues["热流出口温度"].show = true;
    }
  }
  if (initialValues["流股属性"] && initialValues["冷流出口压力"] && initialValues["热流出口压力"]) {
    if (initialValues["流股属性"].value === "冷流股") {
      initialValues["冷流出口压力"].show = true;
      initialValues["热流出口压力"].show = false;
    } else if (initialValues["流股属性"].value === "热流股") {
      initialValues["冷流出口压力"].show = false;
      initialValues["热流出口压力"].show = true;
    }
  }
  if (initialValues["内部类型"] && initialValues["塔盘类型"] && initialValues["填料类型"]) {
    if (initialValues["内部类型"].value === "塔板") {
      initialValues["塔盘类型"].show = true;
      // initialValues["塔板数"].show = true;
      initialValues["有效孔面积比"].show = true;
      initialValues["堰高"].show = true;
      initialValues["塔板材质"].show = true;
      initialValues["溢流类型"].show = true;

      initialValues["填料类型"].show = false;
      initialValues["填料高度"].show = false;
    } else if (initialValues["内部类型"].value === "填料") {
      initialValues["塔盘类型"].show = false;
      // initialValues["塔板数"].show = false;
      initialValues["有效孔面积比"].show = false;
      initialValues["堰高"].show = false;
      initialValues["塔板材质"].show = false;
      initialValues["溢流类型"].show = false;

      initialValues["填料类型"].show = true;
      initialValues["填料高度"].show = true;
    } else if (initialValues["内部类型"].value === "混合") {
      initialValues["塔盘类型"].show = true;
      // initialValues["塔板数"].show = true;
      initialValues["有效孔面积比"].show = true;
      initialValues["堰高"].show = true;
      initialValues["塔板材质"].show = true;
      initialValues["溢流类型"].show = true;

      initialValues["填料类型"].show = true;
      initialValues["填料高度"].show = true;
    }
  }
  if (modal2Data["计算模式"] && initialValues["温度"] && initialValues["汽相分率"]) {
    if (modal2Data["计算模式"].value === "TP") {
      initialValues["温度"].show = true;
      initialValues["汽相分率"].show = false;
    } else if (modal2Data["计算模式"].value === "VP" || modal2Data["计算模式"].value === "HP") {
      initialValues["温度"].show = false;
      initialValues["汽相分率"].show = true;
    }
  }

  return initialValues;
};

const Component = (props: ComponentProps) => {
  const {
    dataSource,
    settings = { readonly: false },
    setDiagrams,
    overview = true,
    globalData,
    onScaleChange,
    diagramsRef,
    doubleClick,
    upTreeData,
    setClearSelectVariable,
    taskList,
    selectedItem,
    setSelectedNode,
    setSearchElementName,
    setOpenImportPage,
    closeModalVariable,
    setMultipleNodes,
    changeLinkFlowValue,
    setTaskListGroups,
    taskListSelectGroup,
    setRunPartTaskByDiagram,
    saveDiagram,
    taskListVariable,
    taskListWidth,
    closeOtherDrawer,
    setIsNowNeedOpenPramDrawer,

    setSubName,
    setCurResultInfo,
    setResultDrawOpen,
  } = props;
  const $ = go.GraphObject.make;
  const [curTube, setCurTube] = useState<any>(null);
  const diagramInstance = useRef<go.Diagram | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalParams, setModalParams] = useState(null);
  const [modal2Visible, setModal2Visible] = useState(false);
  const [modal2Data, setModal2Data] = useState(null);
  const [materialsData, setMaterialsData] = useState(null);
  const [localFormData, setLocalFormData] = useState<Record<string, any>>({});
  const [localParamValues, setLocalParamValues] = useState<Record<string, any>>({});
  const [localMaterialsData, setLocalMaterialsData] = useState<Record<string, any>>({});
  const [pageHeight, setPageHeight] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerHeight - 85;
    }
    return 500;
  });
  const [selectElement, setSelectElement] = useState<string>("");
  const [messageApi, contextHolder] = message.useMessage();
  const overviewContainerRef = useRef(null);
  const overviewInstanceRef = useRef<any>(null);
  const { state, actions } = useAppContext();
  const [isLinkSelected, setIsLinkSelected] = useState(false);
  const [wrapOffset, setWrapOffset] = useState({ x: 0, y: 0 });
  const [designVisible, setDesignVisible] = useState(false);
  const [fastVisible, setFastVisible] = useState(false);
  const [saveAbled, setSaveAbled] = useState(false);
  const [readonlyNodeParamValues, setReadonlyNodeParamValues] = useState(null);
  const taskListRef = useRef(taskList);
  const selectedItemRef = useRef(selectedItem);
  const [dialogSelectButton, setDialogSelectButton] = useState(null);
  const [openNode, setOpenNode] = useState(null);
  const [groups, setGroups] = useState([]);
  const groupsRef = useRef([]);
  const [selectGroup, setSelectGroup] = useState(null);
  const selectGroupRef = useRef(null);
  const updatingLinksRef = useRef(false);
  const [elementPage, setElementPage] = useState(null);
  const [dragPos, setDragPos] = useState({ x: 0, y: 0 });
  const [selectedElementData, setSelectedElementData] = useState(null);
  const [streamsBasicParams, setStreamsBasicParams] = useState([
    {
      p_name: "类型",
      p_engName: "type",
      p_show: false,
      enum: [
        { label: "进料", value: "进料" },
        { label: "出料", value: "出料" },
        { label: "内部", value: "内部" },
      ],
    },
    {
      p_name: "物性计算方法",
      p_engName: "physical_method",
      p_show: true,
      enum: [
        { label: "NRTL", value: "NRTL" },
        { label: "SRK", value: "SRK" },
      ],
    },
    {
      p_name: "相态",
      p_engName: "phase",
      p_show: true,
      enum: [
        { label: "L-液相", value: "L" },
        { label: "V-汽相", value: "V" },
        { label: "VL-汽液两相", value: "VL" },
      ],
    },
    {
      p_name: "计算模式",
      p_engName: "mode",
      p_show: true,
      enum: [
        { label: "TP-温压闪蒸", value: "TP" },
        { label: "VP-汽化率压力闪蒸", value: "VP" },
        { label: "HP-压焓闪蒸", value: "HP" },
      ],
    },
    {
      p_name: "流股属性",
      p_engName: "streamAttribute",
      p_show: true,
      enum: [
        { label: "无", value: "无" },
        { label: "冷流股", value: "冷流股" },
        { label: "热流股", value: "热流股" },
      ],
    },
    {
      p_name: "流量",
      p_engName: "f",
      p_show: true,
      p_unitField: "",
      p_unit: ["kg/h", "kmol/h", "Nm3/h"],
      p_value: "16500.19495",
    },
    {
      p_name: "温度",
      p_engName: "t",
      p_show: true,
      p_unitField: "",
      p_type: "T",
      p_unit: unitMap["T"],
      p_value: "120",
    },
    {
      p_name: "压力",
      p_engName: "p",
      p_show: true,
      p_unitField: "",
      p_type: "P",
      p_unit: unitMap["P"],
      p_value: "50.49",
    },
    { p_name: "描述", p_engName: "description", p_show: false, p_value: "" },
  ]);

  //其他变量
  const [popupInfo, setPopupInfo] = useState<{
    visible: boolean;
    x: number;
    y: number;
    data?: [];
  }>({ visible: false, x: 0, y: 0, data: [] });
  const popupRef = useRef<HTMLDivElement>(null);
  const [popupStyle, setPopupStyle] = useState<React.CSSProperties>({});
  const [subJobs, setSubJobs] = useState<any>([]);

  const s16TotalOutput_f = 426.5; //S-16输出流量基准
  const t106V1 = 12903.7238; // T106塔釜采出量 基准

  useEffect(() => {
    const handleResize = () => {
      setPageHeight(window.innerHeight - 85);
    };

    window.addEventListener("resize", handleResize);

    // 清理函数，避免内存泄漏
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (settings) {
      let nodeName = null;
      //元件信息
      if (modalVisible && modal2Data && typeof modal2Data === "object") {
        // 深拷贝一份，避免直接引用原对象
        setLocalFormData(JSON.parse(JSON.stringify(modal2Data)));
        if (modal2Data["元件名称"]) {
          nodeName = modal2Data["元件名称"].value;
        }
      }

      //流股组分摩尔分率
      if (modalVisible && materialsData && typeof materialsData === "object") {
        // 深拷贝一份，避免直接引用原对象
        setLocalMaterialsData(JSON.parse(JSON.stringify(materialsData)));
      }

      //元件参数
      if (modalVisible && modalParams && Array.isArray(modalParams)) {
        // 获取当前选中图元已保存的参数值
        let savedValues = {};

        if (settings.readonly) {
          //只读模式取node
          savedValues = readonlyNodeParamValues;
        } else {
          if (diagramInstance.current) {
            const selectedPart = diagramInstance.current.selection.first();
            if (selectedPart && selectedPart.data && selectedPart.data.ParamValues) {
              savedValues = selectedPart.data.ParamValues;
            }
          }
        }

        const initialValues = {};
        modalParams.forEach((param) => {
          const paramName = param?.p_name;
          const saved = savedValues[paramName] || {}; // 取已保存的值，若无则为空对象

          if (param.p_children && Array.isArray(param.p_children) && param.p_children.length > 0) {
            // 带子项的参数：主项存储容器，子项数据放在 p_children 数组中
            // 特殊处理 Ns 和 No
            if (
              param.p_engName === "Ns" ||
              param.p_engName === "No" ||
              param.p_engName === "output_f"
            ) {
              const selectedNode = diagramInstance.current?.selection.first();
              const nodeKey = selectedNode?.data?.key;
              if (nodeKey) {
                const direction = param.p_engName === "Ns" ? "in" : "out";
                const links = getRelatedLinks(nodeKey, direction);
                const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
                const newChildren = links.map((link) => {
                  // 查找已保存的子项（按流股名匹配）
                  const found = savedChildren.filter(
                    (item) => item?.["流股"]?.value === (link.text || link.linkName || ""),
                  )?.[0];
                  const fieldKey =
                    param.p_engName === "Ns"
                      ? "进料位置"
                      : param.p_engName === "No"
                        ? "出料位置"
                        : "输出流量";
                  return {
                    linkKey: link.key,
                    streamName: link.text || link.linkName || "",
                    // 是否存在已保存子项：用于区分“已保存为空值”与“从未保存”
                    hasSaved: !!found,
                    value:
                      found?.[fieldKey]?.value ?? (found?.[fieldKey]?.value === "" ? "" : null),
                    desValue:
                      found?.[fieldKey]?.desValue ??
                      (found?.[fieldKey]?.desValue === "" ? "" : null),
                  };
                });
                initialValues[paramName] = {
                  show: param.p_show,
                  engName: param.p_engName,
                  p_children: newChildren.map((child, index) => {
                    // 分流器“输出流量”：未保存过时默认最后一个输出流股留空（用户可自行改成其它流股为空）
                    const isEmptyLast =
                      param.p_engName === "output_f" && index === newChildren.length - 1;
                    const defaultValue =
                      (nodeName &&
                        test_Rectisol.inputs.elements.find((item) => item.name === nodeName)
                          ?.params[param.p_engName]?.[
                          test_Rectisol.inputs.elements
                            .find((item) => item.name === nodeName)
                            ?.[
                              param.p_engName === "Ns" ? "inputStreams" : "outputStreams"
                            ].findIndex((item) => item.name === (child.streamName ?? ""))
                        ]) ??
                      param.p_children.find(
                        (item) =>
                          item.p_engName === "进料位置" ||
                          item.p_engName === "出料位置" ||
                          item.p_engName === "输出流量",
                      ).p_value ??
                      null;
                    // 已保存的子项原样保留（含空值，空值存为 null 或 ""）；未保存时才按默认值/留空生成
                    const childValue =
                      param.p_engName === "output_f"
                        ? child.hasSaved
                          ? (child.value ?? "")
                          : isEmptyLast
                            ? ""
                            : defaultValue
                        : child.value
                          ? child.value
                          : child.value === ""
                            ? ""
                            : defaultValue;
                    const childDesValue =
                      param.p_engName === "output_f"
                        ? child.hasSaved
                          ? (child.desValue ?? "")
                          : isEmptyLast
                            ? ""
                            : defaultValue
                        : child.desValue
                          ? child.desValue
                          : child.desValue === ""
                            ? ""
                            : defaultValue;
                    return {
                      流股: {
                        value: child.streamName ?? "",
                        desValue: child.streamName ?? "",
                        show: true,
                        engName: "streamName",
                        readonly: true,
                      },
                      [param.p_engName === "Ns"
                        ? "进料位置"
                        : param.p_engName === "No"
                          ? "出料位置"
                          : "输出流量"]: {
                        value: childValue,
                        desValue: childDesValue,
                        show: true,
                        engName:
                          param.p_engName === "Ns"
                            ? "进料位置"
                            : param.p_engName === "No"
                              ? "出料位置"
                              : "输出流量",
                      },
                    };
                  }),
                };
              } else {
                // 降级处理
                initialValues[paramName] = {
                  show: param.p_show,
                  engName: param.p_engName,
                  p_children: [],
                };
              }
            } else if (param.p_engName === "cold_out_T" || param.p_engName === "hot_out_T") {
              const selectedNode = diagramInstance.current?.selection.first();
              const nodeKey = selectedNode?.data?.key;
              if (nodeKey) {
                const direction = param.p_engName === "cold_out_T" ? "cold" : "hot";
                const links = getRelatedLinks2(nodeKey, direction);
                const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
                const newChildren = links.map((link) => {
                  // 查找已保存的值
                  return {
                    linkKey: link.key,
                    streamName: link.text || link.linkName || "",
                    value: savedChildren.filter(
                      (item) => item?.["流股"]?.value === link.text,
                    )?.[0]?.["出口温度"]?.value
                      ? savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                          "出口温度"
                        ]?.value
                      : savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                            "出口温度"
                          ]?.value === ""
                        ? ""
                        : null,
                    desValue: savedChildren.filter(
                      (item) => item?.["流股"]?.value === link.text,
                    )?.[0]?.["出口温度"]?.desValue
                      ? savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                          "出口温度"
                        ]?.desValue
                      : savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                            "出口温度"
                          ]?.desValue === ""
                        ? ""
                        : null,
                    unit:
                      savedChildren.find((item) => item?.["流股"]?.value === link.text)?.[
                        "出口温度"
                      ]?.unit ??
                      unitMap[
                        param.p_children.find((item) => item.p_engName === "出口温度")?.p_type
                      ][0],
                  };
                });
                initialValues[paramName] = {
                  show: param.p_show,
                  engName: param.p_engName,
                  p_children: newChildren.map((child) => ({
                    流股: {
                      value: child.streamName ?? "",
                      desValue: child.streamName ?? "",
                      show: true,
                      engName: "streamName",
                      readonly: true,
                    },
                    出口温度: {
                      value: child.value
                        ? child.value
                        : child.value === ""
                          ? ""
                          : (param.p_children.find((i) => i.p_engName === "出口温度").p_value ??
                            null),
                      desValue: child.desValue
                        ? child.desValue
                        : child.desValue === ""
                          ? ""
                          : (param.p_children.find((i) => i.p_engName === "出口温度").p_value ??
                            null),
                      show: true,
                      engName: "出口温度",
                      unit: child.unit,
                    },
                  })),
                };
              } else {
                // 降级处理
                initialValues[paramName] = {
                  show: param.p_show,
                  engName: param.p_engName,
                  p_children: [],
                };
              }
            } else if (param.p_engName === "cold_out_P" || param.p_engName === "hot_out_P") {
              const selectedNode = diagramInstance.current?.selection.first();
              const nodeKey = selectedNode?.data?.key;
              if (nodeKey) {
                const direction = param.p_engName === "cold_out_P" ? "cold" : "hot";
                const links = getRelatedLinks2(nodeKey, direction);
                const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
                const newChildren = links.map((link) => {
                  // 查找已保存的值
                  return {
                    linkKey: link.key,
                    streamName: link.text || link.linkName || "",
                    value: savedChildren.filter(
                      (item) => item?.["流股"]?.value === link.text,
                    )?.[0]?.["出口压力"]?.value
                      ? savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                          "出口压力"
                        ]?.value
                      : savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                            "出口压力"
                          ]?.value === ""
                        ? ""
                        : null,
                    desValue: savedChildren.filter(
                      (item) => item?.["流股"]?.value === link.text,
                    )?.[0]?.["出口压力"]?.desValue
                      ? savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                          "出口压力"
                        ]?.desValue
                      : savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[
                            "出口压力"
                          ]?.desValue === ""
                        ? ""
                        : null,
                    unit:
                      savedChildren.find((item) => item?.["流股"]?.value === link.text)?.[
                        "出口压力"
                      ]?.unit ??
                      unitMap[
                        param.p_children.find((item) => item.p_engName === "出口压力")?.p_type
                      ][0],
                  };
                });
                initialValues[paramName] = {
                  show: param.p_show,
                  engName: param.p_engName,
                  p_children: newChildren.map((child) => ({
                    流股: {
                      value: child.streamName ?? "",
                      desValue: child.streamName ?? "",
                      show: true,
                      engName: "streamName",
                      readonly: true,
                    },
                    出口压力: {
                      value: child.value
                        ? child.value
                        : child.value === ""
                          ? ""
                          : (param.p_children.find((i) => i.p_engName === "出口压力").p_value ??
                            null),
                      desValue: child.desValue
                        ? child.desValue
                        : child.desValue === ""
                          ? ""
                          : (param.p_children.find((i) => i.p_engName === "出口压力").p_value ??
                            null),
                      show: true,
                      engName: "出口压力",
                      unit: child.unit,
                    },
                  })),
                };
              } else {
                // 降级处理
                initialValues[paramName] = {
                  show: param.p_show,
                  engName: param.p_engName,
                  p_children: [],
                };
              }
            } else if (param.p_engName === "stream_type") {
              let defaultChildren = [{}];
              for (let i = 0; i < param.p_children.length; i++) {
                let defaultChild = {
                  value: param.p_children[i].p_value,
                  desValue: param.p_children[i].p_value,
                  show: param.p_children[i].p_show,
                  engName: param.p_children[i].p_engName,
                };
                defaultChildren[0][param.p_children[i].p_name] = defaultChild;
              }

              initialValues[paramName] = {
                show:
                  saved.show !== undefined
                    ? saved.show
                    : param.p_show !== undefined
                      ? param.p_show
                      : false,
                engName:
                  saved.engName !== undefined
                    ? saved.engName
                    : param.p_engName !== undefined
                      ? param.p_engName
                      : null,
                p_children: saved.p_children
                  ? saved.p_children.length === 1
                    ? saved.p_children
                    : defaultChildren
                  : defaultChildren,
              };
            } else if (param.p_engName === "streamRelationship") {
              const selectedNode = diagramInstance.current?.selection.first();
              const nodeKey = selectedNode?.data?.key;
              if (nodeKey) {
                const direction = "out";
                const links = getRelatedLinks(nodeKey, direction);
                const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）

                //构建入口流股枚举
                const inLinks = getRelatedLinks(nodeKey, "in");
                let inLinkNames = inLinks.map((obj) => obj.linkName);
                let inLinkEnums = [];
                for (let i = 0; i < inLinkNames.length; i++) {
                  let inLinkEnum = {
                    label: inLinkNames[i],
                    value: inLinkNames[i],
                  };
                  inLinkEnums.push(inLinkEnum);
                }

                const newChildren = links.map((link) => {
                  // 查找已保存的值
                  return {
                    linkKey: link.key,
                    streamName: link.text || link.linkName || "",
                    value: savedChildren.filter(
                      (item) => item?.["出口流股"]?.value === link.text,
                    )?.[0]?.["入口流股"]?.value
                      ? savedChildren.filter(
                          (item) => item?.["出口流股"]?.value === link.text,
                        )?.[0]?.["入口流股"]?.value
                      : savedChildren.filter(
                            (item) => item?.["出口流股"]?.value === link.text,
                          )?.[0]?.["入口流股"]?.value === ""
                        ? ""
                        : null,
                    desValue: savedChildren.filter(
                      (item) => item?.["出口流股"]?.value === link.text,
                    )?.[0]?.["入口流股"]?.desValue
                      ? savedChildren.filter(
                          (item) => item?.["出口流股"]?.value === link.text,
                        )?.[0]?.["入口流股"]?.desValue
                      : savedChildren.filter(
                            (item) => item?.["出口流股"]?.value === link.text,
                          )?.[0]?.["入口流股"]?.desValue === ""
                        ? ""
                        : null,
                  };
                });
                initialValues[paramName] = {
                  show: param.p_show,
                  engName: param.p_engName,
                  p_children: newChildren.map((child) => ({
                    出口流股: {
                      value: child.streamName ?? "",
                      desValue: child.streamName ?? "",
                      show: true,
                      engName: "出口流股",
                      readonly: true,
                    },
                    入口流股: {
                      //value: child.value?child.value:(child.value==="" ?"":(param.p_value??null)),
                      value: child.value ?? null,
                      desValue: child.desValue ?? null,
                      show: true,
                      engName: "入口流股",
                      enum: inLinkEnums,
                    },
                  })),
                };
              } else {
                // 降级处理
                initialValues[paramName] = {
                  show: param.p_show,
                  engName: param.p_engName,
                  p_children: [],
                };
              }
            } else {
              initialValues[paramName] = {
                show:
                  saved.show !== undefined
                    ? saved.show
                    : param.p_show !== undefined
                      ? param.p_show
                      : false,
                engName:
                  saved.engName !== undefined
                    ? saved.engName
                    : param.p_engName !== undefined
                      ? param.p_engName
                      : null,
                p_children: saved.p_children || [], // 数组，每个元素是子项的数据对象
              };
            }
          } else if (param.enum && Array.isArray(param.enum) && param.enum.length > 0) {
            // 有枚举字段：选择器，初始值优先取已保存的 value，否则取第一个选项
            let enumNumber = 0; //默认第一个选项

            //特殊处理
            if (param.p_name === "相态" && openNode) {
              let diagram = diagramInstance.current;
              const allNodes = diagram.model["nodeDataArray"].filter((item) => !item.isGroup);
              let fromkey = openNode.from;
              let fromPort = openNode.fromPort;
              if (fromPort[0] && fromkey) {
                let node = allNodes.find((item) => item.key === fromkey);
                if (node) {
                  if (node.type === "DistilStrict") //塔
                  {
                    if (fromPort[0] === "B") {
                      //塔底，液相
                      enumNumber = 0;
                    } else if (fromPort[0] === "T") {
                      //塔顶，气相
                      enumNumber = 1;
                    }
                  }
                }
              }
            }

            initialValues[paramName] = {
              value:
                saved.value !== undefined && saved.value !== null && saved.value !== ""
                  ? saved.value
                  : param.enum[enumNumber]?.value,
              desValue:
                saved.value !== undefined && saved.value !== null && saved.value !== ""
                  ? saved.value
                  : param.enum[enumNumber]?.value,
              show:
                saved.show !== undefined
                  ? saved.show
                  : param.p_show !== undefined
                    ? param.p_show
                    : false,
              engName:
                saved.engName !== undefined
                  ? saved.engName
                  : param.p_engName !== undefined
                    ? param.p_engName
                    : null,
            };
          } else if (param.p_unit && Array.isArray(param.p_unit) && param.p_unit.length > 0) {
            // 有单位字段：输入框 + 单位选择器，初始值优先取已保存的 value/unit，否则取默认
            initialValues[paramName] = {
              // value: saved.value !== undefined ? saved.value : (param.p_value??null),
              value:
                saved.value !== undefined
                  ? saved.value
                  : ((nodeName &&
                      test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                        param.p_engName
                      ]) ??
                    param.p_value ??
                    null),
              desValue:
                saved.desValue !== undefined
                  ? saved.desValue
                  : ((nodeName &&
                      test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                        param.p_engName
                      ]) ??
                    param.p_value ??
                    null),
              unit:
                saved.unit !== undefined && saved.unit !== null && saved.unit !== ""
                  ? saved.unit
                  : param.p_unit[0],
              show:
                saved.show !== undefined
                  ? saved.show
                  : param.p_show !== undefined
                    ? param.p_show
                    : false,
              engName:
                saved.engName !== undefined
                  ? saved.engName
                  : param.p_engName !== undefined
                    ? param.p_engName
                    : null,
              unitField:
                saved.unitField !== undefined
                  ? saved.unitField
                  : param.p_unitField !== undefined
                    ? param.p_unitField
                    : null,
            };
          } else {
            // 仅输入框
            initialValues[paramName] = {
              // value: saved.value !== undefined ? saved.value : (param.p_value??null),
              value:
                saved.value !== undefined
                  ? saved.value
                  : ((nodeName &&
                      test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                        param.p_engName
                      ]) ??
                    param.p_value ??
                    null),
              desValue:
                saved.desValue !== undefined
                  ? saved.desValue
                  : ((nodeName &&
                      test_Rectisol.inputs.elements.find((item) => item.name === nodeName)?.params[
                        param.p_engName
                      ]) ??
                    param.p_value ??
                    null),
              show: saved.show !== undefined ? saved.show : false,
              engName:
                saved.engName !== undefined
                  ? saved.engName
                  : param.p_engName !== undefined
                    ? param.p_engName
                    : null,
            };
          }
        });

        //特殊处理
        if (
          initialValues["流股属性"] &&
          initialValues["冷流股出口温度"] &&
          initialValues["热流股出口温度"]
        ) {
          if (initialValues["流股属性"].value === "冷流股") {
            initialValues["冷流股出口温度"].show = true;
            initialValues["热流股出口温度"].show = false;
          } else if (initialValues["流股属性"].value === "热流股") {
            initialValues["冷流股出口温度"].show = false;
            initialValues["热流股出口温度"].show = true;
          }
        }
        if (
          initialValues["流股属性"] &&
          initialValues["冷流股出口压力"] &&
          initialValues["热流股出口压力"]
        ) {
          if (initialValues["流股属性"].value === "冷流股") {
            initialValues["冷流股出口压力"].show = true;
            initialValues["热流股出口压力"].show = false;
          } else if (initialValues["流股属性"].value === "热流股") {
            initialValues["冷流股出口压力"].show = false;
            initialValues["热流股出口压力"].show = true;
          }
        }
        if (
          initialValues["流股属性"] &&
          initialValues["冷流出口温度"] &&
          initialValues["热流出口温度"]
        ) {
          if (initialValues["流股属性"].value === "冷流股") {
            initialValues["冷流出口温度"].show = true;
            initialValues["热流出口温度"].show = false;
          } else if (initialValues["流股属性"].value === "热流股") {
            initialValues["冷流出口温度"].show = false;
            initialValues["热流出口温度"].show = true;
          }
        }
        if (
          initialValues["流股属性"] &&
          initialValues["冷流出口压力"] &&
          initialValues["热流出口压力"]
        ) {
          if (initialValues["流股属性"].value === "冷流股") {
            initialValues["冷流出口压力"].show = true;
            initialValues["热流出口压力"].show = false;
          } else if (initialValues["流股属性"].value === "热流股") {
            initialValues["冷流出口压力"].show = false;
            initialValues["热流出口压力"].show = true;
          }
        }
        if (initialValues["内部类型"] && initialValues["塔盘类型"] && initialValues["填料类型"]) {
          if (initialValues["内部类型"].value === "塔板") {
            initialValues["塔盘类型"].show = true;
            // initialValues["塔板数"].show = true;
            initialValues["有效孔面积比"].show = true;
            initialValues["堰高"].show = true;
            initialValues["塔板材质"].show = true;
            initialValues["溢流类型"].show = true;

            initialValues["填料类型"].show = false;
            initialValues["填料高度"].show = false;
          } else if (initialValues["内部类型"].value === "填料") {
            initialValues["塔盘类型"].show = false;
            // initialValues["塔板数"].show = false;
            initialValues["有效孔面积比"].show = false;
            initialValues["堰高"].show = false;
            initialValues["塔板材质"].show = false;
            initialValues["溢流类型"].show = false;

            initialValues["填料类型"].show = true;
            initialValues["填料高度"].show = true;
          } else if (initialValues["内部类型"].value === "混合") {
            initialValues["塔盘类型"].show = true;
            // initialValues["塔板数"].show = true;
            initialValues["有效孔面积比"].show = true;
            initialValues["堰高"].show = true;
            initialValues["塔板材质"].show = true;
            initialValues["溢流类型"].show = true;

            initialValues["填料类型"].show = true;
            initialValues["填料高度"].show = true;
          }
        }
        if (modal2Data?.["计算模式"] && initialValues["温度"] && initialValues["汽相分率"]) {
          if (modal2Data["计算模式"].value === "TP") {
            initialValues["温度"].show = true;
            initialValues["汽相分率"].show = false;
          } else if (
            modal2Data["计算模式"].value === "VP" ||
            modal2Data["计算模式"].value === "HP"
          ) {
            initialValues["温度"].show = false;
            initialValues["汽相分率"].show = true;
          }
        }

        setLocalParamValues(initialValues);
        // console.log("initialValues:",initialValues);
      }
    }
  }, [modalVisible, modalParams, modal2Data, materialsData]);

  useEffect(() => {
    taskListRef.current = taskList;

    const diagram = diagramInstance.current;

    //更新元件icon颜色
    if (taskListRef.current) {
      let jobId = selectedItemRef.current.job_id;
      let taskData = taskListRef.current.find((item) => item.job_id === jobId);

      if (taskData) {
        if (taskData.elements.length > 0) {
          let taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
          taskNodes = taskNodes.map((obj) => obj["data"]);
          const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
          allNodes.forEach((selectNode: any) => {
            let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
            if (taskSelectNode) {
              let newIcon = selectNode.icon;
              if (newIcon.includes("high")) {
                newIcon = newIcon.replace("high", "origin");
              }
              if (newIcon.includes("origin") && taskSelectNode.isRun) {
                newIcon = newIcon.replace("origin", "green");
              }
              changeNodeIcon(selectNode, newIcon);
            }
          });
        }
      }
    }

    //如果此时弹窗打开了触发打开弹窗（赋新数值）
    if (modalVisible) {
      if (settings.readonly) //只读状态打开任务数据，所以调用模拟双击接口
      {
        // const diagram = diagramInstance.current;
        let node = selectedItem.data;
        if (node) {
          if (taskListRef.current) {
            let jobId = selectedItemRef.current.job_id;
            let taskData = taskListRef.current.find((item) => item.job_id === jobId);

            if (taskData) {
              if (node.nodeName !== undefined) {
                if (taskData.elements.length > 0) {
                  let nodeType = node.type;
                  let nodeDatas = taskData.elements.find(
                    (item) => item.engName === nodeType,
                  ).children;
                  let nodeData = nodeDatas.find((item) => item.name === node.nodeName);
                  doubleClickEvent(nodeData.data, diagram);
                }
              } else if (node.linkName !== undefined) {
                if (taskData.streams.length > 0) {
                  let linkData = taskData.streams.find((item) => item.name === node.linkName);
                  doubleClickEvent(linkData.data, diagram);
                }
              }
            } else {
              if (selectedItemRef.current.job_name) {
                messageApi.open({
                  type: "error",
                  content: `计算任务 ${selectedItemRef.current.job_name} 数据异常`,
                });
              } else {
                messageApi.open({
                  type: "error",
                  content: "请选择要查看的计算任务",
                });
              }
            }
          } else {
            messageApi.open({
              type: "error",
              content: "请选择要查看的计算任务",
            });
          }
        } else {
          //关闭弹窗
          setModalVisible(false);
          setIsNowNeedOpenPramDrawer(false);
          setDialogSelectButton(null);
          setModalParams(null);
          setModal2Data(null);
          setMaterialsData(null);
          setLocalParamValues({});
          setLocalFormData({});
          setLocalMaterialsData({});
          setClearSelectVariable();
          setElementPage(null);

          //因为树没有取消选中状态，所以点取消按钮也不清除高亮
          //依然保留取消高亮吧
          if (diagram) {
            const allLinks = diagram.model["linkDataArray"];
            allLinks.forEach((link: any) => {
              changeLinkBackground(link, "transparent");
            });

            let taskNodes = null;
            if (taskListRef.current) {
              let jobId = selectedItemRef.current.job_id;
              let taskData = taskListRef.current.find((item) => item.job_id === jobId);
              if (taskData) {
                if (taskData.elements.length > 0) {
                  taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
                  taskNodes = taskNodes.map((obj) => obj["data"]);
                }
              }
            }

            const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
            allNodes.forEach((selectNode: any) => {
              let newIcon = selectNode.icon;
              if (newIcon.includes("high")) {
                newIcon = newIcon.replace("high", "origin");
              }

              if (taskNodes) {
                let taskSelectNode = taskNodes.find(
                  (item) => item.nodeName === selectNode.nodeName,
                );
                if (taskSelectNode) {
                  if (newIcon.includes("origin") && taskSelectNode.isRun) {
                    newIcon = newIcon.replace("origin", "green");
                  }
                }
              }

              changeNodeIcon(selectNode, newIcon);
            });
          }
        }
      }
    }
  }, [taskList]);

  useEffect(() => {
    if (closeModalVariable > 0) {
      //关闭弹窗
      setModalVisible(false);
      setIsNowNeedOpenPramDrawer(false);
      setDialogSelectButton(null);
      setModalParams(null);
      setModal2Data(null);
      setMaterialsData(null);
      setLocalParamValues({});
      setLocalFormData({});
      setLocalMaterialsData({});
      setClearSelectVariable();
      setElementPage(null);

      //因为树没有取消选中状态，所以点取消按钮也不清除高亮
      //依然保留取消高亮吧
      const diagram = diagramInstance.current;
      if (diagram) {
        const allLinks = diagram.model["linkDataArray"];
        allLinks.forEach((link: any) => {
          changeLinkBackground(link, "transparent");
        });

        let taskNodes = null;
        if (taskListRef.current) {
          let jobId = selectedItemRef.current.job_id;
          let taskData = taskListRef.current.find((item) => item.job_id === jobId);
          if (taskData) {
            if (taskData.elements.length > 0) {
              taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
              taskNodes = taskNodes.map((obj) => obj["data"]);
            }
          }
        }

        const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
        allNodes.forEach((selectNode: any) => {
          let newIcon = selectNode.icon;
          if (newIcon.includes("high")) {
            newIcon = newIcon.replace("high", "origin");
          }

          if (taskNodes) {
            let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
            if (taskSelectNode) {
              if (newIcon.includes("origin") && taskSelectNode.isRun) {
                newIcon = newIcon.replace("origin", "green");
              }
            }
          }

          changeNodeIcon(selectNode, newIcon);
        });
      }
    }
  }, [closeModalVariable]);

  useEffect(() => {
    selectedItemRef.current = selectedItem;

    //切换任务时触发元件icon判定
    if (selectedItemRef.current.type === "job") {
      let taskNodes = null;
      if (taskListRef.current) {
        let jobId = selectedItemRef.current.job_id;
        let taskData = taskListRef.current.find((item) => item.job_id === jobId);
        if (taskData) {
          if (taskData.elements.length > 0) {
            taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
            taskNodes = taskNodes.map((obj) => obj["data"]);
          }
        }
      }

      const diagram = diagramInstance.current;
      const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
      allNodes.forEach((selectNode: any) => {
        let newIcon = selectNode.icon;
        if (newIcon.includes("green")) {
          newIcon = newIcon.replace("green", "origin");
        }

        if (taskNodes) {
          let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
          if (taskSelectNode) {
            if (newIcon.includes("origin") && taskSelectNode.isRun) {
              newIcon = newIcon.replace("origin", "green");
            }
          }
        }

        changeNodeIcon(selectNode, newIcon);
      });
    }
  }, [selectedItem]);

  //只读模式（流程存在计算任务）下，流股颜色以所选计算任务保存的「流股属性」为准
  //（该模式下参数保存到计算任务里，流程图数据不更新，刷新后颜色会回退，故在此按任务属性推导）
  useEffect(() => {
    if (!settings.readonly) return;
    const diagram = diagramInstance.current;
    if (!diagram || !taskList) return;

    const jobId = selectedItemRef.current?.job_id;
    const taskData = taskList.find((item) => item.job_id === jobId);
    if (!taskData || !taskData.streams || taskData.streams.length === 0) return;

    const attrColorMap: any = { 冷流股: "#0000FF", 热流股: "#FF0000", 无: "#000" };
    const model: any = diagram.model;
    taskData.streams.forEach((stream: any) => {
      const attr = stream?.data?.ParamValues?.["流股属性"]?.value;
      const color = attrColorMap[attr];
      if (!color) return;
      const link = model.linkDataArray.find((item: any) => item.key === stream?.data?.key);
      if (link && link.lineColor !== color) {
        model.setDataProperty(link, "lineColor", color);
      }
    });
  }, [taskList, settings.readonly, selectedItem]);

  useEffect(() => {
    //更改流股流动动画
    upLinkFlow();
  }, [diagramInstance.current]);

  //参与计算的元件（组合计算选中的元件）对应节点 key：轮询只回传流股名，靠这里让这些元件相邻的流股持续流动
  const flowElementKeysRef = useRef<string[]>([]);

  useEffect(() => {
    if (changeLinkFlowValue) {
      const diagram = diagramInstance.current;
      if (diagram) {
        const linkDatas = diagram.model["linkDataArray"];

        //组合计算：按所选元件在画布上换算成节点 key（后续轮询更新不带元件时继续沿用，计算结束再清空）
        if (changeLinkFlowValue.elementNames?.length > 0) {
          flowElementKeysRef.current = diagram.model["nodeDataArray"]
            .filter(
              (item) => !item.isGroup && changeLinkFlowValue.elementNames.includes(item.nodeName),
            )
            .map((item) => item.key);
        }
        if (!changeLinkFlowValue.flowEnabled) {
          flowElementKeysRef.current = [];
        }
        const flowElementKeys = flowElementKeysRef.current;

        //1.全部取消流动效果
        for (let i = 0; i < linkDatas.length; i++) {
          let linkData = linkDatas[i];
          changeLinkFlow(linkData, false);
        }

        //2.赋予新的流动效果
        if (changeLinkFlowValue.flowEnabled) {
          //2.1 参与计算的元件相邻的流股：按 key 匹配，避免重名/改名/无名流股漏掉
          if (flowElementKeys.length > 0) {
            for (let i = 0; i < linkDatas.length; i++) {
              let linkData = linkDatas[i];
              if (
                flowElementKeys.includes(linkData.from) ||
                flowElementKeys.includes(linkData.to)
              ) {
                changeLinkFlow(linkData, true);
              }
            }
          }

          //2.2 按流股名匹配（同名流股全部生效）
          const linkNames = changeLinkFlowValue.linkNames || [];
          for (let i = 0; i < linkNames.length; i++) {
            const matchedLinks = linkDatas.filter((item) => item.linkName === linkNames[i]);
            for (let j = 0; j < matchedLinks.length; j++) {
              changeLinkFlow(matchedLinks[j], true);
            }
          }
        }
      }
    }
  }, [changeLinkFlowValue]);

  useEffect(() => {
    if (modalVisible) {
      setDragPos({ x: 0, y: 0 });
    }
  }, [modalVisible]);

  const handleDrag = (e, data) => {
    const el = document.querySelector(".custom-dialog");
    if (!el) {
      flushSync(() => setDragPos({ x: data.x, y: data.y }));
      return;
    }
    const rect = el.getBoundingClientRect();
    const viewW = window.innerWidth;
    const viewH = window.innerHeight;

    // 弹窗初始位置距离右下角 20px，偏移 (0,0) 表示该位置
    const maxRight = 20;
    const maxLeft = rect.width - viewW + 20;
    const maxBottom = 20;
    const maxTop = rect.height - viewH + 20;

    const newX = Math.min(Math.max(data.x, maxLeft), maxRight);
    const newY = Math.min(Math.max(data.y, maxTop), maxBottom);

    // 强制同步更新，避免视觉闪烁
    flushSync(() => {
      setDragPos({ x: newX, y: newY });
    });
  };

  //控制连接线流动
  const upLinkFlow = () => {
    const diagram = diagramInstance.current;
    if (!diagram) return;

    let animationId: number | null = null;
    let offset = 0;

    const updateFlow = () => {
      if (!diagram || diagram.div === null) return;
      offset = (offset - 2 + 100) % 100;
      diagram.links.each((link) => {
        const flowShape = link.findObject("FLOW");
        if (flowShape && flowShape.visible) {
          (flowShape as any).strokeDashOffset = offset;
        }
      });
      animationId = requestAnimationFrame(updateFlow);
    };

    const startAnimation = () => {
      if (!diagram || diagram.div === null) return;
      updateFlow();
    };

    // 监听布局完成事件，确保所有链接都已绘制，然后启动动画
    diagram.addDiagramListener("InitialLayoutCompleted", startAnimation);

    // 如果页面加载后链接已经存在，也直接启动动画
    if (diagram.links.count > 0) {
      startAnimation();
    }

    // 清理函数：组件卸载或 effect 重新执行时，取消动画并移除事件监听，防止内存泄漏
    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
      // 移除事件监听前，确保 diagram 实例依然存在
      if (diagram && !(diagram as any).isDisposed && diagram.div !== null) {
        diagram.removeDiagramListener("InitialLayoutCompleted", startAnimation);
      }
    };
  };

  // 创建一个稳定的引用函数，用于在diagram初始化时设置到父组件和本地引用
  const onDiagramInitialized = useCallback(
    (diagram: go.Diagram) => {
      if (diagram) {
        // 更新本地引用，供组件内部使用
        diagramInstance.current = diagram;
        // diagram.isReadOnly = settings.readonly;
        // 直接设置diagram实例到父组件
        setDiagrams(diagram);

        // 通知初始缩放比例
        if (onScaleChange) {
          onScaleChange(Math.round(diagram.scale * 100));
        }

        // 等待初始布局完成
        diagram.addDiagramListener("InitialLayoutCompleted", () => {
          if (overviewContainerRef.current && !overviewInstanceRef.current) {
            const overview = loadOverview(diagram, overviewContainerRef.current);
            overviewInstanceRef.current = overview;
            overview.requestUpdate();
          }
        });

        console.log("Diagram instance successfully initialized and set to parent component");
      }
    },
    [setDiagrams],
  );

  // 添加清理 useEffect
  useEffect(() => {
    return () => {
      if (overviewInstanceRef.current) {
        // 解除观察，释放资源
        overviewInstanceRef.current.observed = null;
      }
    };
  }, []);

  // 监听图表缩放变化（滚轮、缩放按钮等）
  useEffect(() => {
    const diagram = diagramInstance.current;
    if (!diagram || !onScaleChange) return;

    const handler = () => {
      onScaleChange(Math.round(diagram.scale * 100));
    };

    diagram.addDiagramListener("ViewportBoundsChanged", handler);

    return () => {
      diagram.removeDiagramListener("ViewportBoundsChanged", handler);
    };
  }, [onScaleChange]);

  // 更新图表只读状态的函数
  const updateDiagramReadOnlyState = (diagram: any, isReadOnly: boolean) => {
    if (diagram) {
      diagram.isReadOnly = isReadOnly;
    }
  };

  // 监听settings.readonly属性变化
  useEffect(() => {
    if (diagramInstance.current) {
      updateDiagramReadOnlyState(diagramInstance.current, settings.readonly);
      // console.log(`图表已切换到${settings.readonly ? "只读" : "编辑"}模式`);

      const diagram = diagramInstance.current;

      if (settings.readonly === true) {
        //只读模式
        //隐藏全部分组
        const allGroups = diagram.model.nodeDataArray.filter((item) => item.isGroup);
        allGroups.forEach((item: any) => {
          changeGroupVisible(item, false);
        });
      } else if (settings.readonly === false) {
        //编辑模式
        //显示全部分组
        const allGroups = diagram.model.nodeDataArray.filter((item) => item.isGroup);
        allGroups.forEach((item: any) => {
          changeGroupVisible(item, true);
        });
      }
    }
  }, [settings.readonly]);

  useEffect(() => {
    if (doubleClick) {
      if (!doubleClick.isTitle) {
        if (doubleClick.selectItem && doubleClick.diagram) {
          doubleClickEvent(
            doubleClick.selectItem,
            doubleClick.diagram,
            doubleClick.isRealDoubleClick,
          );
        }
      } else {
        //选中标题选项（非元件非流股）时，关闭弹窗
        setModalVisible(false);
        setIsNowNeedOpenPramDrawer(false);
        setDialogSelectButton(null);
        setModalParams(null);
        setModal2Data(null);
        setMaterialsData(null);
        setLocalParamValues({});
        setLocalFormData({});
        setLocalMaterialsData({});
        setClearSelectVariable();
        setElementPage(null);

        //因为树没有取消选中状态，所以点取消按钮也不清除高亮
        //依然保留取消高亮吧
        const diagram = diagramInstance.current;
        if (diagram) {
          const allLinks = diagram.model["linkDataArray"];
          allLinks.forEach((link: any) => {
            changeLinkBackground(link, "transparent");
          });

          let taskNodes = null;
          if (taskListRef.current) {
            let jobId = selectedItemRef.current.job_id;
            let taskData = taskListRef.current.find((item) => item.job_id === jobId);
            if (taskData) {
              if (taskData.elements.length > 0) {
                taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
                taskNodes = taskNodes.map((obj) => obj["data"]);
              }
            }
          }

          const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
          allNodes.forEach((selectNode: any) => {
            let newIcon = selectNode.icon;
            if (newIcon.includes("high")) {
              newIcon = newIcon.replace("high", "origin");
            }

            if (taskNodes) {
              let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
              if (taskSelectNode) {
                if (newIcon.includes("origin") && taskSelectNode.isRun) {
                  newIcon = newIcon.replace("origin", "green");
                }
              }
            }
            changeNodeIcon(selectNode, newIcon);
          });
        }
      }
    }
  }, [
    doubleClick?.selectItem,
    doubleClick?.diagram,
    doubleClick?.isTitle,
    doubleClick?.isRealDoubleClick,
  ]);

  // // 当dataSource变化时，确保diagram模型也同步更新
  // useEffect(() => {
  //   // 这里不需要额外的更新逻辑，因为ReactDiagram组件会自动处理nodeDataArray和linkDataArray的变化
  //   // 但我们可以添加一些调试日志来监控数据更新
  //   console.log("DataSource updated, diagram data should sync automatically");
  // }, [dataSource]);

  useEffect(() => {
    if (dataSource) {
      //图变化时分组按钮需要变化
      if (dataSource.nodeDataArray.length > 0) {
        let newGroups = dataSource.nodeDataArray.filter((item) => item.isGroup);
        setSelectGroup(null);
        setGroups(newGroups);
      } else {
        setSelectGroup(null);
        setGroups([]);
      }
    }
  }, [dataSource]);

  useEffect(() => {
    selectGroupRef.current = selectGroup;

    // 分组功能，勿删
    if (settings.readonly) {
      const diagram = diagramInstance.current;
      if (diagram) {
        //隐藏全部分组
        const allGroups = diagram.model.nodeDataArray.filter((item) => item.isGroup);
        allGroups.forEach((item: any) => {
          changeGroupVisible(item, false);
        });

        //显示选中分组
        if (selectGroup) {
          changeGroupVisible(selectGroup, true);
        }
      }
    }
  }, [selectGroup]);

  useEffect(() => {
    groupsRef.current = groups;
    setTaskListGroups(groups);
  }, [groups]);

  useEffect(() => {
    setSelectGroup(taskListSelectGroup);
  }, [taskListSelectGroup]);

  const nodeSelectionAdornmentTemplate = new go.Adornment("Auto").add(
    new go.Shape({ fill: null, stroke: "red", strokeWidth: 10, strokeDashArray: [0, 0] }),
    new go.Placeholder(),
  );

  const nodeRotateAdornmentTemplate = new go.Adornment({
    locationSpot: go.Spot.Center,
    locationObjectName: "ELLIPSE",
  }).add(
    new go.Shape("Ellipse", {
      name: "ELLIPSE",
      cursor: "pointer",
      desiredSize: new go.Size(7, 7),
      fill: "lightblue",
      stroke: "deepskyblue",
    }),
    new go.Shape({
      geometryString: "M-50 3.5 L0 3.5",
      isGeometryPositioned: true,
      stroke: "deepskyblue",
      strokeWidth: 1.5,
      strokeDashArray: [4, 2],
    }),
  );

  const makePort = (name: any, spot: any, output: any, input: any) => {
    // console.log(spot);
    return $(go.Shape, "Circle", {
      fill: null,
      stroke: null, // this is changed to "white" in the showPorts function
      //连接点尺寸
      desiredSize: new go.Size(10, 10),
      alignment: spot,
      alignmentFocus: spot, // align the port on the main Shape
      portId: name, // declare this object to be a "port"
      fromSpot: spot,
      toSpot: spot, // declare where links may connect at this port
      fromLinkable: output,
      toLinkable: input, // declare whether the user may draw links to/from here
      fromLinkableSelfNode: true,
      toLinkableSelfNode: true,
      cursor: "pointer", // show a different cursor to indicate potential link point
    });
  };

  const showPorts = (node: any, show: any) => {
    let diagram = node.diagram;
    if (!diagram || diagram.isReadOnly) return;
    // 移除对diagram.allowLink的检查，因为我们已经在图表初始化时设置了这个属性
    node.ports.each((port: any) => {
      port.stroke = show ? "red" : null;
      port.fill = show ? "red" : null;
    });
  };

  // myContextMenu将在setupTemplates函数内部定义

  // 设置图表模板
  const setupTemplates = (diagram: any) => {
    // 设置模型属性
    diagram.model = $(go.GraphLinksModel, {
      linkFromPortIdProperty: "fromPort",
      linkToPortIdProperty: "toPort",
      linkKeyProperty: "key",
    });

    // 在setupTemplates内部定义右键菜单，确保能正确访问diagram实例
    const myContextMenu = $(go.HTMLInfo, {
      show: () => {
        if (menuRef.current) {
          // 使用viewPoint获取视图坐标，确保菜单位置与图表视图匹配
          const mousePt = diagram.lastInput.viewPoint;
          const selectedPart = diagram.selection.first();
          setIsLinkSelected(selectedPart instanceof go.Link);

          // 设置菜单样式，确保定位正确
          const menu = menuRef.current;
          menu.style.position = "absolute";
          menu.style.left = mousePt.x + 360 + "px";
          menu.style.top = mousePt.y + "px";
          menu.style.zIndex = "1000";
          menu.style.display = "block";

          // 确保菜单不超出视口范围
          const rect = menu.getBoundingClientRect();
          if (rect.right > window.innerWidth) {
            // menu.style.left = mousePt.x - rect.width + "px";
            menu.style.left = mousePt.x - rect.width + 340 + "px";
          }
          if (rect.bottom > window.innerHeight) {
            menu.style.top = mousePt.y - rect.height + "px";
          }
        }
      },
      hide: () => {
        if (menuRef.current) {
          menuRef.current.style.display = "none";
        }
      },
    });

    const tool = new LinkLabelOnPathDraggingTool();
    diagram.toolManager.mouseMoveTools.insertAt(0, tool);

    // 设置group模板
    //分组
    diagram.groupTemplate = $(
      go.Group,
      // "Position",
      "Vertical",
      {
        selectionObjectName: "PANEL", // selection handle goes around shape, not label
        ungroupable: true, // enable Ctrl-Shift-G to ungroup a selected Group
        layout: null, //禁止重新布局子节点
        avoidable: false, //连接线在路由时不会将该分组视为障碍物，从而不会自动重新计算路径
      },

      //鼠标悬浮
      new go.Binding("toolTip", "", (data) => {
        const desc = data.description;
        if (!desc || desc.trim() === "") return null;
        const name = data.groupName || "";
        const text = name ? name + "：" + desc : desc;
        return $(
          go.Adornment,
          "Auto",
          $(go.Shape, { fill: "#FFF", stroke: "gray", strokeWidth: 1 }),
          $(go.TextBlock, {
            margin: 20,
            maxSize: new go.Size(200, NaN),
            wrap: go.TextBlock.WrapFit,
            text: text,
          }),
        );
      }),

      $(
        go.TextBlock,
        {
          //alignment: go.Spot.Right,
          font: "bold 64px sans-serif",
          isMultiline: false, // don't allow newlines in text
          editable: true, // 允许双击就地编辑分组名称（只读模式下由 diagram.isReadOnly 自动禁用）
          stroke: "rgba(255, 119, 0, 1)",
          //分组功能，勿删
          // visible:false,
          textEdited: (textBlock, oldText, newText) => {
            const group = textBlock.part;
            if (group && group.data) {
              if (checkNameUnique(newText, "group", group.data.key)) {
                // group.diagram.model.setDataProperty(group.data, "keywords", newText);
                group.diagram.model.setDataProperty(group.data, "groupName", newText);
              } else {
                // group.diagram.model.setDataProperty(group.data, "keywords", oldText);
                group.diagram.model.setDataProperty(group.data, "groupName", oldText);
                messageApi.open({
                  type: "error",
                  content: "分组名称重复",
                });
              }
            }
          },
        },
        new go.Binding("text", "groupName").makeTwoWay(),
        new go.Binding("stroke", "titleColor"),
        new go.Binding("visible", "visible"),
      ),
      $(
        go.Panel,
        "Auto",
        { name: "PANEL" },
        new go.Binding("visible", "visible"),
        $(
          go.Shape,
          "Rectangle", // the rectangular shape around the members
          {
            // fill: "rgba(128,128,128,0.05)",
            //分组背景色
            fill: "rgba(186, 209, 219, 0.28)",
            //分组边框颜色
            stroke: "#BBB",
            strokeWidth: 5,
            //分组功能，勿删
            // visible:false,

            //分组边框变虚线
            // strokeDashArray: [50, 30],

            // allow all kinds of links from and to this port
            // fromLinkable: true, fromLinkableSelfNode: true, fromLinkableDuplicates: true,
            // toLinkable: true, toLinkableSelfNode: true, toLinkableDuplicates: true
          },
          new go.Binding("visible", "visible"),
        ),
        $(go.Placeholder, { margin: 10, background: "transparent" }), // represents where the members are
      ),
      // { // this tooltip Adornment is shared by all groups
      // 	toolTip:
      // 		$("ToolTip",
      // 			$(go.TextBlock, { margin: 4 },
      // 				// bind to tooltip, not to Group.data, to allow access to Group properties
      // 				new go.Binding("text", "", groupInfo).ofObject())
      // 		),
      // 	// the same context menu Adornment is shared by all groups
      // 	contextMenu: partContextMenu
      // }
    );

    diagram.nodeTemplate = $(
      go.Node,
      "Spot", // the Shape will go around the TextBlock
      {
        contextMenu: myContextMenu,
        zOrder: 1,
        mouseEnter: (e, obj) => {
          showPorts(obj.part, true);
        },
        mouseLeave: (e, obj) => {
          showPorts(obj.part, false);
        },
        locationSpot: go.Spot.Center,
      },
      new go.Binding("zOrder", "zOrder"),

      //鼠标悬浮
      new go.Binding("toolTip", "", (data) => {
        const desc = data.description;
        if (!desc || desc.trim() === "") return null;
        const name = data.text || "";
        const text = name ? name + "：" + desc : desc;
        return $(
          go.Adornment,
          "Auto",
          $(go.Shape, { fill: "#FFF", stroke: "gray", strokeWidth: 1 }),
          $(go.TextBlock, {
            margin: 20,
            maxSize: new go.Size(200, NaN),
            wrap: go.TextBlock.WrapFit,
            text: text,
          }),
        );
      }),

      {
        resizable: true,
        resizeObjectName: "SHAPE",
        // selectionObjectName: 'SHAPE',
      },
      {
        selectable: true,
        selectionObjectName: "SHAPE",
        selectionAdornmentTemplate: nodeSelectionAdornmentTemplate,
      },
      {
        rotatable: true,
        rotateObjectName: "SHAPE",
        rotateAdornmentTemplate: nodeRotateAdornmentTemplate,
      },

      // {
      //   selectable: true,
      //   selectionObjectName: 'SHAPE',
      //   // selectionAdornmentTemplate: gojs(
      //   //   go.Adornment,
      //   //   'Auto',
      //   //   gojs(go.Shape, {
      //   //     fill: null,
      //   //     stroke: 'rgba(220,110,5,1)',
      //   //     strokeWidth: 2,
      //   //     // strokeDashArray: [1, 2],
      //   //   }),
      //   //   gojs(go.Placeholder)
      //   // ),
      // },

      $(
        go.Picture,
        {
          name: "SHAPE",
        },

        new go.Binding("source", "icon").makeTwoWay(),
        new go.Binding("angle").makeTwoWay(),
        new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(go.Size.stringify),

        // new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
      ),
      makePort("T1", new go.Spot(1 / 20, 0, 0, 0), true, true),
      makePort("T2", new go.Spot(2 / 20, 0, 0, 0), true, true),
      makePort("T3", new go.Spot(3 / 20, 0, 0, 0), true, true),
      makePort("T4", new go.Spot(4 / 20, 0, 0, 0), true, true),
      makePort("T5", new go.Spot(5 / 20, 0, 0, 0), true, true),
      makePort("T6", new go.Spot(6 / 20, 0, 0, 0), true, true),
      makePort("T7", new go.Spot(7 / 20, 0, 0, 0), true, true),
      makePort("T8", new go.Spot(8 / 20, 0, 0, 0), true, true),
      makePort("T9", new go.Spot(9 / 20, 0, 0, 0), true, true),
      makePort("T10", new go.Spot(10 / 20, 0, 0, 0), true, true),
      makePort("T11", new go.Spot(11 / 20, 0, 0, 0), true, true),
      makePort("T12", new go.Spot(12 / 20, 0, 0, 0), true, true),
      makePort("T13", new go.Spot(13 / 20, 0, 0, 0), true, true),
      makePort("T14", new go.Spot(14 / 20, 0, 0, 0), true, true),
      makePort("T15", new go.Spot(15 / 20, 0, 0, 0), true, true),
      makePort("T16", new go.Spot(16 / 20, 0, 0, 0), true, true),
      makePort("T17", new go.Spot(17 / 20, 0, 0, 0), true, true),
      makePort("T18", new go.Spot(18 / 20, 0, 0, 0), true, true),
      makePort("T19", new go.Spot(19 / 20, 0, 0, 0), true, true),
      makePort("T20", new go.Spot(20 / 20, 0, 0, 0), true, true),

      makePort("B1", new go.Spot(1 / 20, 1, 0, 0), true, true),
      makePort("B2", new go.Spot(2 / 20, 1, 0, 0), true, true),
      makePort("B3", new go.Spot(3 / 20, 1, 0, 0), true, true),
      makePort("B4", new go.Spot(4 / 20, 1, 0, 0), true, true),
      makePort("B5", new go.Spot(5 / 20, 1, 0, 0), true, true),
      makePort("B6", new go.Spot(6 / 20, 1, 0, 0), true, true),
      makePort("B7", new go.Spot(7 / 20, 1, 0, 0), true, true),
      makePort("B8", new go.Spot(8 / 20, 1, 0, 0), true, true),
      makePort("B9", new go.Spot(9 / 20, 1, 0, 0), true, true),
      makePort("B10", new go.Spot(10 / 20, 1, 0, 0), true, true),
      makePort("B11", new go.Spot(11 / 20, 1, 0, 0), true, true),
      makePort("B12", new go.Spot(12 / 20, 1, 0, 0), true, true),
      makePort("B13", new go.Spot(13 / 20, 1, 0, 0), true, true),
      makePort("B14", new go.Spot(14 / 20, 1, 0, 0), true, true),
      makePort("B15", new go.Spot(15 / 20, 1, 0, 0), true, true),
      makePort("B16", new go.Spot(16 / 20, 1, 0, 0), true, true),
      makePort("B17", new go.Spot(17 / 20, 1, 0, 0), true, true),
      makePort("B18", new go.Spot(18 / 20, 1, 0, 0), true, true),
      makePort("B19", new go.Spot(19 / 20, 1, 0, 0), true, true),
      makePort("B20", new go.Spot(20 / 20, 1, 0, 0), true, true),

      makePort("L1", new go.Spot(0, 1 / 20, 0, 0), true, true),
      makePort("L2", new go.Spot(0, 2 / 20, 0, 0), true, true),
      makePort("L3", new go.Spot(0, 3 / 20, 0, 0), true, true),
      makePort("L4", new go.Spot(0, 4 / 20, 0, 0), true, true),
      makePort("L5", new go.Spot(0, 5 / 20, 0, 0), true, true),
      makePort("L6", new go.Spot(0, 6 / 20, 0, 0), true, true),
      makePort("L7", new go.Spot(0, 7 / 20, 0, 0), true, true),
      makePort("L8", new go.Spot(0, 8 / 20, 0, 0), true, true),
      makePort("L9", new go.Spot(0, 9 / 20, 0, 0), true, true),
      makePort("L10", new go.Spot(0, 10 / 20, 0, 0), true, true),
      makePort("L11", new go.Spot(0, 11 / 20, 0, 0), true, true),
      makePort("L12", new go.Spot(0, 12 / 20, 0, 0), true, true),
      makePort("L13", new go.Spot(0, 13 / 20, 0, 0), true, true),
      makePort("L14", new go.Spot(0, 14 / 20, 0, 0), true, true),
      makePort("L15", new go.Spot(0, 15 / 20, 0, 0), true, true),
      makePort("L16", new go.Spot(0, 16 / 20, 0, 0), true, true),
      makePort("L17", new go.Spot(0, 17 / 20, 0, 0), true, true),
      makePort("L18", new go.Spot(0, 18 / 20, 0, 0), true, true),
      makePort("L19", new go.Spot(0, 19 / 20, 0, 0), true, true),
      makePort("L20", new go.Spot(0, 20 / 20, 0, 0), true, true),

      makePort("R1", new go.Spot(1, 1 / 20, 0, 0), true, true),
      makePort("R2", new go.Spot(1, 2 / 20, 0, 0), true, true),
      makePort("R3", new go.Spot(1, 3 / 20, 0, 0), true, true),
      makePort("R4", new go.Spot(1, 4 / 20, 0, 0), true, true),
      makePort("R5", new go.Spot(1, 5 / 20, 0, 0), true, true),
      makePort("R6", new go.Spot(1, 6 / 20, 0, 0), true, true),
      makePort("R7", new go.Spot(1, 7 / 20, 0, 0), true, true),
      makePort("R8", new go.Spot(1, 8 / 20, 0, 0), true, true),
      makePort("R9", new go.Spot(1, 9 / 20, 0, 0), true, true),
      makePort("R10", new go.Spot(1, 10 / 20, 0, 0), true, true),
      makePort("R11", new go.Spot(1, 11 / 20, 0, 0), true, true),
      makePort("R12", new go.Spot(1, 12 / 20, 0, 0), true, true),
      makePort("R13", new go.Spot(1, 13 / 20, 0, 0), true, true),
      makePort("R14", new go.Spot(1, 14 / 20, 0, 0), true, true),
      makePort("R15", new go.Spot(1, 15 / 20, 0, 0), true, true),
      makePort("R16", new go.Spot(1, 16 / 20, 0, 0), true, true),
      makePort("R17", new go.Spot(1, 17 / 20, 0, 0), true, true),
      makePort("R18", new go.Spot(1, 18 / 20, 0, 0), true, true),
      makePort("R19", new go.Spot(1, 19 / 20, 0, 0), true, true),
      makePort("R20", new go.Spot(1, 20 / 20, 0, 0), true, true),
      new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),

      $(
        go.Panel,
        "Auto",
        {
          alignment: new go.Spot(0.5, 1.2),
          // isActionable: true,
        },
        new go.Binding("alignment", "point", function (x) {
          return new go.Spot(x[0], x[1]);
        }),

        $(
          go.Shape,
          "RoundedRectangle",
          {
            fill: "red",
            stroke: null,
            parameter1: 3,

            // desiredSize: new go.Size(999, 50),
            // cursor: "move",
            // pickable: true,
            // isActionable: true,
          },
          new go.Binding("fill", "textBackground").makeTwoWay(),
        ),

        $(
          go.TextBlock,
          {
            editable: false,
            //元件下方文字尺寸
            font: "12pt Segoe UI,sans-serif",
            stroke: "#000",
            margin: new go.Margin(5, 10, 2, 10),
            // margin: new go.Margin(5, 6, 3, 6),
            // margin: new go.Margin(10,10,10,10),
            // alignment: new go.Spot(0.5, 1.2),
            // minSize: new go.Size(10, 14),
            // alignment: new go.Spot(0.5, 1.05),
            // margin: new go.Margin(10, 0, 10, 0),
            textEdited: (textBlock, oldText, newText) => {
              const node = textBlock.part;
              if (node && node.data) {
                if (checkNameUnique(newText, "node", node.data.key)) {
                  node.diagram.model.setDataProperty(node.data, "nodeName", newText);
                  node.diagram.model.setDataProperty(node.data, "text", newText);
                } else {
                  node.diagram.model.setDataProperty(node.data, "text", oldText);
                  messageApi.open({
                    type: "error",
                    content: "元件名称重复",
                  });
                }
              }
            },
          },
          new go.Binding("text", "text").makeTwoWay(),
          new go.Binding("stroke", "textColor").makeTwoWay(),
          // new go.Binding("font", "fontSize", function (size) {
          //   return size + "pt Lato, sans-serif";
          // }).makeTwoWay(),
          new go.Binding("font", "fontSize").makeTwoWay(),
          // new go.Binding("alignment", "point", function (x) {
          //   return new go.Spot(x[0], x[1]);
          // }),
          // new go.Binding("background", "textBackground").makeTwoWay(),
        ),
      ),

      // $(
      //   go.Shape,
      //   'RoundedRectangle',
      //   { strokeWidth: 0, fill: 'white' },
      //   // Shape.fill is bound to Node.data.color
      //   new go.Binding('fill', 'color'),
      // ),
      // $(
      //   go.TextBlock,
      //   { margin: 8 }, // some room around the text
      //   // TextBlock.text is bound to Node.data.key
      //   new go.Binding('text', 'key'),
      // ),
    );
    // );

    // setDiagram(diagram);

    diagram.nodeTemplateMap.add(
      "Comment",
      $(
        go.Node,
        "Auto", // the Shape will go around the TextBlock
        { contextMenu: myContextMenu },
        $(
          // go.Shape,
          // "rectangle",
          // {
          //   strokeWidth: 1,
          //   stroke: "rgba(255,255,255,0.3)",
          //   fill: "rgba(255,255,255,0.1)",
          // },
          go.Picture,
          {
            name: "SHAPE",
          },
          new go.Binding("source", "icon").makeTwoWay(),
          new go.Binding("angle").makeTwoWay(),
          new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(go.Size.stringify),

          // Shape.fill is bound to Node.data.color
          // new go.Binding("strokeWidth", "borderWidth").makeTwoWay(),
          // new go.Binding("fill", "bgColor").makeTwoWay(),
          // new go.Binding("stroke", "borderColor").makeTwoWay()
        ),

        $(
          go.TextBlock,
          {
            margin: 4,
            font: "16px sans-serif",
            stroke: "#000",
          }, // Specify a margin to add some room around the text
          // TextBlock.text is bound to Node.data.key
          {
            editable: false,
            alignment: new go.Spot(0.5, 0.5),
          },
          new go.Binding("text").makeTwoWay(),
          // new go.Binding('text', 'text'), //显示控件文字
          // new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(go.Size.stringify),
          new go.Binding("stroke", "fontColor").makeTwoWay(),
          new go.Binding("font", "textSize", function (size) {
            return size + "px Lato, sans-serif";
          }).makeTwoWay(),
          new go.Binding("alignment", "point", function (x) {
            return new go.Spot(x[0], x[1]);
          }).makeTwoWay(),
        ),
        new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
        // makePort("T", go.Spot.Top, true, true),
        // makePort("L", go.Spot.Left, true, true),
        // makePort("R", go.Spot.Right, true, true),
        // makePort("B", go.Spot.Bottom, true, true)
      ),
    );

    diagram.linkTemplate = $(
      go.Link,
      // defined below
      { contextMenu: myContextMenu },
      {
        routing: go.Link.AvoidsNodes,
        // contextMenu: myContextMenu,
        corner: 0,
        curve: go.Link.JumpGap,
        relinkableFrom: true,
        relinkableTo: true,
        reshapable: true,
        resegmentable: true,
        //   link.findObject('HIGHLIGHT').stroke = 'rgba(30,144,255,0.2)';
        // },
        // mouseLeave: function (e, link) {
        //   link.findObject('HIGHLIGHT').stroke = 'transparent';
        // },
      },
      //鼠标悬浮
      new go.Binding("toolTip", "", (data) => {
        const desc = data.description;
        if (!desc || desc.trim() === "") return null;
        const name = data.text || "";
        const text = name ? name + "：" + desc : desc;
        return $(
          go.Adornment,
          "Auto",
          $(go.Shape, { fill: "#FFF", stroke: "gray", strokeWidth: 1 }),
          $(go.TextBlock, {
            margin: 20,
            maxSize: new go.Size(200, NaN),
            wrap: go.TextBlock.WrapFit,
            text: text,
          }),
        );
      }),
      new go.Binding("points").makeTwoWay(),
      // { contextMenu: myContextMenu },
      $(
        go.Shape,
        {
          isPanelMain: true,
          strokeWidth: 15,
          stroke: "transparent", // 默认透明
          name: "BACKGROUND",
        },
        new go.Binding("stroke", "linkBgColor").makeTwoWay(), //连接线背景色
        new go.Binding("strokeWidth", "strokeWidth", (w) => (w !== undefined ? 12 + w * 3 : 10)), //连接线背景宽度
      ),
      //流动线条
      $(
        go.Shape,
        {
          isPanelMain: true,
          // stroke: "rgba(0, 160, 255, 0.9)",
          strokeWidth: 7,
          strokeDashArray: [20, 30],
          name: "FLOW",
          visible: false,
          pickable: false,
          isActionable: false,
        },
        // new go.Binding("stroke","flowColor").makeTwoWay(),
        new go.Binding("stroke", "lineColor").makeTwoWay(),
        new go.Binding("visible", "flowEnabled").makeTwoWay(),
      ),
      $(
        go.Shape, // the highlight shape, normally transparent
        { isPanelMain: true, strokeWidth: 15, stroke: "transparent", name: "HIGHLIGHT" },
      ),
      $(
        go.Shape,
        {
          isPanelMain: true,
          stroke: "rgba(0,0,0,1)",
          strokeWidth: 1,
          opacity: 1,
          // strokeDashArray:[0,0] // 虚线
        },
        new go.Binding("stroke", "lineColor").makeTwoWay(),
        new go.Binding("strokeWidth", "strokeWidth").makeTwoWay(),
        new go.Binding("strokeDashArray", "lineType").makeTwoWay(),
        new go.Binding("opacity", "flowEnabled", (enabled) => (enabled ? 0.5 : 1)).makeTwoWay(),
      ),

      $(
        go.Shape, // the highlight shape, normally transparent
        { isPanelMain: true, strokeWidth: 15, stroke: "transparent", name: "HIGHLIGHT" },
      ),
      // $(
      //   go.Shape,
      //   { isPanelMain: true, stroke: "#787878", strokeWidth: 12 },
      //   new go.Binding("stroke", "lineColor1").makeTwoWay(),
      //   new go.Binding("strokeWidth", "strokeWidth1").makeTwoWay()
      // ),
      // $(
      //   go.Shape,
      //   { isPanelMain: true, stroke: "#a3a3a3", strokeWidth: 8 },
      //   new go.Binding("stroke", "lineColor2").makeTwoWay(),
      //   new go.Binding("strokeWidth", "strokeWidth2").makeTwoWay()
      // ),
      // $(
      //   go.Shape,
      //   { isPanelMain: true, stroke: "#dbdbdb", strokeWidth: 4, strokeDashArray: [0, 0] },
      //   new go.Binding("stroke", "lineColor3").makeTwoWay(),
      //   new go.Binding("strokeWidth", "strokeWidth3").makeTwoWay(),
      //   new go.Binding("strokeDashArray", "lineType").makeTwoWay()
      // ),

      // $(go.Shape, { isPanelMain: true, stroke: "#715715", strokeWidth: 6 }),
      // $(go.Shape, { isPanelMain: true, stroke: "#D8B06E", strokeWidth: 2 }),
      // $(go.Shape, { isPanelMain: true, stroke: "#E6C37C" }),
      $(
        go.Shape,
        {
          toArrow: "Triangle",
          stroke: "black",
          fill: "blcak",
          //连接线箭头尺寸
          strokeWidth: 1,
        },
        // new go.Binding("fill", "arrowColor"),
        new go.Binding("strokeWidth", "arrowScale").makeTwoWay(),
        new go.Binding("stroke", "lineColor").makeTwoWay(),
        new go.Binding("fill", "lineColor"),
      ),

      $(
        go.Panel,
        "Auto", // the link label, normally not visible
        { visible: true, name: "LABEL", segmentIndex: 2, segmentFraction: 0.5, _isLinkLabel: true },
        new go.Binding("visible", "visible").makeTwoWay(),
        new go.Binding("segmentIndex", "segmentIndex").makeTwoWay(),
        new go.Binding("segmentFraction", "segmentFraction").makeTwoWay(),
        $(
          go.Shape,
          "Rectangle", // the label shape
          { fill: "#f0fdffff", stroke: "#0273b9ff", strokeWidth: 1 },
          new go.Binding("fill", "shapeBG").makeTwoWay(), //连接线文字背景颜色
          new go.Binding("stroke", "shapeBorder").makeTwoWay(), //连接线文字边框颜色
          new go.Binding("strokeWidth", "shapeBorderWidth").makeTwoWay(), //连接线文字边框宽度
        ),
        $(
          go.TextBlock,
          "Stream", // the label
          {
            textAlign: "center",
            //连接线文字尺寸
            // font: "12pt helvetica, arial, sans-serif",
            stroke: "#333333",
            editable: false,
            margin: new go.Margin(5, 6, 3, 6),

            // 添加编辑完成事件
            textEdited: (textBlock, oldText, newText) => {
              const link = textBlock.part; // 获取所属的 Link
              if (link) {
                const linkData = link.data;
                if (linkData) {
                  if (checkNameUnique(newText, "link", linkData.key)) {
                    link.diagram.model.setDataProperty(linkData, "linkName", newText);
                    link.diagram.model.setDataProperty(linkData, "text", newText);
                  } else {
                    link.diagram.model.setDataProperty(linkData, "text", oldText);
                    messageApi.open({
                      type: "error",
                      content: "流股名称重复",
                    });
                  }
                }
              }
            },
          },
          new go.Binding("text").makeTwoWay(),
          new go.Binding("font", "fontSize").makeTwoWay(),
          new go.Binding("stroke", "textColor").makeTwoWay(),
        ),
      ),
    );

    // 监听链接绘制完成事件
    diagram.addDiagramListener("LinkDrawn", (e) => {
      const link = e.subject; // go.Link 对象
      const linkData = link.data; // 链接对应的数据对象
      if (linkData) {
        // const currentText = linkData.text || "";
        let newText = `Stream${linkData.key}`;
        diagram.model.setDataProperty(linkData, "linkName", newText);
        diagram.model.setDataProperty(linkData, "text", newText);
        diagram.model.setDataProperty(linkData, "description", "");
      }
    });

    // 监听元件创建完成事件
    diagram.addModelChangedListener((evt) => {
      // 检查是否是向 nodeDataArray 中插入了新数据 (即添加节点)
      if (evt.change === go.ChangedEvent.Insert && evt.propertyName === "nodeDataArray") {
        const newNodeData = evt.newValue;
        if (newNodeData) {
          if (newNodeData.isGroup) {
            //分组
            if (newNodeData.groupName === "Group") //说明是默认名称
            {
              // const currentText = linkData.text || "";
              let newText = `Group${newNodeData.key}`;
              diagram.model.setDataProperty(newNodeData, "groupName", newText);
              diagram.model.setDataProperty(newNodeData, "description", "");

              //选中刚刚创建的分组
              newNodeData.groupName = newText;
              setSelectGroup(newNodeData);

              // //添加分组按钮
              // let newGroups = groupsRef.current;
              // newGroups.push(newNodeData);
              // setGroups(newGroups);
            }
          } else {
            //元件
            if (newNodeData.text === newNodeData.elementName) //说明是默认名称
            {
              // const currentText = linkData.text || "";
              let newText = `${newNodeData.text}${newNodeData.key}`;

              if (newNodeData.type === "comments") {
                newText = "";
              }
              diagram.model.setDataProperty(newNodeData, "nodeName", newText);
              diagram.model.setDataProperty(newNodeData, "text", newText);
            }
          }
        }
      }
      // // 删除数据
      // else if (evt.change === go.ChangedEvent.Remove && evt.propertyName === 'nodeDataArray')
      // {
      //   const oldNodeData = evt.oldValue;
      //   if (oldNodeData)
      //   {
      //     if(oldNodeData.isGroup)
      //     {
      //       //分组
      //       let newGroups = groupsRef.current;

      //       //如果被删除的正好是选中的，则先取消选中
      //       if(selectGroupRef.current)
      //       {
      //         if(selectGroupRef.current.key===oldNodeData.key)
      //         {
      //           setSelectGroup(null);
      //         }
      //       }
      //       //更新分组数据
      //       newGroups = newGroups.filter(item=>item.key!==oldNodeData.key);
      //       setGroups(newGroups);
      //     }
      //   }
      // }
    });

    diagram.addDiagramListener("ObjectContextClicked", (e) => {
      e.handled = true;
      e.diagram.currentTool.stopTool();

      // // 获取点击的对象
      // const clickedObj = e.subject.part;

      // // 如果点击的是链接，设置当前管道并显示右键菜单
      // if (clickedObj instanceof go.Link) {
      //   const linkData = clickedObj.data;
      //   setCurTube(linkData);

      //   // 手动触发右键菜单显示，使用viewPoint而不是documentPoint
      //   if (menuRef.current && diagram) {
      //     // 使用viewPoint获取视图坐标，这样菜单位置会正确匹配图表视图
      //     const mousePt = diagram.lastInput.viewPoint;

      //     const menu = menuRef.current;
      //     menu.style.position = "absolute";
      //     menu.style.left = mousePt.x + "px";
      //     menu.style.top = mousePt.y + "px";
      //     menu.style.zIndex = "1000";
      //     menu.style.display = "block";

      //     // 确保菜单不超出视口范围
      //     const rect = menu.getBoundingClientRect();
      //     if (rect.right > window.innerWidth) {
      //       menu.style.left = mousePt.x - rect.width + "px";
      //     }
      //     if (rect.bottom > window.innerHeight) {
      //       menu.style.top = mousePt.y - rect.height + "px";
      //     }
      //   }
      // }
    });

    // 添加全局点击事件监听，点击菜单外部时隐藏菜单
    document.addEventListener("click", (e: any) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        menuRef.current.style.display = "none";
      }
    });
    diagram.addDiagramListener("AnimationFinished", () => {
      diagram.zoomToFit();
    });
    //点击，单击
    diagram.addDiagramListener("ObjectSingleClicked", () => {
      // const selection = diagram.selection;
      // let selectElements = selection.toArray();
      // let selectNodes = [];
      // for(let i=0;i<selectElements.length;i++)
      // {
      //   let selectNode = selectElements[i].ub;
      //   if(selectNode.nodeName)
      //   {
      //     selectNodes.push(selectNode);
      //   }
      // }
      // setMultipleNodes(selectNodes);
    });

    //选中变化
    diagram.addDiagramListener("ChangedSelection", () => {
      const selection = diagram.selection;
      let selectElements = selection.toArray();
      let selectNodes = [];
      for (let i = 0; i < selectElements.length; i++) {
        let selectNode = selectElements[i].ub;
        if (selectNode.nodeName) {
          selectNodes.push(selectNode);
        }
      }
      setMultipleNodes(selectNodes);
    });

    //双击
    diagram.addDiagramListener("ObjectDoubleClicked", (e) => {
      //判断是否为分组
      if (diagram.selection.first().ub) {
        let node = diagram.selection.first().ub;
        if (node.isGroup && !diagram.isReadOnly) {
          openGroup(node);
          return;
        }
      }

      if (diagram.isReadOnly) //只读状态打开任务数据，所以调用模拟双击接口
      {
        // const node = diagram.selection.first().ub;
        const clickedPart = e.subject.part || e.subject;
        const node = clickedPart.data;
        if (taskListRef.current) {
          let jobId = selectedItemRef.current.job_id;
          let taskData = taskListRef.current.find((item) => item.job_id === jobId);

          if (taskData) {
            if (node.nodeName !== undefined) {
              let nodeType = node.type;
              let nodeDatas = taskData.elements.find((item) => item.engName === nodeType)?.children;
              if (nodeDatas) {
                let nodeData = nodeDatas.find((item) => item.name === node.nodeName);

                //更改选中的树
                setSelectedNode({
                  type: "element",
                  job_id: jobId,
                  job_name: selectedItemRef.current.job_name,
                  category: typeMap3[nodeData.data.type],
                  item_name: nodeData.name,
                  path: [
                    selectedItemRef.current.job_name,
                    "单元操作",
                    typeMap3[nodeData.data.type],
                    nodeData.name,
                  ],
                  data: nodeData.data,
                });
                doubleClickEvent(nodeData.data, diagram, true);
              } else {
                messageApi.open({
                  type: "error",
                  content: "该元件无法在计算任务中编辑",
                });
              }
            } else if (node.linkName !== undefined) {
              let linkData = taskData.streams.find((item) => item.name === node.linkName);

              //更改选中的树
              setSelectedNode({
                type: "stream",
                job_id: jobId,
                job_name: selectedItemRef.current.job_name,
                item_name: linkData.name,
                path: [selectedItemRef.current.job_name, "流股", linkData.name],
                data: linkData.data,
              });
              doubleClickEvent(linkData.data, diagram, true);
            }
          } else {
            if (selectedItemRef.current.job_name) {
              messageApi.open({
                type: "error",
                content: `计算任务 ${selectedItemRef.current.job_name} 数据异常`,
              });
            } else {
              messageApi.open({
                type: "error",
                content: `请选择要查看的计算任务`,
              });
            }
          }
        } else {
          messageApi.open({
            type: "error",
            content: "请选择要查看的计算任务",
          });
        }
      } else {
        //高亮连接线背景色
        // const node = diagram.selection.first().ub;
        const clickedPart = e.subject.part || e.subject;
        const node = clickedPart.data;

        if (!node) return;
        if (node.nodeName !== undefined) {
          const allLinks = diagram.model.linkDataArray;
          allLinks.forEach((link: any) => {
            changeLinkBackground(link, "transparent");
          });
          const nodeKey = node.key;
          const relatedLinks = allLinks.filter(
            (link: any) => link.from === nodeKey || link.to === nodeKey,
          );
          relatedLinks.forEach((link: any) => {
            changeLinkBackground(link, "#85e97c"); //高亮颜色
          });

          let taskNodes = null;
          if (taskListRef.current) {
            let jobId = selectedItemRef.current.job_id;
            let taskData = taskListRef.current.find((item) => item.job_id === jobId);
            if (taskData) {
              if (taskData.elements.length > 0) {
                taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
                taskNodes = taskNodes.map((obj) => obj["data"]);
              }
            }
          }

          const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
          allNodes.forEach((selectNode: any) => {
            let newIcon = selectNode.icon;
            if (newIcon.includes("high")) {
              newIcon = newIcon.replace("high", "origin");
            }

            if (taskNodes) {
              let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
              if (taskSelectNode) {
                if (newIcon.includes("origin") && taskSelectNode.isRun) {
                  newIcon = newIcon.replace("origin", "green");
                }
              }
            }
            changeNodeIcon(selectNode, newIcon);
          });

          const selectNodes = diagram.model.nodeDataArray.filter((item) => item.key === nodeKey);
          selectNodes.forEach((selectNode: any) => {
            let newIcon = selectNode.icon;
            if (newIcon.includes("origin")) {
              newIcon = newIcon.replace("origin", "high");
            } else if (newIcon.includes("green")) {
              newIcon = newIcon.replace("green", "high");
            }
            changeNodeIcon(selectNode, newIcon);
          });
        } else if (node.linkName !== undefined) {
          const allLinks = diagram.model.linkDataArray;
          allLinks.forEach((link: any) => {
            changeLinkBackground(link, "transparent");
          });
          changeLinkBackground(node, "#85e97c"); //高亮颜色

          let taskNodes = null;
          if (taskListRef.current) {
            let jobId = selectedItemRef.current.job_id;
            let taskData = taskListRef.current.find((item) => item.job_id === jobId);
            if (taskData) {
              if (taskData.elements.length > 0) {
                taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
                taskNodes = taskNodes.map((obj) => obj["data"]);
              }
            }
          }

          const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
          allNodes.forEach((selectNode: any) => {
            let newIcon = selectNode.icon;
            if (newIcon.includes("high")) {
              newIcon = newIcon.replace("high", "origin");
            }

            if (taskNodes) {
              let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
              if (taskSelectNode) {
                if (newIcon.includes("origin") && taskSelectNode.isRun) {
                  newIcon = newIcon.replace("origin", "green");
                }
              }
            }
            changeNodeIcon(selectNode, newIcon);
          });
        }
        openInputParams(diagram);
      }
    });

    // setDiagrams(diagram)
    return diagram;
  };

  const changeTube = (diagram: go.Diagram, tube: any, type: any) => {
    // diagram.model.setDataProperty(tube, "lineColor1", "purple");
    diagram.model.assignAllDataProperties(tube, {
      lineColor1: tubeColorSet[type][0],
      lineColor2: tubeColorSet[type][1],
      lineColor3: tubeColorSet[type][2],
    });
    // console.log(JSON.parse(diagram.model.toJson()));
    // diagram.model=go.Model.fromJson(JSON.parse(diagram.model.toJson()));
  };

  const changeLineWidth = (factor: number) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    let linkData = null;
    if (selected instanceof go.Link) {
      linkData = selected.data;
    } else if (curTube) {
      // 如果没有选中但 curTube 存在，通过数据查找链接
      const link = diagram.findLinkForData(curTube);
      if (link) linkData = curTube;
    }
    if (!linkData) return;

    let currentWidth = linkData.strokeWidth;
    if (currentWidth === undefined) currentWidth = 2; // 默认线宽
    let newWidth = currentWidth * factor;
    //连接线宽度范围1~500
    newWidth = Math.min(Math.max(newWidth, 1), 500);
    diagram.model.setDataProperty(linkData, "strokeWidth", newWidth);
  };

  const changeArrowScale = (factor: number) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    let linkData = null;
    if (selected instanceof go.Link) {
      linkData = selected.data;
    } else if (curTube) {
      linkData = curTube;
    }
    if (!linkData) return;

    let currentScale = linkData.arrowScale;
    if (currentScale === undefined || currentScale === null) currentScale = 10;
    let newScale = currentScale * factor;
    //箭头尺寸范围1~1000
    newScale = Math.min(Math.max(newScale, 1), 1000);
    diagram.model.setDataProperty(linkData, "arrowScale", newScale);
  };

  const changeLineColor = (color: string) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;

    // 获取当前选中的元素
    const selected = diagram.selection.first();
    let linkData = null;

    if (!selected) {
      if (openNode) {
        let diagram = diagramInstance.current;
        let dataArrays = diagram.model[openNode.nodeName ? "nodeDataArray" : "linkDataArray"];
        linkData = dataArrays.find((item) => item.key === openNode.key);
      }
    } else {
      linkData = selected.data;
    }
    // 如果选中的是连接线，则使用其数据；否则尝试使用 curTube（通过右键菜单设置）
    // if (selected instanceof go.Link)
    // {
    //   linkData = selected.data;
    // }
    // else if (curTube)
    // {
    //   linkData = curTube;
    // }

    // 更新连接线的颜色
    if (linkData) {
      diagram.model.setDataProperty(linkData, "lineColor", color);
    }
  };

  const changeFontSize = (delta: number) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    if (!selected) return;

    if (selected instanceof go.Node) {
      // 修改节点文字大小
      const data = selected.data;
      let currentSize = data.fontSize;
      if (currentSize === undefined || currentSize === null) currentSize = "12pt Lato, sans-serif"; // 默认 48pt
      let newSize = parseFloat(currentSize) + delta;
      // 限制6~1000pt
      newSize = Math.min(Math.max(newSize, 6), 1000);
      diagram.model.setDataProperty(data, "fontSize", newSize + "pt Lato, sans-serif");
    } else if (selected instanceof go.Link) {
      // 修改链接文字大小
      const data = selected.data;
      let currentSize = data.fontSize;
      if (currentSize === undefined || currentSize === null) currentSize = "12pt Lato, sans-serif"; // 默认 22pt
      let newSize = parseFloat(currentSize) + delta;
      // 限制6~60pt
      newSize = Math.min(Math.max(newSize, 6), 1000);
      diagram.model.setDataProperty(data, "fontSize", newSize + "pt Lato, sans-serif");
    }
  };

  const changeTextBackground = (color: string) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    if (!selected) return;
    let nodeData = null;
    if (selected instanceof go.Node) {
      nodeData = selected.data;
    } else if (curTube) {
      nodeData = curTube;
    }

    // 更新文字背景色
    if (nodeData) {
      diagram.model.setDataProperty(nodeData, "textBackground", color);
    }
  };

  const changePoint = (dx: number, dy: number) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    if (!(selected instanceof go.Node)) return;
    const data = selected.data;
    if (!data) return;

    let point = data.point;
    if (!point || !Array.isArray(point)) point = [0.5, 1.2]; // 默认位置

    let newX = point[0] + dx;
    let newY = point[1] + dy;
    // 限制范围：X 0~1，Y 0~2
    // newX = Math.min(Math.max(newX, 0), 1);
    // newY = Math.min(Math.max(newY, 0), 2);

    diagram.model.setDataProperty(data, "point", [newX, newY]);
  };

  const changeTextColor = (color: string) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    if (!selected) return;
    let targetData = null;
    if (selected instanceof go.Node || selected instanceof go.Link) {
      targetData = selected.data;
    } else if (curTube) {
      targetData = curTube;
    }
    // 更新文字颜色
    if (targetData) {
      diagram.model.setDataProperty(targetData, "textColor", color);
    }
  };

  const saveParams = () => {
    // console.log("localParamValues:", localParamValues);

    if (diagramInstance.current) {
      const selectedPart = diagramInstance.current.selection.first();
      let partData;

      if (!selectedPart && openNode) {
        let diagram = diagramInstance.current;
        let dataArrays = diagram.model[openNode.nodeName ? "nodeDataArray" : "linkDataArray"];
        partData = dataArrays.find((item) => item.key === openNode.key);
      } else {
        partData = selectedPart.data;
      }

      // if (selectedPart) {
      //   if (selectedPart.data)
      //   {
      if (true) {
        if (true) {
          //更新图元数据

          //字符串转数字
          for (let key in localParamValues) {
            let engName = localParamValues[key].engName;
            if (dataTypeMap[engName] === "number" && localParamValues[key].value) {
              let newValue = Number(localParamValues[key].value);
              if (!Number.isNaN(newValue)) {
                localParamValues[key].value = newValue;
              }
            }
          }
          diagramInstance.current?.model.setDataProperty(partData, "ParamValues", localParamValues);

          if (partData.type === "comments") {
            diagramInstance.current?.model.setDataProperty(
              partData,
              "text",
              localParamValues?.["说明文本"].value ?? "",
            );
          }

          setModalVisible(false);
          setIsNowNeedOpenPramDrawer(false);
          setDialogSelectButton(null);
          setModalParams(null);
          setLocalParamValues({});
        } else {
          messageApi.open({
            type: "error",
            content: "保存失败",
          });
        }
      } else {
        messageApi.open({
          type: "error",
          content: "保存失败",
        });
      }
    } else {
      messageApi.open({
        type: "error",
        content: "保存失败",
      });
    }
  };

  const saveField = () => {
    if (diagramInstance.current) {
      const selectedPart = diagramInstance.current.selection.first();
      let partData;

      if (!selectedPart && openNode) {
        let diagram = diagramInstance.current;
        let dataArrays = diagram.model[openNode.nodeName ? "nodeDataArray" : "linkDataArray"];
        partData = dataArrays.find((item) => item.key === openNode.key);
      } else {
        partData = selectedPart.data;
      }

      // if (selectedPart) {
      if (true) {
        //更新图元数据
        Object.entries(localFormData).forEach(([key, value]) => {
          diagramInstance.current?.model.setDataProperty(partData, value.engName, value.value);

          //特殊处理
          if (value.engName === "linkName") {
            diagramInstance.current?.model.setDataProperty(partData, "text", value.value);
          }
          if (value.engName === "nodeName") {
            diagramInstance.current?.model.setDataProperty(partData, "text", value.value);
          }
        });
        setModal2Data(null);
        setElementPage(null);
        setLocalFormData({});
      }
    }
  };

  const saveMaterials = () => {
    if (diagramInstance.current) {
      const selectedPart = diagramInstance.current.selection.first();
      let partData;

      if (!selectedPart && openNode) {
        let diagram = diagramInstance.current;
        let dataArrays = diagram.model[openNode.nodeName ? "nodeDataArray" : "linkDataArray"];
        partData = dataArrays.find((item) => item.key === openNode.key);
      } else {
        partData = selectedPart.data;
      }

      // if (selectedPart) {
      if (true) {
        let newMaterialsData = {};
        Object.entries(localMaterialsData).forEach(([key, value]) => {
          //字符串转数字
          if (!Number.isNaN(value.molar_frac)) {
            value.molar_frac = Number(value.molar_frac);
          }

          newMaterialsData[key] = {
            molar_frac: value.molar_frac,
            desValue: value.desValue,
            cas: value.cas,
            name: value.name,
            chineseName: value.chineseName,
          };
        });
        diagramInstance.current?.model.setDataProperty(partData, "materials", newMaterialsData);

        setMaterialsData(null);
        setLocalMaterialsData({});
      }
    }
  };

  const openInputParams = (diagram: any, node1?: any) => {
    let node;
    if (node1) {
      node = node1;
    } else {
      node = diagram.selection.first().ub;
    }

    if (node.elementName !== undefined) {
      let name = node.elementName;
      let type = node.type;
      let params = [];

      //元件基础数据
      let newModal2Data = {
        元件名称: { value: node.nodeName, engName: "nodeName", show: true },
        物性计算方法: {
          value: node.physical_method !== undefined ? node.physical_method : "NRTL",
          engName: "physical_method",
          show: true,
          enum: [
            { label: "NRTL", value: "NRTL" },
            { label: "SRK", value: "SRK" },
          ],
        },
        相态: {
          value: node.phase !== undefined ? node.phase : "L",
          engName: "phase",
          show: true,
          enum: [
            { label: "L-液相", value: "L" },
            { label: "V-汽相", value: "V" },
            { label: "VL-汽液两相", value: "VL" },
          ],
        },
        计算模式: {
          //计算模式不显示，提交时固定默认值 TP
          value: "TP",
          engName: "mode",
          show: false,
          enum: [
            { label: "TP-温压闪蒸", value: "TP" },
            { label: "VP-汽化率压力闪蒸", value: "VP" },
            { label: "HP-压焓闪蒸", value: "HP" },
          ],
        },
        描述: {
          value: node.description !== undefined ? node.description : "",
          engName: "description",
          show: false,
        },
      };

      //元件参数
      if (element.filter((item: any) => item.typeID == type).length > 0) {
        params = element.filter((item: any) => item.typeID == type)[0].params;
      }
      if (elementsDatas[type] !== undefined) {
        if (elementsDatas[type].filter((item: any) => item.name == name).length > 0) {
          let extraParams = elementsDatas[type].filter((item: any) => item.name == name)[0].params;
          if (extraParams.length > 0) {
            params = params.concat(extraParams);
          }
        }
      }
      //根据p_type找单位
      for (let i = 0; i < params.length; i++) {
        if (params[i].p_type) {
          if (unitMap[params[i].p_type]) {
            params[i].p_unit = unitMap[params[i].p_type];
          }
        }
      }

      //排序，有子的放在最下面
      params = [
        ...params.filter((item) => !item.hasOwnProperty("p_children")),
        ...params.filter((item) => item.hasOwnProperty("p_children")),
      ];

      if (params.length > 0 && Object.keys(newModal2Data).length > 0) {
        setModalParams(params);
        setModal2Data(newModal2Data);
        setSelectElement(node.text ? node.text : "");
        setReadonlyNodeParamValues(node.ParamValues);
        setOpenNode(node);
        setSelectedElementData(buildSelectedElementData(node));
        setModalVisible(true);
        closeOtherDrawer("paramsDrawer");
        setDialogSelectButton("设备");

        let newIcon = structuredClone(node.icon);
        newIcon = newIcon.replace("high", "origin");
        newIcon = newIcon.replace("green", "origin");
        setElementPage(newIcon);

        // console.log("params:", params);
        // console.log("modal2Data:", newModal2Data);
        // console.log("diagram:", JSON.parse(diagram.model.toJson()));

        //initializeLocalParamValues(params,newModal2Data,node.ParamValues,node.key,JSON.parse(diagram.model.toJson()).linkDataArray,node.text);
      } else {
        if (Object.keys(newModal2Data).length > 0) //仅有基础参数（阀门）
        {
          setModalParams(params);
          setModal2Data(newModal2Data);
          setSelectElement(node.text ? node.text : "");
          setReadonlyNodeParamValues(node.ParamValues);
          setOpenNode(node);
          setSelectedElementData(buildSelectedElementData(node));
          setModalVisible(true);
          closeOtherDrawer("paramsDrawer");
          setDialogSelectButton("设备");

          let newIcon = structuredClone(node.icon);
          newIcon = newIcon.replace("high", "origin");
          newIcon = newIcon.replace("green", "origin");
          setElementPage(newIcon);
        } else {
          const allLinks = diagram.model.linkDataArray;
          allLinks.forEach((link: any) => {
            changeLinkBackground(link, "transparent");
          });

          let taskNodes = null;
          if (taskListRef.current) {
            let jobId = selectedItemRef.current.job_id;
            let taskData = taskListRef.current.find((item) => item.job_id === jobId);
            if (taskData) {
              if (taskData.elements.length > 0) {
                taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
                taskNodes = taskNodes.map((obj) => obj["data"]);
              }
            }
          }

          const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
          allNodes.forEach((selectNode: any) => {
            let newIcon = selectNode.icon;
            if (newIcon.includes("high")) {
              newIcon = newIcon.replace("high", "origin");
            }

            if (taskNodes) {
              let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
              if (taskSelectNode) {
                if (newIcon.includes("origin") && taskSelectNode.isRun) {
                  newIcon = newIcon.replace("origin", "green");
                }
              }
            }
            changeNodeIcon(selectNode, newIcon);
          });

          messageApi.open({
            type: "error",
            content: "配置文件参数长度有误",
          });
        }
      }
    } else if (node.linkName !== undefined) {
      //流股基础数据
      let newModal2Data = {
        流股名称: { value: node.linkName, engName: "linkName", show: true },
        描述: {
          value: node.description !== undefined ? node.description : "",
          engName: "description",
          show: false,
        },
      };

      //流股组分摩尔分率
      let newMaterialsData = {};
      for (let i = 0; i < globalData.materials.length; i++) {
        let name = globalData.materials[i].formula;
        let newMaterialsDataValue = {
          molar_frac:
            node?.materials?.[name]?.molar_frac ??
            (node?.materials?.[name]?.molar_frac === 0
              ? node.materials[name].molar_frac
              : materialsValueMap[name]
                ? materialsValueMap[name]
                : ""),
          desValue:
            node?.materials?.[name]?.desValue ??
            (node?.materials?.[name]?.desValue === 0
              ? node.materials[name].desValue
              : materialsValueMap[name]
                ? materialsValueMap[name]
                : ""),
          cas: globalData.materials[i].cas_code,
          name: globalData.materials[i].formula,
          chineseName: globalData.materials[i].name,
        };
        newMaterialsData[name] = newMaterialsDataValue;
      }

      //流股参数
      let params = streamsBasicParams;
      if (params.length > 0 && Object.keys(newModal2Data).length > 0) {
        setModalParams(params);
        setModal2Data(newModal2Data);
        setMaterialsData(newMaterialsData);
        setSelectElement(node.text ? node.text : "");
        setReadonlyNodeParamValues(node.ParamValues);
        setOpenNode(node);
        setSelectedElementData(buildSelectedElementData(node));
        setModalVisible(true);
        closeOtherDrawer("paramsDrawer");
        setDialogSelectButton("流股");

        // console.log("params:", params);
        // console.log("modal2Data:", newModal2Data);
        // console.log("materialsData:", newMaterialsData);

        //initializeLocalParamValues(params,newModal2Data,node.ParamValues,node.key,JSON.parse(diagram.model.toJson()).linkDataArray,node.text);
      } else {
        const allLinks = diagram.model.linkDataArray;
        allLinks.forEach((link: any) => {
          changeLinkBackground(link, "transparent");
        });

        let taskNodes = null;
        if (taskListRef.current) {
          let jobId = selectedItemRef.current.job_id;
          let taskData = taskListRef.current.find((item) => item.job_id === jobId);
          if (taskData) {
            if (taskData.elements.length > 0) {
              taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
              taskNodes = taskNodes.map((obj) => obj["data"]);
            }
          }
        }

        const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
        allNodes.forEach((selectNode: any) => {
          let newIcon = selectNode.icon;
          if (newIcon.includes("high")) {
            newIcon = newIcon.replace("high", "origin");
          }

          if (taskNodes) {
            let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
            if (taskSelectNode) {
              if (newIcon.includes("origin") && taskSelectNode.isRun) {
                newIcon = newIcon.replace("origin", "green");
              }
            }
          }
          changeNodeIcon(selectNode, newIcon);
        });

        messageApi.open({
          type: "error",
          content: "配置文件参数长度有误",
        });
      }
    } else {
      const allLinks = diagram.model.linkDataArray;
      allLinks.forEach((link: any) => {
        changeLinkBackground(link, "transparent");
      });

      let taskNodes = null;
      if (taskListRef.current) {
        let jobId = selectedItemRef.current.job_id;
        let taskData = taskListRef.current.find((item) => item.job_id === jobId);
        if (taskData) {
          if (taskData.elements.length > 0) {
            taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
            taskNodes = taskNodes.map((obj) => obj["data"]);
          }
        }
      }

      const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
      allNodes.forEach((selectNode: any) => {
        let newIcon = selectNode.icon;
        if (newIcon.includes("high")) {
          newIcon = newIcon.replace("high", "origin");
        }

        if (taskNodes) {
          let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
          if (taskSelectNode) {
            if (newIcon.includes("origin") && taskSelectNode.isRun) {
              newIcon = newIcon.replace("origin", "green");
            }
          }
        }
        changeNodeIcon(selectNode, newIcon);
      });

      if (node.type === "comments") {
        setModalParams([
          {
            p_value: node?.ParamValues?.["说明文本"].value ?? "",
            p_name: "说明文本",
            p_engName: "commentsTxt",
            p_show: true,
          },
        ]);
        setSelectElement("标注");
        setReadonlyNodeParamValues(node.ParamValues);
        setOpenNode(node);
        setSelectedElementData(buildSelectedElementData(node));
        setModalVisible(true);
        closeOtherDrawer("paramsDrawer");
        setDialogSelectButton("设备");
      } else {
        messageApi.open({
          type: "error",
          content: "元件/流股异常",
        });
      }
    }
  };

  // 校验名称唯一性
  const checkNameUnique = (
    name: string,
    type: "node" | "link" | "group",
    excludeKey?: string,
  ): boolean => {
    if (!diagramInstance.current) return true;
    const model = diagramInstance.current.model;
    if (type === "node") {
      const nodeDataArray = model.nodeDataArray;
      for (const node of nodeDataArray) {
        if (name !== "") {
          if (node.nodeName === name && node.key !== excludeKey) {
            return false;
          }
        }
      }
    } else if (type === "link") {
      const linkDataArray = (model as go.GraphLinksModel).linkDataArray;
      for (const link of linkDataArray) {
        if (name !== "") {
          if (link.linkName === name && link.key !== excludeKey) {
            return false;
          }
        }
      }
    } else if (type === "group") {
      const nodeDataArray = model.nodeDataArray;
      for (const node of nodeDataArray) {
        if (node.isGroup && node.groupName === name && node.key !== excludeKey) {
          return false;
        }
      }
    }
    return true;
  };

  const getRelatedLinks = (nodeKey: string, direction: "in" | "out") => {
    if (!diagramInstance.current) return [];
    const model = diagramInstance.current.model;
    const linkDataArray = (model as go.GraphLinksModel).linkDataArray;
    return linkDataArray.filter((link) => {
      if (direction === "in") return link.to === nodeKey;
      return link.from === nodeKey;
    });
  };

  const getRelatedLinks2 = (nodeKey: string, direction: "cold" | "hot") => {
    if (!diagramInstance.current) return [];
    const model = diagramInstance.current.model;
    let linkDataArray = (model as go.GraphLinksModel).linkDataArray;

    if (settings.readonly) //只读模式取taskList
    {
      if (selectedItem) {
        let jobId = selectedItem.job_id;
        let task = taskList.find((item) => item.job_id === jobId);
        if (task) {
          linkDataArray = task.streams.map((obj) => obj["data"]);
        }
      }
    }

    let type = direction === "cold" ? "冷流股" : "热流股";
    return linkDataArray.filter((link) => {
      return link.from === nodeKey && link.ParamValues?.["流股属性"]?.value === type;
    });
  };

  const changeLinkBackground = (linkData: any, color: string) => {
    let diagram = diagramInstance.current;
    if (!diagram) return;
    diagram.model.setDataProperty(linkData, "linkBgColor", color);
  };

  const changeLinkFlow = (linkData: any, flowEnabled: boolean) => {
    let diagram = diagramInstance.current;
    if (!diagram) return;
    diagram.model.setDataProperty(linkData, "flowEnabled", flowEnabled);
  };

  const changeNodeIcon = (nodeData: any, icon: string) => {
    let diagram = diagramInstance.current;
    if (!diagram) return;
    diagram.model.setDataProperty(nodeData, "icon", icon);
  };

  const changeGroupVisible = (nodeData: any, visible: boolean) => {
    let diagram = diagramInstance.current;
    if (!diagram) return;
    const allGroups = diagram.model["nodeDataArray"].filter((item) => item.isGroup);
    let groupData = allGroups.find((item) => item.key === nodeData.key);
    if (groupData) {
      diagram.model.setDataProperty(groupData, "visible", visible);
    }
  };

  const clearAllLinkHighlights = () => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const allLinks = diagram.model["linkDataArray"];
    allLinks.forEach((link: any) => {
      changeLinkBackground(link, "transparent");
    });
  };

  const clearAllLinkFlow = () => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const allLinks = diagram.model["linkDataArray"];
    allLinks.forEach((link: any) => {
      changeLinkFlow(link, false);
    });
  };

  const clearAllGroupVisible = () => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const allGroups = diagram.model["nodeDataArray"].filter((item) => item.isGroup);

    allGroups.forEach((item: any) => {
      changeGroupVisible(item, false);
    });

    //为保证数据一致性，清除分组选中状态
    setSelectGroup(null);
  };

  const clearAllNodeHighlights = () => {
    const diagram = diagramInstance.current;
    if (!diagram) return;

    let taskNodes = null;
    if (taskListRef.current) {
      let jobId = selectedItemRef.current.job_id;
      let taskData = taskListRef.current.find((item) => item.job_id === jobId);
      if (taskData) {
        if (taskData.elements.length > 0) {
          taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
          taskNodes = taskNodes.map((obj) => obj["data"]);
        }
      }
    }

    const allNodes = diagram.model["nodeDataArray"].filter((item) => !item.isGroup);
    allNodes.forEach((selectNode: any) => {
      let newIcon = selectNode.icon;
      if (newIcon.includes("high")) {
        newIcon = newIcon.replace("high", "origin");
      }

      if (taskNodes) {
        let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
        if (taskSelectNode) {
          if (newIcon.includes("origin") && taskSelectNode.isRun) {
            newIcon = newIcon.replace("origin", "green");
          }
        }
      }
      changeNodeIcon(selectNode, newIcon);
    });
  };

  const doubleClickEvent = (node, diagram, isRealDoubleClick?) => {
    //等同于双击事件
    if (!node) return;
    if (node.nodeName !== undefined) {
      const allLinks = diagram.model.linkDataArray;
      allLinks.forEach((link: any) => {
        changeLinkBackground(link, "transparent");
      });
      const nodeKey = node.key;
      const relatedLinks = allLinks.filter(
        (link: any) => link.from === nodeKey || link.to === nodeKey,
      );
      relatedLinks.forEach((link: any) => {
        changeLinkBackground(link, "#85e97c"); //高亮颜色
      });

      let taskNodes = null;
      if (taskListRef.current) {
        let jobId = selectedItemRef.current.job_id;
        let taskData = taskListRef.current.find((item) => item.job_id === jobId);
        if (taskData) {
          if (taskData.elements.length > 0) {
            taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
            taskNodes = taskNodes.map((obj) => obj["data"]);
          }
        }
      }

      const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
      allNodes.forEach((selectNode: any) => {
        let newIcon = selectNode.icon;
        // console.log("selectNode:",selectNode);
        if (newIcon.includes("high")) {
          newIcon = newIcon.replace("high", "origin");
        }
        if (taskNodes) {
          let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
          if (taskSelectNode) {
            if (newIcon.includes("origin") && taskSelectNode.isRun) {
              newIcon = newIcon.replace("origin", "green");
            }
          }
        }
        changeNodeIcon(selectNode, newIcon);
      });

      const selectNodes = diagram.model.nodeDataArray.filter((item) => item.key === nodeKey);
      selectNodes.forEach((selectNode: any) => {
        let newIcon = selectNode.icon;
        if (newIcon.includes("origin")) {
          newIcon = newIcon.replace("origin", "high");
        } else if (newIcon.includes("green")) {
          newIcon = newIcon.replace("green", "high");
        }
        changeNodeIcon(selectNode, newIcon);
      });
    } else if (node.linkName !== undefined) {
      const allLinks = diagram.model.linkDataArray;
      allLinks.forEach((link: any) => {
        changeLinkBackground(link, "transparent");
      });
      const relatedLinks = allLinks.filter((link: any) => link.linkName === node.linkName);
      relatedLinks.forEach((link: any) => {
        changeLinkBackground(link, "#85e97c"); //高亮颜色
      });

      let taskNodes = null;
      if (taskListRef.current) {
        let jobId = selectedItemRef.current.job_id;
        let taskData = taskListRef.current.find((item) => item.job_id === jobId);
        if (taskData) {
          if (taskData.elements.length > 0) {
            taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
            taskNodes = taskNodes.map((obj) => obj["data"]);
          }
        }
      }

      const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
      allNodes.forEach((selectNode: any) => {
        let newIcon = selectNode.icon;
        if (newIcon.includes("high")) {
          newIcon = newIcon.replace("high", "origin");
        }

        if (taskNodes) {
          let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
          if (taskSelectNode) {
            if (newIcon.includes("origin") && taskSelectNode.isRun) {
              newIcon = newIcon.replace("origin", "green");
            }
          }
        }
        changeNodeIcon(selectNode, newIcon);
      });
    }

    if (isRealDoubleClick) {
      openInputParams(diagram, node);
    }
  };

  const openGroup = (node) => {
    if (node.isGroup === true) {
      let groupName = node.groupName;
      let groupKey = node.key;
      let params = [];

      //分组基础数据
      let newModal2Data = {
        分组名称: { value: groupName, engName: "groupName", show: true },
        描述: {
          value: node.description !== undefined ? node.description : "",
          engName: "description",
          show: false,
        },
      };

      //分组参数
      params = element.find((item: any) => item.typeID === "group").params;

      if (params.length > 0 && Object.keys(newModal2Data).length > 0) {
        setModalParams(params);
        setModal2Data(newModal2Data);
        setSelectElement(groupName ?? "");
        // setReadonlyNodeParamValues(node.ParamValues);
        // setOpenNode(node);
        setSelectedElementData(buildSelectedElementData(node));
        setModalVisible(true);
        closeOtherDrawer("paramsDrawer");
        // setDialogSelectButton("设备");
      }
    }
  };

  // 更新所有连接线的 group 属性
  const updateLinksGroup = useCallback((diagram: go.Diagram) => {
    if (!diagram || updatingLinksRef.current) return;
    updatingLinksRef.current = true;
    try {
      const model = diagram.model as go.GraphLinksModel;
      const nodeDataArray = model.nodeDataArray;
      const linkDataArray = model.linkDataArray;

      // 构建节点 key -> group 映射（忽略分组节点自身）
      const nodeGroupMap: { [key: string]: number | null } = {};
      nodeDataArray.forEach((node) => {
        if (!node.isGroup) {
          // 如果节点有 group 属性，取它的值，否则为 null
          nodeGroupMap[node.key] = node.group !== undefined ? node.group : null;
        }
      });

      // 遍历所有连接线
      linkDataArray.forEach((link) => {
        const fromGroup = nodeGroupMap[link.from] ?? null;
        const toGroup = nodeGroupMap[link.to] ?? null;
        const newGroup = [fromGroup, toGroup];

        // 检查当前 group 是否已经是这个数组
        const currentGroup = link.group;
        let needUpdate = false;
        if (Array.isArray(currentGroup)) {
          if (
            currentGroup.length !== 2 ||
            currentGroup[0] !== newGroup[0] ||
            currentGroup[1] !== newGroup[1]
          ) {
            needUpdate = true;
          }
        } else {
          needUpdate = true;
        }

        if (needUpdate) {
          model.setDataProperty(link, "group", newGroup);
        }
      });
    } finally {
      updatingLinksRef.current = false;
    }
  }, []);

  //根据名称查询默认值
  const buildDefaultValues = (elementName: string, elementType: string) => {
    if (!modalParams || !modal2Data) {
      messageApi.open({ type: "error", content: "弹窗数据不完整" });
      return;
    }

    const targetArray = test_Rectisol?.inputs?.[elementType];
    if (!targetArray) {
      messageApi.open({ type: "error", content: "未找到对应的默认值数据" });
      return;
    }
    const target = targetArray.find((item) => item.name === elementName);
    if (!target) {
      messageApi.open({ type: "error", content: `未找到 "${elementName}" 的默认值` });
      return;
    }

    //处理流股组分
    if (elementType === "streams" && localMaterialsData && typeof localMaterialsData === "object") {
      const defaultMaterials = target.materials; // 数组
      if (Array.isArray(defaultMaterials) && defaultMaterials.length > 0) {
        const newMaterials = { ...localMaterialsData };
        // 遍历当前已有的组分（键为组分名称）
        Object.keys(newMaterials).forEach((key) => {
          const matched = defaultMaterials.find((item) => item.name === key);
          if (matched) {
            newMaterials[key] = {
              ...newMaterials[key],
              molar_frac: matched.molar_frac,
              desValue: matched.molar_frac,
            };
          }
          // 若未匹配则保留原值，不做任何改动
        });
        setLocalMaterialsData(newMaterials);
      }
    }

    const newParamValues = JSON.parse(JSON.stringify(localParamValues));

    modalParams.forEach((param) => {
      const paramName = param?.p_name;
      const engName = param?.p_engName;
      if (!paramName || !engName) return;

      const defaultValue = target.params?.[engName];

      if (param.p_children && Array.isArray(param.p_children) && param.p_children.length > 0) {
        // 带子项的参数需要特殊处理
        const selectedNode = diagramInstance.current?.selection.first();
        const nodeKey = selectedNode?.data?.key;
        if (!nodeKey) {
          // 无选中节点时保留原样
          return;
        }

        // 根据参数类型获取对应的流股列表
        let links = [];
        if (param.p_engName === "Ns") {
          links = getRelatedLinks(nodeKey, "in");
        } else if (param.p_engName === "No" || param.p_engName === "output_f") {
          links = getRelatedLinks(nodeKey, "out");
        } else if (param.p_engName === "cold_out_T" || param.p_engName === "cold_out_P") {
          links = getRelatedLinks2(nodeKey, "cold");
        } else if (param.p_engName === "hot_out_T" || param.p_engName === "hot_out_P") {
          links = getRelatedLinks2(nodeKey, "hot");
        } else if (param.p_engName === "streamRelationship") {
          links = getRelatedLinks(nodeKey, "out");
        } else {
          // 其他带子项的参数（如 stream_type）直接使用默认值对象
          const childObj = {};
          param.p_children.forEach((childParam) => {
            const childEngName = childParam.p_engName;
            const childVal = defaultValue?.[childEngName] ?? childParam.p_value ?? null;
            childObj[childParam.p_name] = {
              ...(newParamValues[paramName]?.p_children?.[0]?.[childParam.p_name] || {}),
              value: childVal,
              desValue: childVal,
            };
          });
          if (Object.keys(childObj).length) {
            newParamValues[paramName] = {
              ...newParamValues[paramName],
              p_children: [childObj],
            };
          }
          return;
        }

        // 对于有流股列表的参数，重新生成子项
        const streamNames = links.map((link) => link.text || link.linkName || "");
        const newChildren = streamNames.map((streamName, index) => {
          // 分流器“输出流量”：非摩尔分率（frac）时最后一个输出流股留空，保证“有且仅有一个为空”
          const isOutputFLast =
            param.p_engName === "output_f" &&
            target.params?.f_unit !== "frac" &&
            index === streamNames.length - 1;
          const val = isOutputFLast
            ? ""
            : Array.isArray(defaultValue)
              ? (defaultValue[index] ?? null)
              : null;
          const fieldKey =
            param.p_engName === "Ns"
              ? "进料位置"
              : param.p_engName === "No"
                ? "出料位置"
                : param.p_engName === "output_f"
                  ? "输出流量"
                  : param.p_engName.includes("cold_out_T") || param.p_engName.includes("hot_out_T")
                    ? "出口温度"
                    : param.p_engName.includes("cold_out_P") ||
                        param.p_engName.includes("hot_out_P")
                      ? "出口压力"
                      : param.p_engName === "streamRelationship"
                        ? "入口流股"
                        : "";

          // 构建子项对象
          const child = {
            流股: {
              value: streamName,
              desValue: streamName,
              show: true,
              engName: "streamName",
              readonly: true,
            },
          };
          if (fieldKey) {
            child[fieldKey] = {
              ...(newParamValues[paramName]?.p_children?.[index]?.[fieldKey] || {}),
              value: val,
              desValue: val,
            };
            // 如果是温度/压力，保留单位
            if (param.p_engName.includes("cold_out_T") || param.p_engName.includes("hot_out_T")) {
              const unit =
                unitMap[param.p_children.find((p) => p.p_engName === "出口温度")?.p_type]?.[0] ||
                "";
              child[fieldKey].unit = unit;
            } else if (
              param.p_engName.includes("cold_out_P") ||
              param.p_engName.includes("hot_out_P")
            ) {
              const unit =
                unitMap[param.p_children.find((p) => p.p_engName === "出口压力")?.p_type]?.[0] ||
                "";
              child[fieldKey].unit = unit;
            }
            // streamRelationship 需要枚举
            if (param.p_engName === "streamRelationship") {
              const inLinks = getRelatedLinks(nodeKey, "in");
              const inLinkEnums = inLinks.map((l) => ({
                label: l.linkName || "",
                value: l.linkName || "",
              }));
              child[fieldKey].enum = inLinkEnums;
            }
          }
          return child;
        });

        newParamValues[paramName] = {
          show: param.p_show,
          engName: param.p_engName,
          p_children: newChildren,
        };
      } else if (param.enum && Array.isArray(param.enum) && param.enum.length > 0) {
        // 枚举类型
        let val = defaultValue;
        const exists = param.enum.some((item) => item.value === val);
        if (!exists) val = param.enum[0]?.value;
        newParamValues[paramName] = {
          ...newParamValues[paramName],
          value: val,
          desValue: val,
        };
      } else {
        // 普通参数（有单位或无单位）
        const val = defaultValue ?? param.p_value ?? null;
        newParamValues[paramName] = {
          ...newParamValues[paramName],
          value: val,
          desValue: val,
        };
      }
    });

    // 特殊显示逻辑（与 useEffect 一致）
    if (
      newParamValues["流股属性"] &&
      newParamValues["冷流股出口温度"] &&
      newParamValues["热流股出口温度"]
    ) {
      const attr = newParamValues["流股属性"].value;
      newParamValues["冷流股出口温度"].show = attr === "冷流股";
      newParamValues["热流股出口温度"].show = attr === "热流股";
    }
    if (
      newParamValues["流股属性"] &&
      newParamValues["冷流股出口压力"] &&
      newParamValues["热流股出口压力"]
    ) {
      const attr = newParamValues["流股属性"].value;
      newParamValues["冷流股出口压力"].show = attr === "冷流股";
      newParamValues["热流股出口压力"].show = attr === "热流股";
    }
    if (
      newParamValues["流股属性"] &&
      newParamValues["冷流出口温度"] &&
      newParamValues["热流出口温度"]
    ) {
      const attr = newParamValues["流股属性"].value;
      newParamValues["冷流出口温度"].show = attr === "冷流股";
      newParamValues["热流出口温度"].show = attr === "热流股";
    }
    if (
      newParamValues["流股属性"] &&
      newParamValues["冷流出口压力"] &&
      newParamValues["热流出口压力"]
    ) {
      const attr = newParamValues["流股属性"].value;
      newParamValues["冷流出口压力"].show = attr === "冷流股";
      newParamValues["热流出口压力"].show = attr === "热流股";
    }
    if (newParamValues["内部类型"] && newParamValues["塔盘类型"] && newParamValues["填料类型"]) {
      const type = newParamValues["内部类型"].value;

      newParamValues["塔盘类型"].show = type === "塔板" || type === "混合";
      // newParamValues["塔板数"].show = (type === "塔板" || type === "混合");
      newParamValues["有效孔面积比"].show = type === "塔板" || type === "混合";
      newParamValues["堰高"].show = type === "塔板" || type === "混合";
      newParamValues["塔板材质"].show = type === "塔板" || type === "混合";
      newParamValues["溢流类型"].show = type === "塔板" || type === "混合";

      newParamValues["填料类型"].show = type === "填料" || type === "混合";
      newParamValues["填料高度"].show = type === "填料" || type === "混合";
    }
    if (modal2Data["计算模式"] && newParamValues["温度"] && newParamValues["汽相分率"]) {
      const mode = modal2Data["计算模式"].value;
      newParamValues["温度"].show = mode === "TP";
      newParamValues["汽相分率"].show = mode === "VP" || mode === "HP";
    }

    setLocalParamValues(newParamValues);
    messageApi.open({ type: "success", content: "已应用默认值" });
  };

  // 保存当前所有连接线的 points（按 link data key 存储）
  const saveAllLinkPoints = (diagram) => {
    const map = new Map();
    diagram.links.each((link) => {
      if (link.data && link.data.key) {
        map.set(link.data.key, link.points.copy());
      }
    });
    return map;
  };

  // 恢复连接线的 points（传入保存的 map）
  const restoreAllLinkPoints = (diagram, pointsMap) => {
    diagram.links.each((link) => {
      if (link.data && pointsMap.has(link.data.key)) {
        link.points = pointsMap.get(link.data.key);
      }
    });
  };

  useImperativeHandle(props.diagramsRef, () => ({
    clearAllLinkHighlights,
    clearAllNodeHighlights,
    clearAllLinkFlow,
    clearAllGroupVisible,
  }));

  /** 构造一个“特殊效率”子节点 */
const buildSpecChild=(componentName:any, effValue:any)=>{
  return {
    组分: {
      value: componentName, // spec 元素的 [0] - 1 对应组分
      show: true,
      engName: "组分",
      readonly: true,
    },
    效率值: {
      value: effValue, // spec 元素的 [1]
      desValue: String(effValue),
      show: true,
      engName: "效率值",
    },
  };
}

/** 填充一条塔板效率记录 */
const fillEffChild=(child:any, effItem:any)=>{
  if (!child || !effItem) return;
  child["起始塔板"].value = effItem.start;
  child["结束塔板"].value = effItem.end;
  child["效率值"].value = effItem.value;

  const specNode = child["特殊效率"];
  if (!specNode) return;

  const spec = effItem.spec;
  if (!Array.isArray(spec) || spec.length === 0) {
    // 情况（1）：spec 为空数组
    specNode.value = [];
    specNode.children = [];
  } else {
    // 情况（2）：spec 非空，格式 [[组分索引, 效率值], ...]
    specNode.value = spec;
    const ms=globalData.materials.map((m)=>m.name)
    specNode.children = spec.map(([idx, val]) =>
      buildSpecChild(ms[idx - 1], val)
    );
  }
}

//返回最新的图元数据
const fillResult=(result:any, inputs:any)=>{
  for (const key of Object.keys(result)) {
    const node = result[key];
    if (!node || typeof node !== "object") continue;

    const engName = node.engName;
    if (!engName) continue;

    // inputs.json 中不存在该键 -> 跳过
    if (!(engName in inputs)) continue;
    const found = inputs[engName];

    // 规则 2：Ns / No —— 按索引替换进出料位置
    if (engName === "Ns" || engName === "No") {
      if (!Array.isArray(found) || !Array.isArray(node.p_children)) continue;
      const posKey = engName === "Ns" ? "进料位置" : "出料位置";
      found.forEach((v, i) => {
        const child = node.p_children[i];
        if (child && child[posKey]) {
          child[posKey].value = v;
        }
      });
      continue;
    }

    // 规则 3：eff —— 塔板效率
    if (engName === "eff") {
      if (!Array.isArray(found) || !Array.isArray(node.p_children)) continue;
      found.forEach((effItem, x) => {
        fillEffChild(node.p_children[x], effItem);
      });
      continue;
    }

    // 规则 1：数字或字符串 -> 赋值 value
    if (typeof found === "number" || typeof found === "string") {
      node.value = found;
    }
    // 其他类型（数组、对象、null 等）按“没找到/不可填”处理，跳过
  }
  return result;
}

  //参数抽屉确认事件
  const paramsDrawerConfirm = async (oldParams) => {
    // console.log('oldParams',oldParams);
    // 从传入参数解构数据
    const {
      localFormData: formData,
      localParamValues: paramValues,
      localMaterialsData: materialsData,
    } = oldParams;

    // 校验是否允许保存
    if (!saveAbled) {
      messageApi.open({
        type: "error",
        content: "保存失败：数据非法",
      });
      return;
    }

    // 获取当前选中的图元数据
    let selectedPart = diagramInstance.current?.selection.first();

    let partData;
    if (!selectedPart && openNode) {
      let diagram = diagramInstance.current;
      let dataArrays = diagram.model[openNode.nodeName ? "nodeDataArray" : "linkDataArray"];
      partData = dataArrays.find((item) => item.key === openNode.key);
    } else {
      partData = selectedPart?.data;
    }

    if (!partData) {
      messageApi.open({ type: "error", content: "未选中任何图元" });
      return;
    }

    const localKey = partData.key;
    const localType = partData.type ?? "";

  

    // const t106Key=selectedPart.data.nodeName === "S-16"?diagramInstance.current.model["nodeDataArray"].find((s) => s.nodeName === "T-106").key:null;
    // const t106Type='DistilStrict'

    // const t106key=

    // ---- 保存参数（原 saveParams 逻辑，使用 paramValues） ----
    const saveParams = () => {
      const processedParamValues = { ...paramValues };
      for (const key in processedParamValues) {
        const engName = processedParamValues[key]?.engName;
        if (dataTypeMap[engName] === "number" && processedParamValues[key]?.value) {
          const newValue = Number(processedParamValues[key].value);
          if (!isNaN(newValue)) {
            processedParamValues[key].value = newValue;
          }
        }
      }

      if (partData.nodeName === "S-16") {
        let diagasdram: any = diagramInstance.current.model["nodeDataArray"];
        const t106 = diagasdram.find((s) => s.nodeName === "T-106");
        // openInputParams(t106,t106)

        let jobId = selectedItemRef.current.job_id;
        let taskData = taskListRef.current.find((item:any) => item.job_id === jobId);
        // console.log('taskDatataskDatataskData',taskData);
        // console.log('globalData',globalData);
        //用与任务树相同的逆向映射重建 T-106 参数：eff 等子表参数按后端 input 整表重建，
        //不依赖画布模型里现有的 p_children 行（刚进页面时模型里的 eff 行可能为空）
        const t106paramsvalues = buildNodeDataByInput(
          t106,
          taskData.input,
          "node",
          { curFlow: { global_data: { materials: globalData.materials } } },
          null,
          null,
        ).ParamValues;
        // console.log('任务参数数据',taskData.input.elements.find((i:any)=>i.name==='T-106'));
        // console.log('组合后的数据',t106paramsvalues);

        

        if (t106) {
          let  t106params= { ...t106paramsvalues };


          const sum = processedParamValues["输出流量"].p_children.reduce((acc, item) => {
            const rawVal = item["输出流量"].value;
            const num = Number(rawVal);
            const val = isNaN(num) ? 0 : num;
            return acc + val;
          }, 0);

          if (sum - s16TotalOutput_f >= 0) {
            t106params = {
              ...t106params,
              塔釜采出量: {
                ...t106params['塔釜采出量'],
                value: t106V1 + (sum - s16TotalOutput_f) * 0.95,
              },
            };
          }
          // console.log("1066666", t106);
          // console.log("t106params", t106params);
          // console.log("sum - s16TotalOutput_f", sum - s16TotalOutput_f);
          

          diagramInstance.current?.model.setDataProperty(t106, "ParamValues", t106params);

          setTimeout(() => {
            upTreeData?.(t106, "node", t106.type ?? "");
          }, 100);

        }
      }

      diagramInstance.current?.model.setDataProperty(partData, "ParamValues", processedParamValues);

      if (partData.type === "comments") {
        diagramInstance.current?.model.setDataProperty(
          partData,
          "text",
          processedParamValues["说明文本"]?.value ?? "",
        );
      }
    };

    // ---- 保存基础字段（原 saveField 逻辑，使用 formData） ----
    const saveField = () => {
      console.log("formData", formData);
      Object.entries(formData).forEach(([key, value]: [string, any]) => {
        diagramInstance.current?.model.setDataProperty(partData, value.engName, value.value);
        if (value.engName === "linkName") {
          diagramInstance.current?.model.setDataProperty(partData, "text", value.value);
        }
        if (value.engName === "nodeName") {
          diagramInstance.current?.model.setDataProperty(partData, "text", value.value);
        }
      });
    };

    // ---- 保存组分（原 saveMaterials 逻辑，使用 materialsData） ----
    const saveMaterials = () => {
      const newMaterialsData = {};
      Object.entries(materialsData).forEach(([key, value]: [string, any]) => {
        const molarFrac = Number(value.molar_frac);
        const finalMolar = isNaN(molarFrac) ? value.molar_frac : molarFrac;
        newMaterialsData[key] = {
          molar_frac: finalMolar,
          desValue: value.desValue,
          cas: value.cas,
          name: value.name,
          chineseName: value.chineseName,
        };
      });
      diagramInstance.current?.model.setDataProperty(partData, "materials", newMaterialsData);
    };

    // ---- 关闭抽屉并清理状态（复用原逻辑） ----
    const closeDrawerAndCleanup = () => {
      setModalVisible(false);
      setIsNowNeedOpenPramDrawer(false);
      setDialogSelectButton(null);
      setModalParams(null);
      setModal2Data(null);
      setMaterialsData(null);
      setLocalParamValues({});
      setLocalFormData({});
      setLocalMaterialsData({});
      setClearSelectVariable?.();
      setElementPage(null);
      setSelectedElementData(null);
    };

    // ---- 主逻辑：根据图元类型执行保存 ----
    if (formData["元件名称"] && formData["元件名称"].value !== "") {
      if (!checkNameUnique(formData["元件名称"].value, "node", partData.key)) {
        messageApi.open({ type: "error", content: "元件名称重复" });
        return;
      }
      saveParams();
      saveField();

      const diagram = diagramInstance.current;
      if (diagram) {
        const allLinks = diagram.model["linkDataArray"];
        allLinks.forEach((link) => changeLinkBackground(link, "transparent"));

        let taskNodes = null;
        if (taskListRef.current) {
          const jobId = selectedItemRef.current?.job_id;
          const taskData = taskListRef.current.find((item) => item.job_id === jobId);
          if (taskData && taskData.elements.length > 0) {
            taskNodes = taskData.elements.flatMap((obj) => obj.children).map((child) => child.data);
          }
        }

        const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
        allNodes.forEach((selectNode) => {
          let newIcon = selectNode.icon;
          if (newIcon.includes("high")) {
            newIcon = newIcon.replace("high", "origin");
          }
          if (taskNodes) {
            const taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
            if (taskSelectNode && newIcon.includes("origin") && taskSelectNode.isRun) {
              newIcon = newIcon.replace("origin", "green");
            }
          }
          changeNodeIcon(selectNode, newIcon);
        });
      }

      const newNodes = diagram.model["nodeDataArray"];
      const newNode = newNodes.find((item) => item.key === localKey);
      if (newNode) {
        upTreeData(newNode, "node", localType);
      }

      // 保存流程图数据
      setTimeout(() => saveDiagram?.(), 200);

      // 关闭抽屉并清理状态
      closeDrawerAndCleanup();
    } else if (formData["流股名称"] && formData["流股名称"].value !== "") {
      if (!checkNameUnique(formData["流股名称"].value, "link", partData.key)) {
        messageApi.open({ type: "error", content: "流股名称重复" });
        return;
      }
      saveParams();
      saveMaterials();
      saveField();

      const diagram = diagramInstance.current;
      if (diagram) {
        const allLinks = diagram.model["linkDataArray"];
        allLinks.forEach((link) => changeLinkBackground(link, "transparent"));

        let taskNodes = null;
        if (taskListRef.current) {
          const jobId = selectedItemRef.current?.job_id;
          const taskData = taskListRef.current.find((item) => item.job_id === jobId);
          if (taskData && taskData.elements.length > 0) {
            taskNodes = taskData.elements.flatMap((obj) => obj.children).map((child) => child.data);
          }
        }

        const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);
        allNodes.forEach((selectNode) => {
          let newIcon = selectNode.icon;
          if (newIcon.includes("high")) {
            newIcon = newIcon.replace("high", "origin");
          }
          if (taskNodes) {
            const taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
            if (taskSelectNode && newIcon.includes("origin") && taskSelectNode.isRun) {
              newIcon = newIcon.replace("origin", "green");
            }
          }
          changeNodeIcon(selectNode, newIcon);
        });

        if (partData["ParamValues"]?.["流股属性"]?.value === "冷流股") {
          changeLineColor("#0000FF");
        } else if (partData["ParamValues"]?.["流股属性"]?.value === "热流股") {
          changeLineColor("#FF0000");
        } else if (partData["ParamValues"]?.["流股属性"]?.value === "无") {
          changeLineColor("#000");
        }
      }

      const newLinks = diagram.model["linkDataArray"];
      const newLink = newLinks.find((item) => item.key === localKey);
      if (newLink) {
        upTreeData(newLink, "link", localType);
      }

      setTimeout(() => saveDiagram?.(), 200);

      closeDrawerAndCleanup();
    } else {
      if (localType === "comments") {
        saveParams();
        setTimeout(() => saveDiagram?.(), 200);
        closeDrawerAndCleanup();
      } else if (partData.isGroup) {
        if (formData["分组名称"] && formData["分组名称"].value !== "") {
          if (!checkNameUnique(formData["分组名称"].value, "group", partData.key)) {
            messageApi.open({ type: "error", content: "分组名称重复" });
            return;
          }
          saveParams();
          saveField();
          setTimeout(() => saveDiagram?.(), 200);
          closeDrawerAndCleanup();
        } else {
          messageApi.open({ type: "error", content: "请填写分组名称" });
        }
      } else {
        messageApi.open({ type: "error", content: "请填写名称" });
      }
    }
  };

  //参数抽屉取消事件
  const paramsDrawerCancel = async () => {
    setModalVisible(false);
    setIsNowNeedOpenPramDrawer(false);
    setDialogSelectButton(null);
    setModalParams(null);
    setModal2Data(null);
    setMaterialsData(null);
    setLocalParamValues({});
    setLocalFormData({});
    setLocalMaterialsData({});
    setClearSelectVariable();
    setElementPage(null);
    setSelectedElementData(null);

    //因为树没有取消选中状态，所以点取消按钮也不清除高亮
    //依然保留取消高亮吧
    const diagram = diagramInstance.current;
    if (diagram) {
      const allLinks = diagram.model["linkDataArray"];
      allLinks.forEach((link: any) => {
        changeLinkBackground(link, "transparent");
      });

      const allNodes = diagram.model.nodeDataArray.filter((item) => !item.isGroup);

      let taskNodes = null;
      if (taskListRef.current) {
        let jobId = selectedItemRef.current.job_id;
        let taskData = taskListRef.current.find((item) => item.job_id === jobId);
        if (taskData) {
          if (taskData.elements.length > 0) {
            taskNodes = taskData.elements.map((obj) => obj["children"]).flat();
            taskNodes = taskNodes.map((obj) => obj["data"]);
          }
        }
      }

      allNodes.forEach((selectNode: any) => {
        let newIcon = selectNode.icon;
        if (newIcon.includes("high")) {
          newIcon = newIcon.replace("high", "origin");
        }

        if (taskNodes) {
          let taskSelectNode = taskNodes.find((item) => item.nodeName === selectNode.nodeName);
          if (taskSelectNode) {
            if (newIcon.includes("origin") && taskSelectNode.isRun) {
              newIcon = newIcon.replace("origin", "green");
            }
          }
        }

        changeNodeIcon(selectNode, newIcon);
      });
    }
  };

  const showSubJobIcon = (status: string, covered: any) => {
    if (status === "done") {
      if (covered === false) {
        return <span style={{ color: statusColor.uncovered, fontSize: 16 }}>(未收敛)</span>;
        // <WarningFilled style={{ color: `${statusColor.uncovered}`, fontSize: 16 }} />;
      } else {
        return <CheckCircleFilled style={{ color: `${statusColor[status]}`, fontSize: 16 }} />;
      }
    } else if (status === "error") {
      return <WarningFilled style={{ color: `${statusColor[status]}`, fontSize: 16 }} />;
    } else {
      return <LoadingOutlined style={{ color: `${statusColor[status]}`, fontSize: 16 }} />;
    }
  };

  return (
    <>
      {contextHolder}
      {dataSource && (
        <div id="editor" style={{ position: "relative" }}>
          <ReactDiagram
            initDiagram={() => {
              // 创建diagram实例

              const diagram: any = $(go.Diagram, {
                allowMove: true,
                "commandHandler.archetypeGroupData": {
                  groupName: "Group",
                  isGroup: true,
                  color: "blue",
                },
                "undoManager.isEnabled": true,
                // 确保滚轮缩放功能正常工作
                "toolManager.mouseWheelBehavior": go.ToolManager.WheelZoom,
                "linkingTool.isUnconnectedLinkValid": true,
                "relinkingTool.isUnconnectedLinkValid": true,
                // 启用自动平移和缩放功能
                // "toolManager.dragSelectingTool.isEnabled": true,
                scrollMode: go.Diagram.InfiniteScroll,
                isReadOnly: settings.readonly,
                // 确保允许链接操作
                allowLink: true,
                allowRelink: true,
                // 添加初始事件监听器
                initialContentAlignment: go.Spot.Center,
                contextMenu: null,
                // 确保图表使用正确的坐标系统和缩放范围
                // scale: 1.0,
                // minScale: 0.1,
                // maxScale: 5.0
              });

              // 立即响应悬停
              diagram.toolManager.hoverDelay = 10;

              // 在实例化后设置复制粘贴权限
              diagram.allowCopy = false;
              diagram.allowPaste = false;

              // 初始配置由updateDiagramReadOnlyState函数统一管理

              // 设置模板和模型属性
              setupTemplates(diagram);

              updateLinksGroup(diagram);

              diagram.commandHandler.groupSelection = function () {
                const diagram = this.diagram;
                // 保存所有连接线当前路径
                const pointsMap = saveAllLinkPoints(diagram);

                // 调用默认分组逻辑
                const result = go.CommandHandler.prototype.groupSelection.call(this);

                if (result) {
                  // 恢复路径（确保在分组布局完成后执行）
                  // 用 requestAnimationFrame 或 setTimeout 延后恢复，防止被后续布局覆盖
                  requestAnimationFrame(() => {
                    restoreAllLinkPoints(diagram, pointsMap);
                  });
                }
                return result;
              };

              diagram.commandHandler.ungroupSelection = function () {
                const diagram = this.diagram;
                const pointsMap = saveAllLinkPoints(diagram);
                const result = go.CommandHandler.prototype.ungroupSelection.call(this);
                if (result) {
                  requestAnimationFrame(() => {
                    restoreAllLinkPoints(diagram, pointsMap);
                  });
                }
                return result;
              };

              // 调用初始化回调函数，将diagram实例传递给父组件
              onDiagramInitialized(diagram);

              // 设置初始只读状态
              updateDiagramReadOnlyState(diagram, settings.readonly);

              return diagram;
            }}
            divClassName="diagramArea"
            nodeDataArray={dataSource.nodeDataArray || []}
            linkDataArray={dataSource.linkDataArray || []}
            // modelData={{"position": "0 0"}}
            // 添加onModelChange属性以确保模型变化时正确更新
            onModelChange={(e) => {
              // 当模型变化时，可以在这里添加额外的处理逻辑
              // console.log("Model changed:", e);
              //更新分组数据
              if (diagramInstance.current) {
                const nodeDataArray = diagramInstance.current.model.nodeDataArray;
                let newGroups = nodeDataArray.filter((item) => item.isGroup === true);
                setGroups(newGroups);
                updateLinksGroup(diagramInstance.current);
              }
            }}
            style={{ height: pageHeight, border: "0px solid #BBB", margin: 0 }}
          />

          {/* 分组功能，勿删（分组按钮） */}
          {/* <div
            style={{
              position: "absolute",
              top:0,
              left:0,
              height: 25,
              backgroundColor: "#eee",
              borderBottom: "1px solid #ccc",
              zIndex: 100,
              paddingLeft:15,
              display: groups.length>0 ? "block" : "none",
            }}
          >
            {groups.map((item) => (
              <button
                onClick={()=>{
                  if(selectGroup)
                  {
                    if(selectGroup.key===item.key)
                    {
                      setSelectGroup(null);
                    }
                    else
                    {
                      setSelectGroup(item);
                    }
                  }
                  else
                  {
                    setSelectGroup(item);
                  }
                }}
                style={{
                  width:100,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth:selectGroup?.key===item.key?"0 0 0 0":"0 1px 0 0",
                  background:selectGroup?.key===item.key?"#BBB":"#EEE",
                  color:selectGroup?.key===item.key?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                {item.groupName}
              </button>
            ))}
          </div> */}

          <div
            ref={overviewContainerRef}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              width: 150,
              height: 100,
              backgroundColor: "#FFF",
              border: "1px solid #ccc",
              zIndex: 100,
              display: overview ? "block" : "none",
            }}
          />
        </div>
      )}
      <div ref={menuRef} style={{ position: "absolute", zIndex: 1000, display: "none" }}>
        <ul className="nodeMenu">
          <li id="changeTubeType" className="link">
            {isLinkSelected && !settings.readonly && (
              <div
                className="changeTubeType"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  background: "#FFF",
                  border: "1px solid #BBB",
                }}
              >
                {/* <Button 
                  onClick={() =>{if(diagramInstance.current){openInputParams(diagramInstance.current);}}}
                  type="text"
                  style={{marginTop:10,marginBottom:10,width:100,height:40,borderRadius:0}}
              >参数信息</Button> */}
                <div>
                  <ColorPicker
                    onChange={(color) => {
                      changeLineColor(color.toHexString());
                    }}
                  >
                    <Button
                      type="text"
                      style={{
                        width: 150,
                        height: 30,
                        borderRadius: 0,
                        fontSize: 12,
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        paddingLeft: 10,
                      }}
                    >
                      流股颜色
                    </Button>
                  </ColorPicker>
                </div>
                <div>
                  <ColorPicker
                    onChange={(color) => {
                      changeTextColor(color.toHexString());
                    }}
                  >
                    <Button
                      type="text"
                      style={{
                        width: 150,
                        height: 30,
                        borderRadius: 0,
                        fontSize: 12,
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        paddingLeft: 10,
                      }}
                    >
                      文字颜色
                    </Button>
                  </ColorPicker>
                </div>
                <Button
                  onClick={() => {
                    changeLineWidth(1.5);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  增大线宽
                </Button>
                <Button
                  onClick={() => {
                    changeLineWidth(0.5);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  减小线宽
                </Button>
                <Button
                  onClick={() => {
                    changeFontSize(1);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  增大文字尺寸
                </Button>
                <Button
                  onClick={() => {
                    changeFontSize(-1);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  减小文字尺寸
                </Button>
                <Button
                  onClick={() => {
                    changeArrowScale(1.5);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  增大箭头
                </Button>
                <Button
                  onClick={() => {
                    changeArrowScale(0.5);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  减小箭头
                </Button>

                {/* 此处不知道有什么用，但是先注释掉留着 */}
                {/* <div className="ctubeT">更改管道：</div>
              {Object.keys(tubeColorSet).map((item: string, index: number) => {
                return (
                  <div
                    className="s_item"
                    onClick={() =>
                      diagramInstance.current &&
                      changeTube(diagramInstance.current, curTube, item)
                    }
                  >
                    {item}
                  </div>
                )
              })} */}
              </div>
            )}
            {!isLinkSelected && !settings.readonly && (
              <div
                className="changeTubeType"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  background: "#FFF",
                  border: "1px solid #BBB",
                }}
              >
                <div>
                  <ColorPicker
                    onChange={(color) => {
                      changeTextBackground(color.toHexString());
                    }}
                  >
                    <Button
                      type="text"
                      style={{
                        width: 150,
                        height: 30,
                        borderRadius: 0,
                        fontSize: 12,
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        paddingLeft: 10,
                      }}
                    >
                      文字背景色
                    </Button>
                  </ColorPicker>
                </div>
                <div>
                  <ColorPicker
                    onChange={(color) => {
                      changeTextColor(color.toHexString());
                    }}
                  >
                    <Button
                      type="text"
                      style={{
                        width: 150,
                        height: 30,
                        borderRadius: 0,
                        fontSize: 12,
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        paddingLeft: 10,
                      }}
                    >
                      文字颜色
                    </Button>
                  </ColorPicker>
                </div>
                <Button
                  onClick={() => {
                    changeFontSize(4);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  增大文字尺寸
                </Button>
                <Button
                  onClick={() => {
                    changeFontSize(-4);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  减小文字尺寸
                </Button>
                <Button
                  onClick={() => {
                    changePoint(0, -0.1);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  文字上移
                </Button>
                <Button
                  onClick={() => {
                    changePoint(0, 0.1);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  文字下移
                </Button>
                <Button
                  onClick={() => {
                    changePoint(-0.1, 0);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  文字左移
                </Button>
                <Button
                  onClick={() => {
                    changePoint(0.1, 0);
                  }}
                  type="text"
                  style={{
                    width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 12,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  文字右移
                </Button>
              </div>
            )}
            {!isLinkSelected && settings.readonly && (
              <div
                className="changeTubeType"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  // width:200,
                  background: "#FFF",
                  border: "1px solid #BBB",
                }}
              >
                <Button
                  onClick={() => {
                    const diagram = diagramInstance.current;
                    if (!diagram) return;
                    const selected = diagram.selection.first();
                    if (!selected) return;

                    if (selected instanceof go.Node) {
                      const nodeData = selected.data;
                      setRunPartTaskByDiagram(nodeData);
                    }
                    // 关闭右键菜单
                    if (menuRef.current) {
                      menuRef.current.style.display = "none";
                    }
                  }}
                  type="text"
                  style={{
                    // width: 150,
                    height: 30,
                    borderRadius: 0,
                    fontSize: 16,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    paddingLeft: 10,
                  }}
                >
                  <PlayCircleOutlined style={{ marginRight: 5 }} />
                  运行单元操作
                </Button>
                {selectedItem.job_id ? (
                  <Button
                    onClick={async (e) => {
                      e.stopPropagation();
                      const diagram = diagramInstance.current;
                      if (!diagram) return;
                      const selected = diagram.selection.first();
                      if (!(selected instanceof go.Node)) return;
                      const data = selected.data;

                      const token = userInfo.access_token;

                      let res = await getSubJobs(
                        { job_id: selectedItem.job_id, name: data.nodeName },
                        token,
                      );
                      if (res.status === 200) {
                        //接口按 job_id 返回该任务下所有单元操作记录，需再按元件名过滤（与任务树「查看单元操作结果」一致）
                        setSubJobs(res.data.filter((i: any) => i.name === data.nodeName));
                        setPopupInfo({ visible: true, x: e.clientX + 78, y: e.clientY });
                        setPopupStyle({
                          position: "fixed",
                          left: e.clientX - 20,
                          top: e.clientY,
                        });
                      } else {
                        messageApi.open({
                          type: "error",
                          content: `计算任务查询失败：${res.status}`,
                        });
                      }

                      // 关闭菜单
                      if (menuRef.current) {
                        menuRef.current.style.display = "none";
                      }
                    }}
                    type="text"
                    style={{
                      height: 30,
                      borderRadius: 0,
                      fontSize: 16,
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      paddingLeft: 10,
                    }}
                  >
                    <EyeOutlined style={{ marginRight: 5 }} />
                    查看单元操作结果
                  </Button>
                ) : null}
                {selectedItem.job_id ? (
                  <Button
                    onClick={() => {
                      setOpenImportPage();
                    }}
                    type="text"
                    style={{
                      height: 30,
                      borderRadius: 0,
                      fontSize: 16,
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      paddingLeft: 10,
                    }}
                  >
                    <ImportOutlined style={{ marginRight: 5 }} />
                    导入单元操作数据
                  </Button>
                ) : null}
              </div>
            )}
          </li>
        </ul>
      </div>

      {/* <style>{`
        .rc-dialog-wrap
        {
          pointer-events: none !important;
        }
        .custom-dialog .rc-dialog-section 
        {
          border-radius: 0 !important;
          padding: 0 !important;
          border: 1px solid #BBB !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        }
        .rc-dialog-body
        {
          pointer-events: auto !important;
          padding: 0 !important;
        }
      `}
      </style>
      <Dialog
        className="custom-dialog"
        closable={false}
        footer={null}
        width={designVisible?460+100+300:460+300}
        visible={modalVisible}
        mask={false}
        maskClosable={false}
        onClose={() =>{}}
        zIndex={500}
        style={{
          position: 'fixed',
          right:0,
          bottom:0,
          // left:'auto',
          // top:'auto',
          transform:'none',
          transition: 'transform 0.15s ease',
        }}
        modalRender={modal => 
          modal ? (
            <Draggable handle=".dialog-header" position={dragPos} onDrag={handleDrag} {...({} as any)}>
              {modal}
            </Draggable>
          ) : null
        }
      >
        <div>
          <div className="dialog-header" style={{display:"flex",alignItems: "center",justifyContent:"space-between",height:40,paddingLeft:30,fontSize:20,fontWeight:"bold",color:"#1b6ae7", cursor: 'move',background:"#EEE",borderBottom:"1px solid #BBB"}}>
            {`${selectElement}参数信息`}
            <div style={{marginRight:20}}>
              <button
                onClick={()=>{setFastVisible(true);}}
                style={{width:70,height:23,border:"1px solid #BBB",backgroundColor:"#FFF",fontSize:12,color:"#BBB"}}
              >快捷输入</button>

              {settings.readonly ?(
                <button
                  onClick={()=>{setOpenImportPage();}}
                  style={{width:25,height:25,border:0,backgroundColor:"transparent"}}
                >
                  <ImportIcon />
                </button>
              ):null}
              
              <button
                onClick={() => {
                  {
                    setModalVisible(false);
                    setIsNowNeedOpenPramDrawer(false);
                    setDialogSelectButton(null);
                    setModalParams(null);
                    setModal2Data(null);
                    setMaterialsData(null);
                    setLocalParamValues({});
                    setLocalFormData({});
                    setLocalMaterialsData({});
                    setClearSelectVariable();
                    setElementPage(null);

                    //因为树没有取消选中状态，所以点取消按钮也不清除高亮
                    //依然保留取消高亮吧
                    const diagram = diagramInstance.current;
                    if (diagram) 
                    {
                      const allLinks = diagram.model["linkDataArray"];
                      allLinks.forEach((link: any) => {
                        changeLinkBackground(link, "transparent");
                      });

                      const allNodes = diagram.model.nodeDataArray.filter(item => !item.isGroup);

                      let taskNodes = null;
                      if(taskListRef.current)
                      {
                        let jobId = selectedItemRef.current.job_id;
                        let taskData = taskListRef.current.find(item=>item.job_id===jobId);
                        if(taskData)
                        {
                          if(taskData.elements.length>0)
                          {
                            taskNodes = (taskData.elements.map(obj => obj["children"])).flat();
                            taskNodes = taskNodes.map(obj => obj["data"]);
                          }
                        }
                      }

                      allNodes.forEach((selectNode: any) => 
                      {
                        let newIcon = selectNode.icon;
                        if(newIcon.includes("high"))
                        {
                          newIcon = newIcon.replace("high","origin");
                        }

                        if(taskNodes)
                        {
                          let taskSelectNode = taskNodes.find(item=>item.nodeName===selectNode.nodeName);
                          if(taskSelectNode)
                          {
                            if(newIcon.includes("origin") && taskSelectNode.isRun)
                            {
                              newIcon = newIcon.replace("origin","green");
                            }
                          }
                        }

                        changeNodeIcon(selectNode,newIcon);
                      });
                    }
                  }
                }}
                style={{width:25,height:25,border:0,color:"#888",backgroundColor:"transparent",fontSize:14}}
              >
                <CloseOutlined />
              </button>

            </div>
          </div>
          
          <div>
            {selectedItem && selectedItem.type==="element" && taskList ?(
              <div>
                <div style={{display:"flex",flexDirection:"row",alignItems: "center",marginLeft:30,marginTop:20}}>
                  <Dropdown dropdownRender={()=>(
                    <div style={{backgroundColor:"#FFF",border:"1px solid #EEE",boxShadow:"0 4px 12px rgba(0, 0, 0, 0.15)",borderRadius:5}}>
                      <div style={{display:"flex",flexDirection:"row",flexWrap: "wrap",gap:10,alignItems: "center",minHeight:30,maxWidth:370,border:"0px solid #BBB",borderRadius:5,padding:10}}>
                        <div style={{minWidth:80,minHeight:30,display:"flex",alignItems: "center",fontSize:14,color:"#000"}}>进料流股：</div>
                        {taskList && (taskList.find(item=>item.job_id===selectedItem.job_id).input.elements.find(item=>item.name==selectedItem.item_name)) ?(
                            taskList.find(item=>item.job_id===selectedItem.job_id).input.elements.find(item=>item.name==selectedItem.item_name).inputStreams.map((item) => (
                              <button
                                onClick={() =>
                                {
                                  let node = taskList.find(item0=>item0.job_id===selectedItem.job_id).streams.find(item0=>item0.name==item.name).data;
                                  let diagram = diagramInstance.current;
                                  doubleClickEvent(node,diagram);

                                  let jobId = selectedItemRef.current.job_id;
                                  let taskData = taskListRef.current.find(item0=>item0.job_id===jobId);
                                  let linkData = taskData.streams.find(item0=>item0.name==node.linkName);

                                  //更改选中的树
                                  setSelectedNode
                                  ({
                                      "type":"stream",
                                      "job_id":jobId,
                                      "job_name":selectedItemRef.current.job_name,
                                      "item_name":linkData.name,
                                      "path":[selectedItemRef.current.job_name,"流股",linkData.name],
                                      "data":linkData.data
                                  });
                                  setSearchElementName({ name: linkData.name, type: "link" });
                                }}
                                style=
                                {{
                                  minWidth:80,
                                  minHeight:30,
                                  border:"1px solid #BBB",
                                  borderRadius: 5,
                                  background:"#FFF",
                                  color:"#888",
                                  fontSize: 14
                                }}
                              >
                                {item.name}
                              </button>
                            ))
                        ):null}
                      </div>

                      <div style={{display:"flex",flexDirection:"row",flexWrap: "wrap",gap:10,alignItems: "center",minHeight:30,maxWidth:370,border:"0px solid #BBB",borderRadius:5,padding:10}}>
                        <div style={{minWidth:80,minHeight:30,display:"flex",alignItems: "center",fontSize:14,color:"#000"}}>出料流股：</div>
                        {taskList && (taskList.find(item=>item.job_id===selectedItem.job_id).input.elements.find(item=>item.name==selectedItem.item_name)) ?(
                            taskList.find(item=>item.job_id===selectedItem.job_id).input.elements.find(item=>item.name==selectedItem.item_name).outputStreams.map((item) => (
                              <button
                                onClick={() =>
                                {
                                  let node = taskList.find(item0=>item0.job_id===selectedItem.job_id).streams.find(item0=>item0.name==item.name).data;
                                  let diagram = diagramInstance.current;
                                  doubleClickEvent(node,diagram);

                                  let jobId = selectedItemRef.current.job_id;
                                  let taskData = taskListRef.current.find(item0=>item0.job_id===jobId);
                                  let linkData = taskData.streams.find(item0=>item0.name==node.linkName);

                                  //更改选中的树
                                  setSelectedNode
                                  ({
                                      "type":"stream",
                                      "job_id":jobId,
                                      "job_name":selectedItemRef.current.job_name,
                                      "item_name":linkData.name,
                                      "path":[selectedItemRef.current.job_name,"流股",linkData.name],
                                      "data":linkData.data
                                  });
                                  setSearchElementName({ name: linkData.name, type: "link" });
                                }}
                                style={{
                                  minWidth:80,
                                  minHeight:30,
                                  border:"1px solid #BBB",
                                  borderRadius: 5,
                                  background:"#FFF",
                                  color:"#888",
                                  fontSize: 14,
                                }}
                              >
                                {item.name}
                              </button>
                            ))
                        ):null}
                      </div>
                    </div>
                  )} trigger={["hover"]} arrow placement="bottomLeft">
                    <button
                      // onClick={() => {setDialogSelectButton("相关流股");}}
                      style={{
                        width:80,
                        height:30,
                        // border:dialogSelectButton==="相关流股"?"0px":"1px solid #BBB",
                        border:"1px solid #BBB",
                        borderRadius: 5,
                        // background:dialogSelectButton==="相关流股"?"#1b6ae7":"#FFF",
                        // color:dialogSelectButton==="相关流股"?"#FFF":"#888",
                        background:"#FFF",
                        color:"#888",
                        fontSize: 14,
                        marginLeft:0,
                      }}
                    >
                      相关流股
                    </button>
                  </Dropdown>
                </div>
              </div>
            ):null}
            {selectedItem && selectedItem.type==="stream" && taskList ?(
              <div>
                <div style={{display:"flex",flexDirection:"row",alignItems: "center",marginLeft:30,marginTop:20}}>
                  <Dropdown dropdownRender={()=>(
                    <div style={{backgroundColor:"#FFF",border:"1px solid #EEE",boxShadow:"0 4px 12px rgba(0, 0, 0, 0.15)",borderRadius:5}}>
                      <div style={{display:"flex",flexDirection:"row",flexWrap: "wrap",gap:10,alignItems: "center",minHeight:30,maxWidth:370,border:"0px solid #BBB",borderRadius:5,padding:10}}>
                        <div style={{minWidth:80,minHeight:30,display:"flex",alignItems: "center",fontSize:14,color:"#000"}}>来源设备：</div>
                        {taskList?(
                            ((taskList.find(item=>item.job_id===selectedItem.job_id).elements).map(obj => obj["children"])).flat().filter(item=>item.data.key === (taskList.find(item=>item.job_id===selectedItem.job_id).streams.find(item=>item.name==selectedItem.item_name).data.from) ).map((item) => (
                              <button
                                onClick={() =>
                                {
                                  let nodeType = item.data.type;
                                  let node = item.data;
                                  let diagram = diagramInstance.current;
                                  doubleClickEvent(node,diagram);

                                  let jobId = selectedItemRef.current.job_id;
                                  let taskData = taskListRef.current.find(item0=>item0.job_id===jobId);
                                  let nodeData = item;

                                  //更改选中的树
                                  setSelectedNode
                                  ({
                                      "type":"element",
                                      "job_id":jobId,
                                      "job_name":selectedItemRef.current.job_name,
                                      "category":typeMap3[nodeData.data.type],
                                      "item_name":nodeData.name,
                                      "path":[selectedItemRef.current.job_name,"单元操作",typeMap3[nodeData.data.type],nodeData.name],
                                      "data":nodeData.data
                                  });
                                  setSearchElementName({ name: nodeData.name, type: "node" });
                                }}
                                style={{
                                  minWidth:80,
                                  minHeight:30,
                                  border:"1px solid #BBB",
                                  borderRadius: 5,
                                  background:"#FFF",
                                  color:"#888",
                                  fontSize: 14
                                }}
                              >
                                {item.name}
                              </button>
                            ))
                        ):null}
                      </div>

                      <div style={{display:"flex",flexDirection:"row",flexWrap: "wrap",gap:10,alignItems: "center",minHeight:30,maxWidth:370,border:"0px solid #BBB",borderRadius:5,padding:10}}>
                        <div style={{minWidth:80,minHeight:30,display:"flex",alignItems: "center",fontSize:14,color:"#000"}}>流向设备：</div>
                        {taskList?(
                            ((taskList.find(item=>item.job_id===selectedItem.job_id).elements).map(obj => obj["children"])).flat().filter(item=>item.data.key === (taskList.find(item=>item.job_id===selectedItem.job_id).streams.find(item=>item.name==selectedItem.item_name).data.to) ).map((item) => (
                              <button
                                onClick={() =>
                                {
                                  let nodeType = item.data.type;
                                  let node = item.data;
                                  let diagram = diagramInstance.current;
                                  doubleClickEvent(node,diagram);

                                  let jobId = selectedItemRef.current.job_id;
                                  let taskData = taskListRef.current.find(item0=>item0.job_id===jobId);
                                  let nodeData = item;

                                  //更改选中的树
                                  setSelectedNode
                                  ({
                                      "type":"element",
                                      "job_id":jobId,
                                      "job_name":selectedItemRef.current.job_name,
                                      "category":typeMap3[nodeData.data.type],
                                      "item_name":nodeData.name,
                                      "path":[selectedItemRef.current.job_name,"单元操作",typeMap3[nodeData.data.type],nodeData.name],
                                      "data":nodeData.data
                                  });
                                  setSearchElementName({ name: nodeData.name, type: "node" });
                                }}
                                style={{
                                  minWidth:80,
                                  minHeight:30,
                                  border:"1px solid #BBB",
                                  borderRadius: 5,
                                  background:"#FFF",
                                  color:"#888",
                                  fontSize: 14
                                }}
                              >
                                {item.name}
                              </button>
                            ))
                        ):null}
                      </div>
                    </div>
                  )} trigger={["hover"]} arrow placement="bottomLeft">
                    <button
                      // onClick={() => {setDialogSelectButton("相关设备");}}
                      style={{
                        width:80,
                        height:30,
                        // border:dialogSelectButton==="相关设备"?"0px":"1px solid #BBB",
                        border:"1px solid #BBB",
                        borderRadius: 5,
                        // background:dialogSelectButton==="相关设备"?"#1b6ae7":"#FFF",
                        // color:dialogSelectButton==="相关设备"?"#FFF":"#888",
                        background:"#FFF",
                        color:"#888",
                        fontSize: 14,
                        marginLeft:0,
                      }}
                    >
                      相关设备
                    </button>
                  </Dropdown>
                </div>
              </div>
            ):null}
          </div>

          <div style={{paddingLeft:20,paddingRight:20,paddingBottom:20,}}>
            <ParameterEditor
              localFormData={localFormData}
              setLocalFormData={setLocalFormData}
              modalParams={modalParams}
              localParamValues={localParamValues}
              setLocalParamValues={setLocalParamValues}
              materialsData={materialsData}
              localMaterialsData={localMaterialsData}
              setLocalMaterialsData={setLocalMaterialsData}
              globalData={globalData}
              selectElement={selectElement}
              maxHeight={designVisible?400+200:400}
              designVisible={designVisible}
              fastModalVariable={fastVisible}
              closeFastModal={() => {setFastVisible(false);}}
              saveAbled={(newSaveAbled) => {setSaveAbled(newSaveAbled);}}
              readonly={settings.readonly}
              isShowDescription={true}
              elementPage={elementPage}

              confirm={()=>{paramsDrawerConfirm();}}
              cancel={()=>{paramsDrawerCancel();}}
            />
          </div>
          <div style={{ height: 32,marginTop:10 }}>
            {(designVisible?(
              <div style={{marginLeft:20,color:"#9e9e9e",fontSize:12}}>
                <WarningOutlined style={{marginRight:5,color:"orange"}}/>
                提示：第一个输入框为计算值，第二个输入框为设计值
              </div>
            ):null)}
            <button
              onClick={() => {
                {
                  setModalVisible(false);
                  setIsNowNeedOpenPramDrawer(false);
                  setDialogSelectButton(null);
                  setModalParams(null);
                  setModal2Data(null);
                  setMaterialsData(null);
                  setLocalParamValues({});
                  setLocalFormData({});
                  setLocalMaterialsData({});
                  setClearSelectVariable();
                  setElementPage(null);
                  
                  //因为树没有取消选中状态，所以点取消按钮也不清除高亮
                  //依然保留取消高亮吧
                  const diagram = diagramInstance.current;
                  if (diagram) 
                  {
                    const allLinks = diagram.model["linkDataArray"];
                    allLinks.forEach((link: any) => {
                      changeLinkBackground(link, "transparent");
                    });

                    const allNodes = diagram.model.nodeDataArray.filter(item => !item.isGroup);

                    let taskNodes = null;
                    if(taskListRef.current)
                    {
                      let jobId = selectedItemRef.current.job_id;
                      let taskData = taskListRef.current.find(item=>item.job_id===jobId);
                      if(taskData)
                      {
                        if(taskData.elements.length>0)
                        {
                          taskNodes = (taskData.elements.map(obj => obj["children"])).flat();
                          taskNodes = taskNodes.map(obj => obj["data"]);
                        }
                      }
                    }

                    allNodes.forEach((selectNode: any) => 
                    {
                      let newIcon = selectNode.icon;
                      if(newIcon.includes("high"))
                      {
                        newIcon = newIcon.replace("high","origin");
                      }

                      if(taskNodes)
                      {
                        let taskSelectNode = taskNodes.find(item=>item.nodeName===selectNode.nodeName);
                        if(taskSelectNode)
                        {
                          if(newIcon.includes("origin") && taskSelectNode.isRun)
                          {
                            newIcon = newIcon.replace("origin","green");
                          }
                        }
                      }

                      changeNodeIcon(selectNode,newIcon);
                    });
                  }
                }
              }}
              style={{
                position: "absolute",
                right: 25,
                bottom: 10,
                width: 88,
                height: 32,
                border: 0,
                borderRadius: 5,
                background: "#FF4D4F",
                color: "#FFF",
                fontSize: 14,
              }}
            >
              取消
            </button>

            <button
              onClick={async () => {
                if(saveAbled)
                {
                  let selectedPart = diagramInstance.current.selection.first();
                  let partData;
                  if(!selectedPart && openNode)
                  {
                    let diagram = diagramInstance.current;
                    let dataArrays = diagram.model[openNode.nodeName?"nodeDataArray":"linkDataArray"];
                    partData = dataArrays.find(item=>item.key===openNode.key)
                  }
                  else
                  {
                    partData = selectedPart.data;
                  }

                  let localKey = partData.key;
                  let localType = partData.type??"";
                  if (localFormData["元件名称"] && localFormData["元件名称"].value !== "") {
                    if (!checkNameUnique(localFormData["元件名称"].value, "node", partData.key)) {
                      messageApi.open({
                        type: "error",
                        content: "元件名称重复",
                      });
                    } 
                    else 
                    {
                      await saveParams();
                      await saveField();

                      const diagram = diagramInstance.current;

                      //因为树没有取消选中状态，所以点保存按钮也不清除高亮
                      //依然保留取消高亮吧
                      if (diagram) 
                      {
                        const allLinks = diagram.model["linkDataArray"];
                        allLinks.forEach((link: any) => {
                          changeLinkBackground(link, "transparent");
                        });

                        let taskNodes = null;
                        if(taskListRef.current)
                        {
                          let jobId = selectedItemRef.current.job_id;
                          let taskData = taskListRef.current.find(item=>item.job_id===jobId);
                          if(taskData)
                          {
                            if(taskData.elements.length>0)
                            {
                              taskNodes = (taskData.elements.map(obj => obj["children"])).flat();
                              taskNodes = taskNodes.map(obj => obj["data"]);
                            }
                          }
                        }

                        const allNodes = diagram.model.nodeDataArray.filter(item => !item.isGroup);
                        allNodes.forEach((selectNode: any) => 
                        {
                          let newIcon = selectNode.icon;
                          if(newIcon.includes("high"))
                          {
                            newIcon = newIcon.replace("high","origin");
                          }
                          if(taskNodes)
                          {
                            let taskSelectNode = taskNodes.find(item=>item.nodeName===selectNode.nodeName);
                            if(taskSelectNode)
                            {
                              if(newIcon.includes("origin") && taskSelectNode.isRun)
                              {
                                newIcon = newIcon.replace("origin","green");
                              }
                            }
                          }
                          changeNodeIcon(selectNode,newIcon);
                        });
                      }

                      //将新值传给树
                      const newNodes = diagram.model["nodeDataArray"];
                      let newNode = newNodes.find(item=>item.key===localKey);
                      if(newNode)
                      {
                        upTreeData(newNode,"node",localType);
                      }

                      setClearSelectVariable();

                      //保存流程图数据
                      setTimeout(() => 
                      {
                        saveDiagram();
                      }, 200);
                    }
                  } 
                  else if (localFormData["流股名称"] && localFormData["流股名称"].value !== "") 
                  {
                    if (!checkNameUnique(localFormData["流股名称"].value, "link", partData.key)) 
                    {
                      messageApi.open({
                        type: "error",
                        content: "流股名称重复",
                      });
                    } 
                    else 
                    {
                      await saveParams();
                      await saveMaterials();
                      await saveField();

                      const diagram = diagramInstance.current;

                      //因为树没有取消选中状态，所以点保存按钮也不清除高亮
                      //依然保留取消高亮吧
                      if (diagram) 
                      {
                        //取消高亮
                        const allLinks = diagram.model["linkDataArray"];
                        allLinks.forEach((link: any) => {
                          changeLinkBackground(link, "transparent");
                        });

                        let taskNodes = null;
                        if(taskListRef.current)
                        {
                          let jobId = selectedItemRef.current.job_id;
                          let taskData = taskListRef.current.find(item=>item.job_id===jobId);
                          if(taskData)
                          {
                            if(taskData.elements.length>0)
                            {
                              taskNodes = (taskData.elements.map(obj => obj["children"])).flat();
                              taskNodes = taskNodes.map(obj => obj["data"]);
                            }
                          }
                        }

                        const allNodes = diagram.model.nodeDataArray.filter(item => !item.isGroup);
                        allNodes.forEach((selectNode: any) => 
                        {
                          let newIcon = selectNode.icon;
                          if(newIcon.includes("high"))
                          {
                            newIcon = newIcon.replace("high","origin");
                          }

                          if(taskNodes)
                          {
                            let taskSelectNode = taskNodes.find(item=>item.nodeName===selectNode.nodeName);
                            if(taskSelectNode)
                            {
                              if(newIcon.includes("origin") && taskSelectNode.isRun)
                              {
                                newIcon = newIcon.replace("origin","green");
                              }
                            }
                          }
                          changeNodeIcon(selectNode,newIcon);
                        });

                        //判断是否修改连接线颜色
                        // const selectedPart = diagramInstance.current.selection.first();
                        if(partData["ParamValues"]?.["流股属性"].value==="冷流股")
                        {
                          changeLineColor("#0000FF");
                        }
                        else if(partData["ParamValues"]?.["流股属性"].value==="热流股")
                        {
                          changeLineColor("#FF0000");
                        }
                        else if(partData["ParamValues"]?.["流股属性"].value==="无")
                        {
                          changeLineColor("#000");
                        }
                      }

                      //将新值传给树
                      const newLinks = diagram.model["linkDataArray"];
                      let newLink = newLinks.find(item=>item.key===localKey);
                      if(newLink)
                      {
                        upTreeData(newLink,"link",localType);
                      }

                      setClearSelectVariable();

                      //保存流程图数据
                      setTimeout(() => 
                      {
                        saveDiagram();
                      }, 200);
                    }
                  } 
                  else 
                  {
                    if(localType==="comments")
                    {
                      await saveParams();

                      //保存流程图数据
                      setTimeout(() => 
                      {
                        saveDiagram();
                      }, 200);
                    }
                    else
                    {
                      if(partData.isGroup)
                      {
                        if (localFormData["分组名称"] && localFormData["分组名称"].value !== "") 
                        {
                          if (!checkNameUnique(localFormData["分组名称"].value, "group", partData.key)) 
                          {
                            messageApi.open({
                              type: "error",
                              content: "分组名称重复",
                            });
                          }
                          else
                          {
                            // //更新分组按钮（如名称）
                            // let newGroups = groups;
                            // newGroups.splice(newGroups.findIndex(item => item.key === partData.key), 1, partData);
                            // setGroups(newGroups);

                            //保存分组
                            await saveParams();
                            await saveField();

                            //保存流程图数据
                            setTimeout(() => 
                            {
                              saveDiagram();
                            }, 200);
                          }
                        }
                        else
                        {
                          messageApi.open({
                            type: "error",
                            content: "请填写分组名称",
                          });
                        }
                      }
                      else
                      {
                        messageApi.open({
                          type: "error",
                          // content: "请填写元件/流股名称",
                          content: "请填写名称",
                        });
                      }
                    }
                  }
                }
                else
                {
                  messageApi.open
                  ({
                    type:"error",
                    content:"保存失败：数据非法",
                  });
                }
              }}
              style={{
                position: "absolute",
                right: 138,
                bottom: 10,
                width: 88,
                height: 32,
                border: 0,
                borderRadius: 5,
                background: "#1b6ae7",
                color: "#FFF",
                fontSize: 14,
              }}
            >
              保存
            </button>

            <button
              onClick={async () =>
              {
                let elementName = null;
                let elementType = null;
                if (localFormData["元件名称"])
                {
                  if(localFormData["元件名称"].value==="")
                  {
                    messageApi.open
                    ({
                      type:"error",
                      content:"请填写元件名称",
                    });
                    return;
                  }
                  else
                  {
                    elementName = localFormData["元件名称"].value;
                    elementType = "elements";
                  }
                }
                else if(localFormData["流股名称"])
                {
                  if(localFormData["流股名称"].value==="")
                  {
                    messageApi.open
                    ({
                      type:"error",
                      content:"请填写流股名称",
                    });
                    return;
                  }
                  else
                  {
                    elementName = localFormData["流股名称"].value;
                    elementType = "streams";
                  }
                }

                if(elementName && elementType)
                {
                  await buildDefaultValues(elementName,elementType);
                  return;
                }
                else 
                {
                  messageApi.open
                  ({
                    type:"error",
                    content:"数据有误",
                  });
                  return;
                }
              }}
              style={{
                position: "absolute",
                right: 251,
                bottom: 10,
                width: 88,
                height: 32,
                border: 0,
                borderRadius: 5,
                background: "#1b6ae7",
                color: "#FFF",
                fontSize: 14,
              }}
            >
              默认值
            </button>

          </div>
        </div>
      </Dialog> */}

      {/* 编辑参数抽屉 */}
      <Drawer
        open={modalVisible}
        onOpenChange={paramsDrawerCancel}
        title={null}
        width={taskListVariable ? `calc(100vw - ${taskListWidth}px)` : "100vw"}
        children={
          <ParameterEditor
            localFormData={localFormData}
            setLocalFormData={setLocalFormData}
            modalParams={modalParams}
            localParamValues={localParamValues}
            setLocalParamValues={setLocalParamValues}
            materialsData={materialsData}
            localMaterialsData={localMaterialsData}
            setLocalMaterialsData={setLocalMaterialsData}
            globalData={globalData}
            selectElement={selectElement}
            maxHeight={pageHeight}
            designVisible={designVisible}
            fastModalVariable={fastVisible}
            closeFastModal={() => {
              setFastVisible(false);
            }}
            saveAbled={(newSaveAbled) => {
              setSaveAbled(newSaveAbled);
            }}
            readonly={settings.readonly}
            isShowDescription={true}
            elementPage={elementPage}
            selectedElementData={selectedElementData}
            diagramInstance={diagramInstance.current}
            confirm={(oldParams) => {
              paramsDrawerConfirm(oldParams);
            }}
            cancel={() => {
              paramsDrawerCancel();
            }}
            changeOtherElement={(element) => {
              if (element.data) {
                const diagram = diagramInstance.current;
                if (diagram) {
                  // 1. 选中流程图中的图元（已实现）
                  let part = null;
                  if (element.data.nodeName !== undefined) {
                    part = diagram.findNodeForData(element.data);
                  } else if (element.data.linkName !== undefined) {
                    part = diagram.findLinkForData(element.data);
                  }
                  if (part) {
                    diagram.clearSelection();
                    diagram.select(part);
                  }

                  // 2. 模拟双击事件中的树选中逻辑
                  //    这里需要根据您当前是编辑模式还是只读模式，以及数据来源调整。
                  //    以下示例参考只读模式（从 taskList 中查找数据）：
                  if (taskListRef.current && selectedItemRef.current?.job_id) {
                    const jobId = selectedItemRef.current.job_id;
                    const taskData = taskListRef.current.find((item) => item.job_id === jobId);
                    if (taskData) {
                      if (element.data.nodeName !== undefined) {
                        // 查找该元件在 taskData 中的信息
                        const nodeType = element.data.type;
                        const nodeDatas = taskData.elements.find(
                          (item) => item.engName === nodeType,
                        )?.children;
                        if (nodeDatas) {
                          const nodeData = nodeDatas.find(
                            (item) => item.name === element.data.nodeName,
                          );
                          if (nodeData) {
                            setSelectedNode({
                              type: "element",
                              job_id: jobId,
                              job_name: selectedItemRef.current.job_name,
                              category: typeMap3[nodeData.data.type],
                              item_name: nodeData.name,
                              path: [
                                selectedItemRef.current.job_name,
                                "单元操作",
                                typeMap3[nodeData.data.type],
                                nodeData.name,
                              ],
                              data: nodeData.data,
                            });
                            // 可选：同步搜索框
                            setSearchElementName?.({ name: nodeData.name, type: "node" });
                          }
                        }
                      } else if (element.data.linkName !== undefined) {
                        const linkData = taskData.streams.find(
                          (item) => item.name === element.data.linkName,
                        );
                        if (linkData) {
                          setSelectedNode({
                            type: "stream",
                            job_id: jobId,
                            job_name: selectedItemRef.current.job_name,
                            item_name: linkData.name,
                            path: [selectedItemRef.current.job_name, "流股", linkData.name],
                            data: linkData.data,
                          });
                          setSearchElementName?.({ name: linkData.name, type: "link" });
                        }
                      }
                    }
                  }

                  // 3. 执行原双击效果（高亮、打开弹窗）
                  doubleClickEvent(element.data, diagram, true);
                }
              }
            }}
          />
        }
      />

      {popupInfo.visible && (
        <div
          className="click-popup-overlay"
          onClick={() => setPopupInfo({ visible: false, x: 0, y: 0 })}
        >
          <div
            ref={popupRef}
            className="click-popup-content"
            style={popupStyle}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="click-popup-header">
              <span>单元计算结果：</span>
              <button
                className="click-popup-close"
                onClick={() => setPopupInfo({ visible: false, x: 0, y: 0 })}
              >
                ×
              </button>
            </div>
            <div className="click-popup-body">
              {subJobs.length ? (
                <ul className="subJobsList">
                  {subJobs.map((i: any, index: number) => {
                    return (
                      <li
                        key={index}
                        onClick={async () => {
                          setSubName(i.name);

                          await setCurResultInfo({
                            id: i.id,
                            type: "subJob",
                          });
                          await setResultDrawOpen(true);

                          //点击后关闭
                          setPopupInfo({ visible: false, x: 0, y: 0 });
                        }}
                      >
                        {/* <span style={{backgroundColor:`${statusColor[i.status]}`}}>{index + 1}</span> */}
                        <b
                          style={{
                            color: `${i.is_converged === false ? statusColor.uncovered : statusColor[i.status]}`,
                          }}
                        >
                          {dayjs(i.created_at).add(8, "hours").format("YYYY-MM-DD HH:mm:ss")}
                        </b>
                        <i className={i.status}>{showSubJobIcon(i.status, i.is_converged)}</i>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <p>此单元没有计算结果。</p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Component;
